"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementFields = exports.SettlementItemFields = exports.CommerceOrderFields = exports.ClientVersions = exports.ClientVersionsFields = exports.ChatRoom = exports.JobOfferResponseFields = exports.ChannelUserUsage = exports.ChannelUserUsageFields = exports.ChannelExpert = exports.ChannelExpertFields = exports.ChannelDictionary = exports.ChannelDictionaryFields = exports.ChannelDeviceToken = exports.ChannelDeviceTokenFields = exports.ChannelChatRoomMenu = exports.ChannelChatRoomMenuFields = exports.ChannelBizInfo = exports.ChannelBizInfoFields = exports.Channel = exports.CategoryKeyword = exports.CategoryKeywordFields = exports.Category = exports.CategoryFields = exports.BannedWords = exports.BannedWordsFields = exports.Attachment = exports.ExpertInfoFields = exports.AttachmentFields = exports.Applications = exports.ApplicationsFields = exports.AppInfo = exports.AppInfoFields = exports.AiChatRoom = exports.AiChatMessage = exports.AiChatRoomFields = exports.AiChatMessageFields = exports.Advertiser = exports.Advertisement = exports.AdvertiserFields = exports.AdvertisementFields = exports.AccountInfo = exports.AccountInfoFields = exports.AbusingReport = exports.ReactionFields = exports.ChatRoomFields = exports.ChannelFields = exports.ProfileFields = exports.UserFields = exports.AbusingReportFields = void 0;
exports.LessonFlashcardFields = exports.LessonExamQuestion = exports.LessonExamQuestionFields = exports.LessonExam = exports.LessonSubjectFields = exports.LessonExamFields = exports.LessonCreator = exports.LessonYouTubeUserFields = exports.LessonCreatorFields = exports.JobTransaction = exports.JobTransactionFields = exports.JobReview = exports.JobOutput = exports.JobOutputFields = exports.JobOfferResponse = exports.JobReviewFields = exports.JobOffer = exports.MessageInfoFields = exports.JobOfferFields = exports.HashTag = exports.HashTagFields = exports.Follow = exports.FollowFields = exports.FaQ = exports.FaQFields = exports.ExternalRequest = exports.ExternalRequestFields = exports.ExpertInfo = exports.DynamicLink = exports.DynamicLinkFields = exports.DontShowAgain = exports.DontShowAgainFields = exports.Document = exports.DocumentFields = exports.DeviceToken_Topics = exports.DeviceToken_TopicsFields = exports.DeletedUser = exports.DeletedUserFields = exports.CustomerRelationship = exports.Profile_ChannelFields = exports.CustomerCommunicationLog = exports.CustomerRelationshipFields = exports.CustomerCommunicationLogFields = exports.CommerceProductReview = exports.CommerceProductReviewFields = exports.CommerceProduct = exports.CommerceOrderReview = exports.CommerceOrderReviewFields = exports.CommerceOrder = exports.CommerceProductFields = void 0;
exports.QuotaFields = exports.Profile_ChatRoom = exports.Profile_ChatRoomFields = exports.Profile_ChannelActivity = exports.Profile_ChannelActivityFields = exports.Profile_Channel = exports.ProfileReview = exports.ProfileReviewFields = exports.ProfileInfo = exports.ProfileInfoFields = exports.ProfileChannel_User = exports.ProfileChannel_UserFields = exports.Profile = exports.Product = exports.ProductFields = exports.Plugin = exports.PluginFields = exports.Place = exports.PlaceFields = exports.PaymentStatusHistory = exports.PaymentStatusHistoryFields = exports.PaymentIntent = exports.PaymentIntentFields = exports.PaymentAPIFailureLog = exports.Payment = exports.SubscriptionFields = exports.PaymentAPIFailureLogFields = exports.PaymentFields = exports.MessageTranslation = exports.MessageTranslationFields = exports.MessageInfo = exports.MesgNotification = exports.MesgNotificationFields = exports.LessonYouTubeUser = exports.LessonWatchHistory = exports.LessonWatchHistoryFields = exports.LessonVideo = exports.LessonVideoFields = exports.LessonUser_FlashcardDeck = exports.LessonUser_FlashcardDeckFields = exports.LessonUnit = exports.LessonUnitFields = exports.LessonSubject = exports.LessonKeyword = exports.LessonKeywordFields = exports.LessonItemGroup = exports.LessonItemGroupFields = exports.LessonFlashcardDeck = exports.LessonFlashcardDeckFields = exports.LessonFlashcard = void 0;
exports.UserPointLog = exports.UserPointLogFields = exports.UserPenalty = exports.UserLog = exports.UserLogFields = exports.UserKeyword = exports.UserKeywordFields = exports.UserIdentity = exports.UserIdentityFields = exports.UserChannelAccount = exports.UserChannelAccountFields = exports.UserBlocking = exports.UserBlockingFields = exports.UserAdAction = exports.UserAdActionFields = exports.User = exports.UrlMetadata = exports.UrlMetadataFields = exports.Thumbnail = exports.ThumbnailFields = exports.SysPicture = exports.SysPictureFields = exports.SysNotification = exports.SysNotificationFields = exports.SysNotice = exports.SysNoticeFields = exports.SysInfo = exports.SysInfoFields = exports.SubscriptionHistory = exports.SubscriptionHistoryFields = exports.Subscription = exports.SignInTelVerification = exports.SignInTelVerificationFields = exports.SignIn = exports.SignInFields = exports.SettlementItem = exports.Settlement = exports.ServerError = exports.ServerErrorFields = exports.Secret = exports.SecretFields = exports.SearchWord = exports.SearchWordFields = exports.ReportAction = exports.UserPenaltyFields = exports.ReportActionFields = exports.Reaction = exports.QuotaUsage = exports.QuotaUsageFields = exports.Quota = void 0;
exports.deleteOneAiChatRoom = exports.updateOneAiChatRoom = exports.createOneAiChatRoom = exports.findManyAiChatRoomCount = exports.findManyAiChatRoom = exports.findUniqueAiChatRoom = exports.updateManyAiChatMessage = exports.deleteManyAiChatMessage = exports.deleteOneAiChatMessage = exports.updateOneAiChatMessage = exports.createOneAiChatMessage = exports.findManyAiChatMessageCount = exports.findManyAiChatMessage = exports.findUniqueAiChatMessage = exports.updateManyAdvertiser = exports.deleteManyAdvertiser = exports.deleteOneAdvertiser = exports.updateOneAdvertiser = exports.createOneAdvertiser = exports.findManyAdvertiserCount = exports.findManyAdvertiser = exports.findUniqueAdvertiser = exports.updateManyAdvertisement = exports.deleteManyAdvertisement = exports.deleteOneAdvertisement = exports.updateOneAdvertisement = exports.createOneAdvertisement = exports.findManyAdvertisementCount = exports.findManyAdvertisement = exports.findUniqueAdvertisement = exports.findManyAccountInfoCount = exports.findUniqueAccountInfo = exports.updateManyAbusingReport = exports.deleteManyAbusingReport = exports.deleteOneAbusingReport = exports.updateOneAbusingReport = exports.createOneAbusingReport = exports.findManyAbusingReportCount = exports.findManyAbusingReport = exports.findUniqueAbusingReport = exports.VersionChange = exports.VersionChangeFields = exports.User_Profile = exports.User_ProfileFields = exports.User_ChatRoomView = exports.User_ChatRoomViewFields = exports.UserUsage = exports.UserUsageFields = exports.UserPointWithdrawRequest = exports.UserPointWithdrawRequestFields = void 0;
exports.updateManyCategoryKeyword = exports.deleteManyCategoryKeyword = exports.deleteOneCategoryKeyword = exports.updateOneCategoryKeyword = exports.createOneCategoryKeyword = exports.findManyCategoryKeywordCount = exports.findManyCategoryKeyword = exports.findUniqueCategoryKeyword = exports.updateManyCategory = exports.deleteManyCategory = exports.deleteOneCategory = exports.updateOneCategory = exports.createOneCategory = exports.findManyCategoryCount = exports.findManyCategory = exports.findUniqueCategory = exports.updateManyBannedWords = exports.deleteManyBannedWords = exports.deleteOneBannedWords = exports.updateOneBannedWords = exports.createOneBannedWords = exports.findManyBannedWordsCount = exports.findManyBannedWords = exports.findUniqueBannedWords = exports.updateManyAttachment = exports.deleteManyAttachment = exports.deleteOneAttachment = exports.updateOneAttachment = exports.createOneAttachment = exports.findManyAttachmentCount = exports.findManyAttachment = exports.findUniqueAttachment = exports.updateManyApplications = exports.deleteManyApplications = exports.deleteOneApplications = exports.updateOneApplications = exports.createOneApplications = exports.findManyApplicationsCount = exports.findManyApplications = exports.findUniqueApplications = exports.updateManyAppInfo = exports.deleteManyAppInfo = exports.deleteOneAppInfo = exports.updateOneAppInfo = exports.createOneAppInfo = exports.findManyAppInfoCount = exports.findManyAppInfo = exports.findUniqueAppInfo = exports.updateManyAiChatRoom = exports.deleteManyAiChatRoom = void 0;
exports.findManyChannelUserUsage = exports.findUniqueChannelUserUsage = exports.updateManyChannelExpert = exports.deleteManyChannelExpert = exports.deleteOneChannelExpert = exports.updateOneChannelExpert = exports.createOneChannelExpert = exports.findManyChannelExpertCount = exports.findManyChannelExpert = exports.findUniqueChannelExpert = exports.updateManyChannelDictionary = exports.deleteManyChannelDictionary = exports.deleteOneChannelDictionary = exports.updateOneChannelDictionary = exports.createOneChannelDictionary = exports.findManyChannelDictionaryCount = exports.findManyChannelDictionary = exports.findUniqueChannelDictionary = exports.updateManyChannelDeviceToken = exports.deleteManyChannelDeviceToken = exports.deleteOneChannelDeviceToken = exports.updateOneChannelDeviceToken = exports.createOneChannelDeviceToken = exports.findManyChannelDeviceTokenCount = exports.findManyChannelDeviceToken = exports.findUniqueChannelDeviceToken = exports.updateManyChannelChatRoomMenu = exports.deleteManyChannelChatRoomMenu = exports.deleteOneChannelChatRoomMenu = exports.updateOneChannelChatRoomMenu = exports.createOneChannelChatRoomMenu = exports.findManyChannelChatRoomMenuCount = exports.findManyChannelChatRoomMenu = exports.findUniqueChannelChatRoomMenu = exports.updateManyChannelBizInfo = exports.deleteManyChannelBizInfo = exports.deleteOneChannelBizInfo = exports.updateOneChannelBizInfo = exports.createOneChannelBizInfo = exports.findManyChannelBizInfoCount = exports.findManyChannelBizInfo = exports.findUniqueChannelBizInfo = exports.updateManyChannel = exports.deleteManyChannel = exports.deleteOneChannel = exports.updateOneChannel = exports.createOneChannel = exports.findManyChannelCount = exports.findManyChannel = exports.findUniqueChannel = void 0;
exports.updateOneCommerceProductReview = exports.createOneCommerceProductReview = exports.findManyCommerceProductReviewCount = exports.findManyCommerceProductReview = exports.findUniqueCommerceProductReview = exports.deleteManyCommerceProduct = exports.deleteOneCommerceProduct = exports.updateOneCommerceProduct = exports.createOneCommerceProduct = exports.findManyCommerceProductCount = exports.findManyCommerceProduct = exports.findUniqueCommerceProduct = exports.updateManyCommerceOrderReview = exports.deleteManyCommerceOrderReview = exports.deleteOneCommerceOrderReview = exports.updateOneCommerceOrderReview = exports.createOneCommerceOrderReview = exports.findManyCommerceOrderReviewCount = exports.findManyCommerceOrderReview = exports.findUniqueCommerceOrderReview = exports.updateManyCommerceOrder = exports.deleteManyCommerceOrder = exports.deleteOneCommerceOrder = exports.updateOneCommerceOrder = exports.createOneCommerceOrder = exports.findManyCommerceOrderCount = exports.findManyCommerceOrder = exports.findUniqueCommerceOrder = exports.updateManyClientVersions = exports.deleteManyClientVersions = exports.deleteOneClientVersions = exports.updateOneClientVersions = exports.createOneClientVersions = exports.findManyClientVersionsCount = exports.findManyClientVersions = exports.findUniqueClientVersions = exports.updateManyChatRoom = exports.deleteManyChatRoom = exports.deleteOneChatRoom = exports.updateOneChatRoom = exports.createOneChatRoom = exports.findManyChatRoomCount = exports.findManyChatRoom = exports.findUniqueChatRoom = exports.updateManyChannelUserUsage = exports.deleteManyChannelUserUsage = exports.deleteOneChannelUserUsage = exports.updateOneChannelUserUsage = exports.createOneChannelUserUsage = exports.findManyChannelUserUsageCount = void 0;
exports.deleteManyDontShowAgain = exports.deleteOneDontShowAgain = exports.updateOneDontShowAgain = exports.createOneDontShowAgain = exports.findManyDontShowAgainCount = exports.findManyDontShowAgain = exports.findUniqueDontShowAgain = exports.updateManyDocument = exports.deleteManyDocument = exports.deleteOneDocument = exports.updateOneDocument = exports.createOneDocument = exports.findManyDocumentCount = exports.findManyDocument = exports.findUniqueDocument = exports.updateManyDeviceToken_Topics = exports.deleteManyDeviceToken_Topics = exports.deleteOneDeviceToken_Topics = exports.updateOneDeviceToken_Topics = exports.createOneDeviceToken_Topics = exports.findManyDeviceToken_TopicsCount = exports.findManyDeviceToken_Topics = exports.findUniqueDeviceToken_Topics = exports.updateManyDeletedUser = exports.deleteManyDeletedUser = exports.deleteOneDeletedUser = exports.updateOneDeletedUser = exports.createOneDeletedUser = exports.findManyDeletedUserCount = exports.findManyDeletedUser = exports.findUniqueDeletedUser = exports.updateManyCustomerRelationship = exports.deleteManyCustomerRelationship = exports.deleteOneCustomerRelationship = exports.updateOneCustomerRelationship = exports.createOneCustomerRelationship = exports.findManyCustomerRelationshipCount = exports.findManyCustomerRelationship = exports.findUniqueCustomerRelationship = exports.updateManyCustomerCommunicationLog = exports.deleteManyCustomerCommunicationLog = exports.deleteOneCustomerCommunicationLog = exports.updateOneCustomerCommunicationLog = exports.createOneCustomerCommunicationLog = exports.findManyCustomerCommunicationLogCount = exports.findManyCustomerCommunicationLog = exports.findUniqueCustomerCommunicationLog = exports.updateManyCommerceProductReview = exports.deleteManyCommerceProductReview = exports.deleteOneCommerceProductReview = void 0;
exports.findUniqueJobOffer = exports.updateManyHashTag = exports.deleteManyHashTag = exports.deleteOneHashTag = exports.updateOneHashTag = exports.createOneHashTag = exports.findManyHashTagCount = exports.findManyHashTag = exports.findUniqueHashTag = exports.updateManyFollow = exports.deleteManyFollow = exports.deleteOneFollow = exports.updateOneFollow = exports.createOneFollow = exports.findManyFollowCount = exports.findManyFollow = exports.findUniqueFollow = exports.updateManyFaQ = exports.deleteManyFaQ = exports.deleteOneFaQ = exports.updateOneFaQ = exports.createOneFaQ = exports.findManyFaQCount = exports.findManyFaQ = exports.findUniqueFaQ = exports.updateManyExternalRequest = exports.deleteManyExternalRequest = exports.deleteOneExternalRequest = exports.updateOneExternalRequest = exports.createOneExternalRequest = exports.findManyExternalRequestCount = exports.findManyExternalRequest = exports.findUniqueExternalRequest = exports.updateManyExpertInfo = exports.deleteManyExpertInfo = exports.deleteOneExpertInfo = exports.updateOneExpertInfo = exports.createOneExpertInfo = exports.findManyExpertInfoCount = exports.findManyExpertInfo = exports.findUniqueExpertInfo = exports.updateManyDynamicLink = exports.deleteManyDynamicLink = exports.deleteOneDynamicLink = exports.updateOneDynamicLink = exports.createOneDynamicLink = exports.findManyDynamicLinkCount = exports.findManyDynamicLink = exports.findUniqueDynamicLink = exports.updateManyDontShowAgain = void 0;
exports.updateOneLessonExam = exports.createOneLessonExam = exports.findManyLessonExamCount = exports.findManyLessonExam = exports.findUniqueLessonExam = exports.updateManyLessonCreator = exports.deleteManyLessonCreator = exports.deleteOneLessonCreator = exports.updateOneLessonCreator = exports.createOneLessonCreator = exports.findManyLessonCreatorCount = exports.findManyLessonCreator = exports.findUniqueLessonCreator = exports.updateManyJobTransaction = exports.deleteManyJobTransaction = exports.deleteOneJobTransaction = exports.updateOneJobTransaction = exports.createOneJobTransaction = exports.findManyJobTransactionCount = exports.findManyJobTransaction = exports.findUniqueJobTransaction = exports.updateManyJobReview = exports.deleteManyJobReview = exports.deleteOneJobReview = exports.updateOneJobReview = exports.createOneJobReview = exports.findManyJobReviewCount = exports.findManyJobReview = exports.findUniqueJobReview = exports.updateManyJobOutput = exports.deleteManyJobOutput = exports.deleteOneJobOutput = exports.updateOneJobOutput = exports.createOneJobOutput = exports.findManyJobOutputCount = exports.findManyJobOutput = exports.findUniqueJobOutput = exports.deleteManyJobOfferResponse = exports.deleteOneJobOfferResponse = exports.updateOneJobOfferResponse = exports.findManyJobOfferResponseCount = exports.findManyJobOfferResponse = exports.findUniqueJobOfferResponse = exports.updateManyJobOffer = exports.deleteManyJobOffer = exports.deleteOneJobOffer = exports.updateOneJobOffer = exports.createOneJobOffer = exports.findManyJobOfferCount = exports.findManyJobOffer = void 0;
exports.deleteManyLessonSubject = exports.deleteOneLessonSubject = exports.updateOneLessonSubject = exports.createOneLessonSubject = exports.findManyLessonSubjectCount = exports.findManyLessonSubject = exports.findUniqueLessonSubject = exports.updateManyLessonKeyword = exports.deleteManyLessonKeyword = exports.deleteOneLessonKeyword = exports.updateOneLessonKeyword = exports.createOneLessonKeyword = exports.findManyLessonKeywordCount = exports.findManyLessonKeyword = exports.findUniqueLessonKeyword = exports.updateManyLessonItemGroup = exports.deleteManyLessonItemGroup = exports.deleteOneLessonItemGroup = exports.updateOneLessonItemGroup = exports.createOneLessonItemGroup = exports.findManyLessonItemGroupCount = exports.findManyLessonItemGroup = exports.findUniqueLessonItemGroup = exports.updateManyLessonFlashcardDeck = exports.deleteManyLessonFlashcardDeck = exports.deleteOneLessonFlashcardDeck = exports.updateOneLessonFlashcardDeck = exports.createOneLessonFlashcardDeck = exports.findManyLessonFlashcardDeckCount = exports.findManyLessonFlashcardDeck = exports.findUniqueLessonFlashcardDeck = exports.updateManyLessonFlashcard = exports.deleteManyLessonFlashcard = exports.deleteOneLessonFlashcard = exports.updateOneLessonFlashcard = exports.createOneLessonFlashcard = exports.findManyLessonFlashcardCount = exports.findManyLessonFlashcard = exports.findUniqueLessonFlashcard = exports.updateManyLessonExamQuestion = exports.deleteManyLessonExamQuestion = exports.deleteOneLessonExamQuestion = exports.updateOneLessonExamQuestion = exports.createOneLessonExamQuestion = exports.findManyLessonExamQuestionCount = exports.findManyLessonExamQuestion = exports.findUniqueLessonExamQuestion = exports.updateManyLessonExam = exports.deleteManyLessonExam = exports.deleteOneLessonExam = void 0;
exports.findUniqueMessageInfo = exports.updateManyMesgNotification = exports.deleteManyMesgNotification = exports.deleteOneMesgNotification = exports.updateOneMesgNotification = exports.createOneMesgNotification = exports.findManyMesgNotificationCount = exports.findManyMesgNotification = exports.findUniqueMesgNotification = exports.updateManyLessonYouTubeUser = exports.deleteManyLessonYouTubeUser = exports.deleteOneLessonYouTubeUser = exports.updateOneLessonYouTubeUser = exports.createOneLessonYouTubeUser = exports.findManyLessonYouTubeUserCount = exports.findManyLessonYouTubeUser = exports.findUniqueLessonYouTubeUser = exports.updateManyLessonWatchHistory = exports.deleteManyLessonWatchHistory = exports.deleteOneLessonWatchHistory = exports.updateOneLessonWatchHistory = exports.createOneLessonWatchHistory = exports.findManyLessonWatchHistoryCount = exports.findManyLessonWatchHistory = exports.findUniqueLessonWatchHistory = exports.updateManyLessonVideo = exports.deleteManyLessonVideo = exports.deleteOneLessonVideo = exports.updateOneLessonVideo = exports.createOneLessonVideo = exports.findManyLessonVideoCount = exports.findManyLessonVideo = exports.findUniqueLessonVideo = exports.updateManyLessonUser_FlashcardDeck = exports.deleteManyLessonUser_FlashcardDeck = exports.deleteOneLessonUser_FlashcardDeck = exports.updateOneLessonUser_FlashcardDeck = exports.createOneLessonUser_FlashcardDeck = exports.findManyLessonUser_FlashcardDeckCount = exports.findManyLessonUser_FlashcardDeck = exports.findUniqueLessonUser_FlashcardDeck = exports.updateManyLessonUnit = exports.deleteManyLessonUnit = exports.deleteOneLessonUnit = exports.updateOneLessonUnit = exports.createOneLessonUnit = exports.findManyLessonUnitCount = exports.findManyLessonUnit = exports.findUniqueLessonUnit = exports.updateManyLessonSubject = void 0;
exports.updateManyPlace = exports.deleteManyPlace = exports.deleteOnePlace = exports.updateOnePlace = exports.createOnePlace = exports.findManyPlaceCount = exports.findManyPlace = exports.findUniquePlace = exports.updateManyPaymentStatusHistory = exports.deleteManyPaymentStatusHistory = exports.deleteOnePaymentStatusHistory = exports.updateOnePaymentStatusHistory = exports.createOnePaymentStatusHistory = exports.findManyPaymentStatusHistoryCount = exports.findManyPaymentStatusHistory = exports.findUniquePaymentStatusHistory = exports.updateManyPaymentIntent = exports.deleteManyPaymentIntent = exports.deleteOnePaymentIntent = exports.updateOnePaymentIntent = exports.createOnePaymentIntent = exports.findManyPaymentIntentCount = exports.findManyPaymentIntent = exports.findUniquePaymentIntent = exports.updateManyPaymentAPIFailureLog = exports.deleteManyPaymentAPIFailureLog = exports.deleteOnePaymentAPIFailureLog = exports.updateOnePaymentAPIFailureLog = exports.createOnePaymentAPIFailureLog = exports.findManyPaymentAPIFailureLogCount = exports.findManyPaymentAPIFailureLog = exports.findUniquePaymentAPIFailureLog = exports.findManyPaymentCount = exports.findManyPayment = exports.findUniquePayment = exports.updateManyMessageTranslation = exports.deleteManyMessageTranslation = exports.deleteOneMessageTranslation = exports.updateOneMessageTranslation = exports.createOneMessageTranslation = exports.findManyMessageTranslationCount = exports.findManyMessageTranslation = exports.findUniqueMessageTranslation = exports.updateManyMessageInfo = exports.deleteManyMessageInfo = exports.deleteOneMessageInfo = exports.updateOneMessageInfo = exports.createOneMessageInfo = exports.findManyMessageInfoCount = exports.findManyMessageInfo = void 0;
exports.findManyProfile_Channel = exports.findUniqueProfile_Channel = exports.updateManyProfileReview = exports.deleteManyProfileReview = exports.deleteOneProfileReview = exports.updateOneProfileReview = exports.createOneProfileReview = exports.findManyProfileReviewCount = exports.findManyProfileReview = exports.findUniqueProfileReview = exports.updateManyProfileInfo = exports.deleteManyProfileInfo = exports.deleteOneProfileInfo = exports.updateOneProfileInfo = exports.createOneProfileInfo = exports.findManyProfileInfoCount = exports.findManyProfileInfo = exports.findUniqueProfileInfo = exports.updateManyProfileChannel_User = exports.deleteManyProfileChannel_User = exports.deleteOneProfileChannel_User = exports.updateOneProfileChannel_User = exports.createOneProfileChannel_User = exports.findManyProfileChannel_UserCount = exports.findManyProfileChannel_User = exports.findUniqueProfileChannel_User = exports.updateManyProfile = exports.deleteManyProfile = exports.deleteOneProfile = exports.updateOneProfile = exports.createOneProfile = exports.findManyProfileCount = exports.findManyProfile = exports.findUniqueProfile = exports.updateManyProduct = exports.deleteManyProduct = exports.deleteOneProduct = exports.updateOneProduct = exports.createOneProduct = exports.findManyProductCount = exports.findManyProduct = exports.findUniqueProduct = exports.updateManyPlugin = exports.deleteManyPlugin = exports.deleteOnePlugin = exports.updateOnePlugin = exports.createOnePlugin = exports.findManyPluginCount = exports.findManyPlugin = exports.findUniquePlugin = void 0;
exports.findManySearchWord = exports.findUniqueSearchWord = exports.updateManyReportAction = exports.deleteManyReportAction = exports.deleteOneReportAction = exports.updateOneReportAction = exports.createOneReportAction = exports.findManyReportActionCount = exports.findManyReportAction = exports.findUniqueReportAction = exports.updateManyReaction = exports.deleteManyReaction = exports.deleteOneReaction = exports.updateOneReaction = exports.createOneReaction = exports.findManyReactionCount = exports.findManyReaction = exports.findUniqueReaction = exports.updateManyQuotaUsage = exports.deleteManyQuotaUsage = exports.deleteOneQuotaUsage = exports.updateOneQuotaUsage = exports.createOneQuotaUsage = exports.findManyQuotaUsageCount = exports.findManyQuotaUsage = exports.findUniqueQuotaUsage = exports.findManyQuotaCount = exports.findManyQuota = exports.findUniqueQuota = exports.updateManyProfile_ChatRoom = exports.deleteManyProfile_ChatRoom = exports.deleteOneProfile_ChatRoom = exports.updateOneProfile_ChatRoom = exports.createOneProfile_ChatRoom = exports.findManyProfile_ChatRoomCount = exports.findManyProfile_ChatRoom = exports.findUniqueProfile_ChatRoom = exports.updateManyProfile_ChannelActivity = exports.deleteManyProfile_ChannelActivity = exports.deleteOneProfile_ChannelActivity = exports.updateOneProfile_ChannelActivity = exports.createOneProfile_ChannelActivity = exports.findManyProfile_ChannelActivityCount = exports.findManyProfile_ChannelActivity = exports.findUniqueProfile_ChannelActivity = exports.updateManyProfile_Channel = exports.deleteManyProfile_Channel = exports.deleteOneProfile_Channel = exports.updateOneProfile_Channel = exports.findManyProfile_ChannelCount = void 0;
exports.createOneSignInTelVerification = exports.findManySignInTelVerificationCount = exports.findManySignInTelVerification = exports.findUniqueSignInTelVerification = exports.updateManySignIn = exports.deleteManySignIn = exports.deleteOneSignIn = exports.updateOneSignIn = exports.createOneSignIn = exports.findManySignInCount = exports.findManySignIn = exports.findUniqueSignIn = exports.updateManySettlementItem = exports.deleteManySettlementItem = exports.deleteOneSettlementItem = exports.updateOneSettlementItem = exports.createOneSettlementItem = exports.findManySettlementItemCount = exports.findManySettlementItem = exports.findUniqueSettlementItem = exports.updateManySettlement = exports.deleteManySettlement = exports.deleteOneSettlement = exports.updateOneSettlement = exports.createOneSettlement = exports.findManySettlementCount = exports.findManySettlement = exports.findUniqueSettlement = exports.updateManyServerError = exports.deleteManyServerError = exports.deleteOneServerError = exports.updateOneServerError = exports.createOneServerError = exports.findManyServerErrorCount = exports.findManyServerError = exports.findUniqueServerError = exports.updateManySecret = exports.deleteManySecret = exports.deleteOneSecret = exports.updateOneSecret = exports.createOneSecret = exports.findManySecretCount = exports.findManySecret = exports.findUniqueSecret = exports.updateManySearchWord = exports.deleteManySearchWord = exports.deleteOneSearchWord = exports.updateOneSearchWord = exports.createOneSearchWord = exports.findManySearchWordCount = void 0;
exports.findManyThumbnailCount = exports.findManyThumbnail = exports.findUniqueThumbnail = exports.updateManySysPicture = exports.deleteManySysPicture = exports.deleteOneSysPicture = exports.updateOneSysPicture = exports.createOneSysPicture = exports.findManySysPictureCount = exports.findManySysPicture = exports.findUniqueSysPicture = exports.updateManySysNotification = exports.deleteManySysNotification = exports.deleteOneSysNotification = exports.updateOneSysNotification = exports.createOneSysNotification = exports.findManySysNotificationCount = exports.findManySysNotification = exports.findUniqueSysNotification = exports.updateManySysNotice = exports.deleteManySysNotice = exports.deleteOneSysNotice = exports.updateOneSysNotice = exports.createOneSysNotice = exports.findManySysNoticeCount = exports.findManySysNotice = exports.findUniqueSysNotice = exports.updateManySysInfo = exports.deleteManySysInfo = exports.deleteOneSysInfo = exports.updateOneSysInfo = exports.createOneSysInfo = exports.findManySysInfoCount = exports.findManySysInfo = exports.findUniqueSysInfo = exports.findManySubscriptionHistoryCount = exports.findManySubscriptionHistory = exports.findUniqueSubscriptionHistory = exports.updateManySubscription = exports.deleteManySubscription = exports.deleteOneSubscription = exports.updateOneSubscription = exports.createOneSubscription = exports.findManySubscriptionCount = exports.findManySubscription = exports.findUniqueSubscription = exports.updateManySignInTelVerification = exports.deleteManySignInTelVerification = exports.deleteOneSignInTelVerification = exports.updateOneSignInTelVerification = void 0;
exports.findManyUserKeywordCount = exports.findManyUserKeyword = exports.findUniqueUserKeyword = exports.findManyUserIdentityCount = exports.findUniqueUserIdentity = exports.updateManyUserChannelAccount = exports.deleteManyUserChannelAccount = exports.deleteOneUserChannelAccount = exports.updateOneUserChannelAccount = exports.createOneUserChannelAccount = exports.findManyUserChannelAccountCount = exports.findManyUserChannelAccount = exports.findUniqueUserChannelAccount = exports.updateManyUserBlocking = exports.deleteManyUserBlocking = exports.deleteOneUserBlocking = exports.updateOneUserBlocking = exports.createOneUserBlocking = exports.findManyUserBlockingCount = exports.findManyUserBlocking = exports.findUniqueUserBlocking = exports.updateManyUserAdAction = exports.deleteManyUserAdAction = exports.deleteOneUserAdAction = exports.updateOneUserAdAction = exports.createOneUserAdAction = exports.findManyUserAdActionCount = exports.findManyUserAdAction = exports.findUniqueUserAdAction = exports.updateManyUser = exports.deleteManyUser = exports.deleteOneUser = exports.updateOneUser = exports.createOneUser = exports.findManyUserCount = exports.findManyUser = exports.findUniqueUser = exports.updateManyUrlMetadata = exports.deleteManyUrlMetadata = exports.deleteOneUrlMetadata = exports.updateOneUrlMetadata = exports.createOneUrlMetadata = exports.findManyUrlMetadataCount = exports.findManyUrlMetadata = exports.findUniqueUrlMetadata = exports.updateManyThumbnail = exports.deleteManyThumbnail = exports.deleteOneThumbnail = exports.updateOneThumbnail = exports.createOneThumbnail = void 0;
exports.updateOneUser_ChatRoomView = exports.createOneUser_ChatRoomView = exports.findManyUser_ChatRoomViewCount = exports.findManyUser_ChatRoomView = exports.findUniqueUser_ChatRoomView = exports.updateManyUserUsage = exports.deleteManyUserUsage = exports.deleteOneUserUsage = exports.updateOneUserUsage = exports.createOneUserUsage = exports.findManyUserUsageCount = exports.findManyUserUsage = exports.findUniqueUserUsage = exports.updateManyUserPointWithdrawRequest = exports.deleteManyUserPointWithdrawRequest = exports.deleteOneUserPointWithdrawRequest = exports.updateOneUserPointWithdrawRequest = exports.createOneUserPointWithdrawRequest = exports.findManyUserPointWithdrawRequestCount = exports.findManyUserPointWithdrawRequest = exports.findUniqueUserPointWithdrawRequest = exports.updateManyUserPointLog = exports.deleteManyUserPointLog = exports.deleteOneUserPointLog = exports.updateOneUserPointLog = exports.createOneUserPointLog = exports.findManyUserPointLogCount = exports.findManyUserPointLog = exports.findUniqueUserPointLog = exports.updateManyUserPenalty = exports.deleteManyUserPenalty = exports.deleteOneUserPenalty = exports.updateOneUserPenalty = exports.createOneUserPenalty = exports.findManyUserPenaltyCount = exports.findManyUserPenalty = exports.findUniqueUserPenalty = exports.updateManyUserLog = exports.deleteManyUserLog = exports.deleteOneUserLog = exports.updateOneUserLog = exports.createOneUserLog = exports.findManyUserLogCount = exports.findManyUserLog = exports.findUniqueUserLog = exports.updateManyUserKeyword = exports.deleteManyUserKeyword = exports.deleteOneUserKeyword = exports.updateOneUserKeyword = exports.createOneUserKeyword = void 0;
exports.updateManyVersionChange = exports.deleteManyVersionChange = exports.deleteOneVersionChange = exports.updateOneVersionChange = exports.createOneVersionChange = exports.findManyVersionChangeCount = exports.findManyVersionChange = exports.findUniqueVersionChange = exports.updateManyUser_Profile = exports.deleteManyUser_Profile = exports.deleteOneUser_Profile = exports.updateOneUser_Profile = exports.createOneUser_Profile = exports.findManyUser_ProfileCount = exports.findManyUser_Profile = exports.findUniqueUser_Profile = exports.updateManyUser_ChatRoomView = exports.deleteManyUser_ChatRoomView = exports.deleteOneUser_ChatRoomView = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.AbusingReportFields = (0, graphql_tag_1.default) `
    fragment AbusingReportFields on AbusingReport {
  id
  createdAt
  lastActionAt
  closedAt
  description
  reporterId
  profileId
  userId
  channelId
  chatRoomId
  messageId
  reactionId
}
    `;
exports.UserFields = (0, graphql_tag_1.default) `
    fragment UserFields on User {
  id
  createdAt
  tel
  email
  emailVerified
  emailCode
  emailCodeValidUntil
  extProvider
  extUserId
  extToken
  isAdmin
  agreeToMarketingAt
  deleted
  deletedAt
  lastAccessedAt
  referrerId
  referChannelId
  auxInfo
  timestamp
  newMessageDisplaySetting
  notiSetting
  lastMesgNotiId
  lastSysNotiId
  lastNoticeId
  lastEventId
  channelId
}
    `;
exports.ProfileFields = (0, graphql_tag_1.default) `
    fragment ProfileFields on Profile {
  id
  createdAt
  name
  description
  picture
  thumbnailId
  tel
  telVerified
  telCode
  telCodeValidUntil
  email
  emailVerified
  emailCode
  emailCodeValidUntil
  deleted
  type
  address
  tel2
  email2
  homepage
  ceo
  bizName
  bizId
  canIssueReceipt
  attachments
  blockChatting
  userId
}
    `;
exports.ChannelFields = (0, graphql_tag_1.default) `
    fragment ChannelFields on Channel {
  id
  code
  createdAt
  timestamp
  name
  description
  picture
  thumbnailId
  keywords
  needAccessCode
  accessCode
  needApproval
  blockSearch
  profileCount
  expertName
  certificationNotice
  actionButtons
  welcomeMesg
  matchKeywords
  uiComponents
  props
  layout
  productMeta
  termsOfService
  privacyPolicy
  company
  commerceProductMeta
  isCompanyOperated
  defaultSubscProductId
  ownerId
  ownUserId
  channelRoomId
}
    `;
exports.ChatRoomFields = (0, graphql_tag_1.default) `
    fragment ChatRoomFields on ChatRoom {
  id
  status
  type
  name
  description
  rootMessageId
  restricted
  process
  accessCode
  keywords
  props
  channelId
  namespace
  commentsRootMessageId
  commentsRootChatRoomId
}
    `;
exports.ReactionFields = (0, graphql_tag_1.default) `
    fragment ReactionFields on Reaction {
  id
  createdAt
  updatedAt
  type
  mesgId
  props
  profileName
  targetProfileName
  reportedAt
  likesCount
  censored
  userId
  targetUserId
  parentReactionId
  channelId
  chatRoomId
}
    `;
exports.AbusingReport = (0, graphql_tag_1.default) `
    fragment AbusingReport on AbusingReport {
  ...AbusingReportFields
  reporter {
    ...UserFields
  }
  profile {
    ...ProfileFields
  }
  user {
    ...UserFields
  }
  channel {
    ...ChannelFields
  }
  chatRoom {
    ...ChatRoomFields
  }
  reaction {
    ...ReactionFields
  }
}
    ${exports.AbusingReportFields}
${exports.UserFields}
${exports.ProfileFields}
${exports.ChannelFields}
${exports.ChatRoomFields}
${exports.ReactionFields}`;
exports.AccountInfoFields = (0, graphql_tag_1.default) `
    fragment AccountInfoFields on AccountInfo {
  id
  bankCode
  bankName
  bankAccountNo
  bankAccountHolder
  taxType
  userId
  profileId
}
    `;
exports.AccountInfo = (0, graphql_tag_1.default) `
    fragment AccountInfo on AccountInfo {
  ...AccountInfoFields
}
    ${exports.AccountInfoFields}`;
exports.AdvertisementFields = (0, graphql_tag_1.default) `
    fragment AdvertisementFields on Advertisement {
  id
  createdAt
  title
  contents
  channelId
  validFrom
  validTo
  byChannel
  isAppChannel
  advertiserId
}
    `;
exports.AdvertiserFields = (0, graphql_tag_1.default) `
    fragment AdvertiserFields on Advertiser {
  id
  name
  tel
  email
  regId
  bizId
}
    `;
exports.Advertisement = (0, graphql_tag_1.default) `
    fragment Advertisement on Advertisement {
  ...AdvertisementFields
  advertiser {
    ...AdvertiserFields
  }
}
    ${exports.AdvertisementFields}
${exports.AdvertiserFields}`;
exports.Advertiser = (0, graphql_tag_1.default) `
    fragment Advertiser on Advertiser {
  ...AdvertiserFields
}
    ${exports.AdvertiserFields}`;
exports.AiChatMessageFields = (0, graphql_tag_1.default) `
    fragment AiChatMessageFields on AiChatMessage {
  id
  createdAt
  role
  body
  imageUrl
  props
  isFirst
  responseId
  inputTokens
  outputTokens
  channelId
  userId
  chatRoomId
}
    `;
exports.AiChatRoomFields = (0, graphql_tag_1.default) `
    fragment AiChatRoomFields on AiChatRoom {
  id
  createdAt
  lastAccessedAt
  category
  channelId
  userId
}
    `;
exports.AiChatMessage = (0, graphql_tag_1.default) `
    fragment AiChatMessage on AiChatMessage {
  ...AiChatMessageFields
  channel {
    ...ChannelFields
  }
  user {
    ...UserFields
  }
  chatRoom {
    ...AiChatRoomFields
  }
}
    ${exports.AiChatMessageFields}
${exports.ChannelFields}
${exports.UserFields}
${exports.AiChatRoomFields}`;
exports.AiChatRoom = (0, graphql_tag_1.default) `
    fragment AiChatRoom on AiChatRoom {
  ...AiChatRoomFields
  channel {
    ...ChannelFields
  }
  user {
    ...UserFields
  }
}
    ${exports.AiChatRoomFields}
${exports.ChannelFields}
${exports.UserFields}`;
exports.AppInfoFields = (0, graphql_tag_1.default) `
    fragment AppInfoFields on AppInfo {
  id
  appId
  appName
  androidPackageId
  androidFingerprints
  iosAppStoreId
  iosTeamId
  iosBundleId
  webAppUrl
  channelId
}
    `;
exports.AppInfo = (0, graphql_tag_1.default) `
    fragment AppInfo on AppInfo {
  ...AppInfoFields
  channel {
    ...ChannelFields
  }
}
    ${exports.AppInfoFields}
${exports.ChannelFields}`;
exports.ApplicationsFields = (0, graphql_tag_1.default) `
    fragment ApplicationsFields on Applications {
  id
  name
  appId
  appSecret
  polices
  blocked
  lastAccessedAt
  createdAt
}
    `;
exports.Applications = (0, graphql_tag_1.default) `
    fragment Applications on Applications {
  ...ApplicationsFields
}
    ${exports.ApplicationsFields}`;
exports.AttachmentFields = (0, graphql_tag_1.default) `
    fragment AttachmentFields on Attachment {
  id
  title
  type
  size
  info
  thumbnail
  thumbnailId
  embed
  url
  expertInfoId
}
    `;
exports.ExpertInfoFields = (0, graphql_tag_1.default) `
    fragment ExpertInfoFields on ExpertInfo {
  id
  description
  agreePrivacyAt
  agreePolicyAt
  requestedAt
  approvedAt
  deniedAt
  denyReason
  reRequestedAt
  channelExpertId
  profile_ChannelId
  userId
  channelId
}
    `;
exports.Attachment = (0, graphql_tag_1.default) `
    fragment Attachment on Attachment {
  ...AttachmentFields
  expertInfo {
    ...ExpertInfoFields
  }
}
    ${exports.AttachmentFields}
${exports.ExpertInfoFields}`;
exports.BannedWordsFields = (0, graphql_tag_1.default) `
    fragment BannedWordsFields on BannedWords {
  id
  createdAt
  updatedAt
  channelId
  words
}
    `;
exports.BannedWords = (0, graphql_tag_1.default) `
    fragment BannedWords on BannedWords {
  ...BannedWordsFields
}
    ${exports.BannedWordsFields}`;
exports.CategoryFields = (0, graphql_tag_1.default) `
    fragment CategoryFields on Category {
  id
  name
  type
  channelId
}
    `;
exports.Category = (0, graphql_tag_1.default) `
    fragment Category on Category {
  ...CategoryFields
  channel {
    ...ChannelFields
  }
}
    ${exports.CategoryFields}
${exports.ChannelFields}`;
exports.CategoryKeywordFields = (0, graphql_tag_1.default) `
    fragment CategoryKeywordFields on CategoryKeyword {
  id
  keyword
}
    `;
exports.CategoryKeyword = (0, graphql_tag_1.default) `
    fragment CategoryKeyword on CategoryKeyword {
  ...CategoryKeywordFields
}
    ${exports.CategoryKeywordFields}`;
exports.Channel = (0, graphql_tag_1.default) `
    fragment Channel on Channel {
  ...ChannelFields
  owner {
    ...ProfileFields
  }
  ownUser {
    ...UserFields
  }
  appInfo {
    ...AppInfoFields
  }
}
    ${exports.ChannelFields}
${exports.ProfileFields}
${exports.UserFields}
${exports.AppInfoFields}`;
exports.ChannelBizInfoFields = (0, graphql_tag_1.default) `
    fragment ChannelBizInfoFields on ChannelBizInfo {
  id
  createdAt
  updatedAt
  commission
  bankCode
  bankName
  bankAccountNo
  bankAccountHolder
  bizId
  channelId
}
    `;
exports.ChannelBizInfo = (0, graphql_tag_1.default) `
    fragment ChannelBizInfo on ChannelBizInfo {
  ...ChannelBizInfoFields
}
    ${exports.ChannelBizInfoFields}`;
exports.ChannelChatRoomMenuFields = (0, graphql_tag_1.default) `
    fragment ChannelChatRoomMenuFields on ChannelChatRoomMenu {
  id
  seq
  type
  text
  channelId
  chatRoomId
}
    `;
exports.ChannelChatRoomMenu = (0, graphql_tag_1.default) `
    fragment ChannelChatRoomMenu on ChannelChatRoomMenu {
  ...ChannelChatRoomMenuFields
  channel {
    ...ChannelFields
  }
  chatRoom {
    ...ChatRoomFields
  }
}
    ${exports.ChannelChatRoomMenuFields}
${exports.ChannelFields}
${exports.ChatRoomFields}`;
exports.ChannelDeviceTokenFields = (0, graphql_tag_1.default) `
    fragment ChannelDeviceTokenFields on ChannelDeviceToken {
  id
  deviceType
  token
  lang
  channelId
  userId
  version
}
    `;
exports.ChannelDeviceToken = (0, graphql_tag_1.default) `
    fragment ChannelDeviceToken on ChannelDeviceToken {
  ...ChannelDeviceTokenFields
}
    ${exports.ChannelDeviceTokenFields}`;
exports.ChannelDictionaryFields = (0, graphql_tag_1.default) `
    fragment ChannelDictionaryFields on ChannelDictionary {
  id
  lang
  dict
  channelId
}
    `;
exports.ChannelDictionary = (0, graphql_tag_1.default) `
    fragment ChannelDictionary on ChannelDictionary {
  ...ChannelDictionaryFields
}
    ${exports.ChannelDictionaryFields}`;
exports.ChannelExpertFields = (0, graphql_tag_1.default) `
    fragment ChannelExpertFields on ChannelExpert {
  id
  name
  description
  disabled
  isOpen
  collectedInfo
  expertPolicy
  channelId
}
    `;
exports.ChannelExpert = (0, graphql_tag_1.default) `
    fragment ChannelExpert on ChannelExpert {
  ...ChannelExpertFields
  channel {
    ...ChannelFields
  }
}
    ${exports.ChannelExpertFields}
${exports.ChannelFields}`;
exports.ChannelUserUsageFields = (0, graphql_tag_1.default) `
    fragment ChannelUserUsageFields on ChannelUserUsage {
  id
  channelId
  userId
  data
  readReactionId
}
    `;
exports.ChannelUserUsage = (0, graphql_tag_1.default) `
    fragment ChannelUserUsage on ChannelUserUsage {
  ...ChannelUserUsageFields
}
    ${exports.ChannelUserUsageFields}`;
exports.JobOfferResponseFields = (0, graphql_tag_1.default) `
    fragment JobOfferResponseFields on JobOfferResponse {
  id
  createdAt
  hiredAt
  canceledAt
  canceledBy
  finishedAt
  state
  props
  startAt
  duration
  partsApplied
  partsHired
  priceExt
  currency
  paidPoint
  paidByPoint
  paidExt
  toBePaidExt
  refundExt
  refundedExt
  toBeRefunded
  refundAgreedAt
  settleProviderId
  settlePlatformId
  toBeDoneByProvider
  toBeDoneByClient
  isPublicByProvider
  isPublicByClient
  clientId
  clientUserId
  providerId
  providerUserId
  channelId
  chatRoomId
  offerChatRoomId
  jobOfferId
  price
  toBePaid
  refund
  settlementId
  tempSettlementId
}
    `;
exports.ChatRoom = (0, graphql_tag_1.default) `
    fragment ChatRoom on ChatRoom {
  ...ChatRoomFields
  channel {
    ...ChannelFields
  }
  jobOfferResponse {
    ...JobOfferResponseFields
  }
}
    ${exports.ChatRoomFields}
${exports.ChannelFields}
${exports.JobOfferResponseFields}`;
exports.ClientVersionsFields = (0, graphql_tag_1.default) `
    fragment ClientVersionsFields on ClientVersions {
  id
  ios
  android
}
    `;
exports.ClientVersions = (0, graphql_tag_1.default) `
    fragment ClientVersions on ClientVersions {
  ...ClientVersionsFields
}
    ${exports.ClientVersionsFields}`;
exports.CommerceOrderFields = (0, graphql_tag_1.default) `
    fragment CommerceOrderFields on CommerceOrder {
  id
  createdAt
  updatedAt
  sentAt
  receivedAt
  downloadedAt
  cancelledAt
  refundedAt
  scheduledAt
  priceExt
  currency
  paidPoint
  paidByPoint
  paidExt
  toBePaidExt
  refundExt
  refundedExt
  toBeRefunded
  needConfirm
  lastPaidAt
  confirmedAt
  productType
  state
  orderDetail
  subscTransactionId
  userUuid
  settleProviderId
  settlePlatformId
  channelId
  userId
  profileId
  sellerId
  sellerUserId
  riderId
  riderUserId
  productId
  settlementId
  tempSettlementId
}
    `;
exports.SettlementItemFields = (0, graphql_tag_1.default) `
    fragment SettlementItemFields on SettlementItem {
  id
  createdAt
  type
  price
  currency
  pgVendor
  payMethod
  amountForeign
  currencyPaid
  exchRate
  paidPoint
  paidByPoint
  amountPaid
  ratePg
  ratePlatform
  rateCompany
  rateProvider
  amountPg
  amountPlatform
  amountCompany
  amountProvider
  jrspId
  jobOfferId
  commerceOrderId
  commerceProductId
  subscriptionId
  settlementId
  channelId
  userId
}
    `;
exports.SettlementFields = (0, graphql_tag_1.default) `
    fragment SettlementFields on Settlement {
  id
  createdAt
  target
  taxType
  taxAmount
  amountBeforeTax
  amountWithTax
  countItem
  countOrder
  pg
  bankCode
  bankAccountNo
  tid
  response
  channelId
  userId
  amount
  totalSalesAmount
  commissions
  profileId
}
    `;
exports.CommerceProductFields = (0, graphql_tag_1.default) `
    fragment CommerceProductFields on CommerceProduct {
  id
  createdAt
  updatedAt
  type
  cat
  sub
  name
  desc
  thumbnails
  specs
  quotaSpecs
  attachments
  extraTerms
  extProductRef
  digitalFiles
  review
  reviewCount
  soldCount
  priceExt
  currency
  channelId
  sellerId
  sellerUserId
}
    `;
exports.CommerceOrder = (0, graphql_tag_1.default) `
    fragment CommerceOrder on CommerceOrder {
  ...CommerceOrderFields
  settleItem {
    ...SettlementItemFields
  }
  settleProvider {
    ...SettlementFields
  }
  settlePlatform {
    ...SettlementFields
  }
  channel {
    ...ChannelFields
  }
  user {
    ...UserFields
  }
  profile {
    ...ProfileFields
  }
  seller {
    ...ProfileFields
  }
  sellerUser {
    ...UserFields
  }
  rider {
    ...ProfileFields
  }
  riderUser {
    ...UserFields
  }
  product {
    ...CommerceProductFields
  }
}
    ${exports.CommerceOrderFields}
${exports.SettlementItemFields}
${exports.SettlementFields}
${exports.ChannelFields}
${exports.UserFields}
${exports.ProfileFields}
${exports.CommerceProductFields}`;
exports.CommerceOrderReviewFields = (0, graphql_tag_1.default) `
    fragment CommerceOrderReviewFields on CommerceOrderReview {
  id
  createdAt
  updatedAt
  deletedAt
  point
  description
  reviewerId
  reviewerUserId
  productId
  orderId
  sellerUserId
}
    `;
exports.CommerceOrderReview = (0, graphql_tag_1.default) `
    fragment CommerceOrderReview on CommerceOrderReview {
  ...CommerceOrderReviewFields
  reviewer {
    ...ProfileFields
  }
  reviewerUser {
    ...UserFields
  }
  product {
    ...CommerceProductFields
  }
  order {
    ...CommerceOrderFields
  }
  sellerUser {
    ...UserFields
  }
}
    ${exports.CommerceOrderReviewFields}
${exports.ProfileFields}
${exports.UserFields}
${exports.CommerceProductFields}
${exports.CommerceOrderFields}`;
exports.CommerceProduct = (0, graphql_tag_1.default) `
    fragment CommerceProduct on CommerceProduct {
  ...CommerceProductFields
  channel {
    ...ChannelFields
  }
  seller {
    ...ProfileFields
  }
  sellerUser {
    ...UserFields
  }
}
    ${exports.CommerceProductFields}
${exports.ChannelFields}
${exports.ProfileFields}
${exports.UserFields}`;
exports.CommerceProductReviewFields = (0, graphql_tag_1.default) `
    fragment CommerceProductReviewFields on CommerceProductReview {
  id
  createdAt
  updatedAt
  deletedAt
  point
  description
  reviewerId
  reviewerUserId
  productId
  sellerUserId
}
    `;
exports.CommerceProductReview = (0, graphql_tag_1.default) `
    fragment CommerceProductReview on CommerceProductReview {
  ...CommerceProductReviewFields
  reviewer {
    ...ProfileFields
  }
  reviewerUser {
    ...UserFields
  }
  product {
    ...CommerceProductFields
  }
  sellerUser {
    ...UserFields
  }
}
    ${exports.CommerceProductReviewFields}
${exports.ProfileFields}
${exports.UserFields}
${exports.CommerceProductFields}`;
exports.CustomerCommunicationLogFields = (0, graphql_tag_1.default) `
    fragment CustomerCommunicationLogFields on CustomerCommunicationLog {
  id
  createdAt
  type
  title
  memo
  when
  where
  who
  rejected
  stageChanged
  relationshipId
}
    `;
exports.CustomerRelationshipFields = (0, graphql_tag_1.default) `
    fragment CustomerRelationshipFields on CustomerRelationship {
  id
  createdAt
  grade
  stage
  tags
  bookmarked
  wasConnected
  hadDeal
  rejected
  customerPcId
  userPcId
  userId
  channelId
}
    `;
exports.CustomerCommunicationLog = (0, graphql_tag_1.default) `
    fragment CustomerCommunicationLog on CustomerCommunicationLog {
  ...CustomerCommunicationLogFields
  relationship {
    ...CustomerRelationshipFields
  }
}
    ${exports.CustomerCommunicationLogFields}
${exports.CustomerRelationshipFields}`;
exports.Profile_ChannelFields = (0, graphql_tag_1.default) `
    fragment Profile_ChannelFields on Profile_Channel {
  id
  createdAt
  approvalRequestedAt
  approvedAt
  denyReason
  blockChatting
  suspendUntil
  certRequestedAt
  certVerifiedAt
  isAdmin
  expelledAt
  mesgFilter
  mesgFilterTokens
  props
  userInfo
  userAttachments
  currentExpertId
  noDefaultExpert
  referrerId
  favoriteChatRooms
  agreePrivacyAt
  agreeTermsAt
  namespace
  reviewAverage
  reviewCount
  viewCount
  passwordApprovedChatRoomIds
  profileId
  channelId
  userId
  custodianId
  isPublic
}
    `;
exports.CustomerRelationship = (0, graphql_tag_1.default) `
    fragment CustomerRelationship on CustomerRelationship {
  ...CustomerRelationshipFields
  customerPc {
    ...Profile_ChannelFields
  }
  userPc {
    ...Profile_ChannelFields
  }
  user {
    ...UserFields
  }
  channel {
    ...ChannelFields
  }
}
    ${exports.CustomerRelationshipFields}
${exports.Profile_ChannelFields}
${exports.UserFields}
${exports.ChannelFields}`;
exports.DeletedUserFields = (0, graphql_tag_1.default) `
    fragment DeletedUserFields on DeletedUser {
  id
  deletedAt
  tel
  reason
  penalty
}
    `;
exports.DeletedUser = (0, graphql_tag_1.default) `
    fragment DeletedUser on DeletedUser {
  ...DeletedUserFields
}
    ${exports.DeletedUserFields}`;
exports.DeviceToken_TopicsFields = (0, graphql_tag_1.default) `
    fragment DeviceToken_TopicsFields on DeviceToken_Topics {
  id
  token
  topics
  createdAt
  updatedAt
  deletedAt
}
    `;
exports.DeviceToken_Topics = (0, graphql_tag_1.default) `
    fragment DeviceToken_Topics on DeviceToken_Topics {
  ...DeviceToken_TopicsFields
}
    ${exports.DeviceToken_TopicsFields}`;
exports.DocumentFields = (0, graphql_tag_1.default) `
    fragment DocumentFields on Document {
  id
  type
  lang
  version
  content
  channelId
}
    `;
exports.Document = (0, graphql_tag_1.default) `
    fragment Document on Document {
  ...DocumentFields
}
    ${exports.DocumentFields}`;
exports.DontShowAgainFields = (0, graphql_tag_1.default) `
    fragment DontShowAgainFields on DontShowAgain {
  id
  type
  name
  userId
}
    `;
exports.DontShowAgain = (0, graphql_tag_1.default) `
    fragment DontShowAgain on DontShowAgain {
  ...DontShowAgainFields
  user {
    ...UserFields
  }
}
    ${exports.DontShowAgainFields}
${exports.UserFields}`;
exports.DynamicLinkFields = (0, graphql_tag_1.default) `
    fragment DynamicLinkFields on DynamicLink {
  id
  url
  fingerprint
  ip
  platform
  isMobile
  isSafari
  isUsed
  usedAt
  createdAt
  expiresAt
}
    `;
exports.DynamicLink = (0, graphql_tag_1.default) `
    fragment DynamicLink on DynamicLink {
  ...DynamicLinkFields
}
    ${exports.DynamicLinkFields}`;
exports.ExpertInfo = (0, graphql_tag_1.default) `
    fragment ExpertInfo on ExpertInfo {
  ...ExpertInfoFields
  channelExpert {
    ...ChannelExpertFields
  }
  profile_Channel {
    ...Profile_ChannelFields
  }
  user {
    ...UserFields
  }
  channel {
    ...ChannelFields
  }
}
    ${exports.ExpertInfoFields}
${exports.ChannelExpertFields}
${exports.Profile_ChannelFields}
${exports.UserFields}
${exports.ChannelFields}`;
exports.ExternalRequestFields = (0, graphql_tag_1.default) `
    fragment ExternalRequestFields on ExternalRequest {
  id
  createdAt
  type
  request
  repliedAt
  reply
  success
  error
}
    `;
exports.ExternalRequest = (0, graphql_tag_1.default) `
    fragment ExternalRequest on ExternalRequest {
  ...ExternalRequestFields
}
    ${exports.ExternalRequestFields}`;
exports.FaQFields = (0, graphql_tag_1.default) `
    fragment FaQFields on FaQ {
  id
  category
  question
  answer
  seq
}
    `;
exports.FaQ = (0, graphql_tag_1.default) `
    fragment FaQ on FaQ {
  ...FaQFields
}
    ${exports.FaQFields}`;
exports.FollowFields = (0, graphql_tag_1.default) `
    fragment FollowFields on Follow {
  id
  createdAt
  channelId
  userId
  followerId
}
    `;
exports.Follow = (0, graphql_tag_1.default) `
    fragment Follow on Follow {
  ...FollowFields
  user {
    ...UserFields
  }
  follower {
    ...UserFields
  }
}
    ${exports.FollowFields}
${exports.UserFields}`;
exports.HashTagFields = (0, graphql_tag_1.default) `
    fragment HashTagFields on HashTag {
  id
  name
  count
  channelId
}
    `;
exports.HashTag = (0, graphql_tag_1.default) `
    fragment HashTag on HashTag {
  ...HashTagFields
  channel {
    ...ChannelFields
  }
}
    ${exports.HashTagFields}
${exports.ChannelFields}`;
exports.JobOfferFields = (0, graphql_tag_1.default) `
    fragment JobOfferFields on JobOffer {
  id
  createdAt
  state
  isPublic
  isPublicByClient
  props
  partsAndCounts
  countsHired
  jobReward
  clientId
  clientUserId
  chatRoomId
  channelId
  designatedProviderId
  designatedProviderUserId
  groupChatRoomId
  mesgId
}
    `;
exports.MessageInfoFields = (0, graphql_tag_1.default) `
    fragment MessageInfoFields on MessageInfo {
  id
  notiUserCount
  likesCount
  bookmarkCount
  commentsCount
  channelId
  chatRoomId
  commentsChatRoomId
  userId
}
    `;
exports.JobOffer = (0, graphql_tag_1.default) `
    fragment JobOffer on JobOffer {
  ...JobOfferFields
  client {
    ...ProfileFields
  }
  clientUser {
    ...UserFields
  }
  chatRoom {
    ...ChatRoomFields
  }
  channel {
    ...ChannelFields
  }
  designatedProvider {
    ...ProfileFields
  }
  designatedProviderUser {
    ...UserFields
  }
  mesg {
    ...MessageInfoFields
  }
}
    ${exports.JobOfferFields}
${exports.ProfileFields}
${exports.UserFields}
${exports.ChatRoomFields}
${exports.ChannelFields}
${exports.MessageInfoFields}`;
exports.JobReviewFields = (0, graphql_tag_1.default) `
    fragment JobReviewFields on JobReview {
  id
  createdAt
  role
  pointOverall
  point1
  point2
  point3
  detail
  reviewerId
  revieweeId
  reviewerUserId
  revieweeUserId
  jobAsClientId
  jobAsProviderId
  channelId
  chatRoomId
  offerChatRoomId
}
    `;
exports.JobOfferResponse = (0, graphql_tag_1.default) `
    fragment JobOfferResponse on JobOfferResponse {
  ...JobOfferResponseFields
  settleItem {
    ...SettlementItemFields
  }
  settleProvider {
    ...SettlementFields
  }
  settlePlatform {
    ...SettlementFields
  }
  client {
    ...ProfileFields
  }
  clientUser {
    ...UserFields
  }
  provider {
    ...ProfileFields
  }
  providerUser {
    ...UserFields
  }
  channel {
    ...ChannelFields
  }
  chatRoom {
    ...ChatRoomFields
  }
  offerChatRoom {
    ...ChatRoomFields
  }
  jobOffer {
    ...JobOfferFields
  }
  reviewByClient {
    ...JobReviewFields
  }
  reviewByProvider {
    ...JobReviewFields
  }
}
    ${exports.JobOfferResponseFields}
${exports.SettlementItemFields}
${exports.SettlementFields}
${exports.ProfileFields}
${exports.UserFields}
${exports.ChannelFields}
${exports.ChatRoomFields}
${exports.JobOfferFields}
${exports.JobReviewFields}`;
exports.JobOutputFields = (0, graphql_tag_1.default) `
    fragment JobOutputFields on JobOutput {
  id
  createdAt
  type
  group
  title
  keywords
  mesgKeywords
  props
  whoCanPublish
  publishedByProvider
  publishedByClient
  published
  jobOfferId
  jobOfferResponseId
  chatRoomId
  channelId
  messageId
  providerId
  clientId
  providerUserId
  clientUserId
}
    `;
exports.JobOutput = (0, graphql_tag_1.default) `
    fragment JobOutput on JobOutput {
  ...JobOutputFields
  jobOffer {
    ...JobOfferFields
  }
  jobOfferResponse {
    ...JobOfferResponseFields
  }
  chatRoom {
    ...ChatRoomFields
  }
  channel {
    ...ChannelFields
  }
  provider {
    ...ProfileFields
  }
  client {
    ...ProfileFields
  }
  providerUser {
    ...UserFields
  }
  clientUser {
    ...UserFields
  }
}
    ${exports.JobOutputFields}
${exports.JobOfferFields}
${exports.JobOfferResponseFields}
${exports.ChatRoomFields}
${exports.ChannelFields}
${exports.ProfileFields}
${exports.UserFields}`;
exports.JobReview = (0, graphql_tag_1.default) `
    fragment JobReview on JobReview {
  ...JobReviewFields
  reviewer {
    ...ProfileFields
  }
  reviewee {
    ...ProfileFields
  }
  reviewerUser {
    ...UserFields
  }
  revieweeUser {
    ...UserFields
  }
  jobAsClient {
    ...JobOfferResponseFields
  }
  jobAsProvider {
    ...JobOfferResponseFields
  }
  channel {
    ...ChannelFields
  }
  chatRoom {
    ...ChatRoomFields
  }
  offerChatRoom {
    ...ChatRoomFields
  }
}
    ${exports.JobReviewFields}
${exports.ProfileFields}
${exports.UserFields}
${exports.JobOfferResponseFields}
${exports.ChannelFields}
${exports.ChatRoomFields}`;
exports.JobTransactionFields = (0, graphql_tag_1.default) `
    fragment JobTransactionFields on JobTransaction {
  id
  createdAt
  type
  body
  mesgId
  jobOfferResponseId
}
    `;
exports.JobTransaction = (0, graphql_tag_1.default) `
    fragment JobTransaction on JobTransaction {
  ...JobTransactionFields
  jobOfferResponse {
    ...JobOfferResponseFields
  }
}
    ${exports.JobTransactionFields}
${exports.JobOfferResponseFields}`;
exports.LessonCreatorFields = (0, graphql_tag_1.default) `
    fragment LessonCreatorFields on LessonCreator {
  id
  createdAt
  updatedAt
  source
  uuid
  userId
  profileId
  youtubeUserId
}
    `;
exports.LessonYouTubeUserFields = (0, graphql_tag_1.default) `
    fragment LessonYouTubeUserFields on LessonYouTubeUser {
  id
  createdAt
  updatedAt
  name
  thumbnailUrl
}
    `;
exports.LessonCreator = (0, graphql_tag_1.default) `
    fragment LessonCreator on LessonCreator {
  ...LessonCreatorFields
  user {
    ...UserFields
  }
  profile {
    ...ProfileFields
  }
  youtubeUser {
    ...LessonYouTubeUserFields
  }
}
    ${exports.LessonCreatorFields}
${exports.UserFields}
${exports.ProfileFields}
${exports.LessonYouTubeUserFields}`;
exports.LessonExamFields = (0, graphql_tag_1.default) `
    fragment LessonExamFields on LessonExam {
  id
  createdAt
  updatedAt
  deletedAt
  uuid
  title
  year
  month
  type
  grade
  subjectId
}
    `;
exports.LessonSubjectFields = (0, graphql_tag_1.default) `
    fragment LessonSubjectFields on LessonSubject {
  id
  title
}
    `;
exports.LessonExam = (0, graphql_tag_1.default) `
    fragment LessonExam on LessonExam {
  ...LessonExamFields
  subject {
    ...LessonSubjectFields
  }
}
    ${exports.LessonExamFields}
${exports.LessonSubjectFields}`;
exports.LessonExamQuestionFields = (0, graphql_tag_1.default) `
    fragment LessonExamQuestionFields on LessonExamQuestion {
  id
  createdAt
  updatedAt
  deletedAt
  uuid
  mesgId
  examUuid
  number
  point
  answer
  unitIds
  keywords
  content
  explanation
  audio
}
    `;
exports.LessonExamQuestion = (0, graphql_tag_1.default) `
    fragment LessonExamQuestion on LessonExamQuestion {
  ...LessonExamQuestionFields
  mesg {
    ...MessageInfoFields
  }
  exam {
    ...LessonExamFields
  }
}
    ${exports.LessonExamQuestionFields}
${exports.MessageInfoFields}
${exports.LessonExamFields}`;
exports.LessonFlashcardFields = (0, graphql_tag_1.default) `
    fragment LessonFlashcardFields on LessonFlashcard {
  id
  createdAt
  updatedAt
  deletedAt
  uuid
  mesgId
  creatorUuid
  type
  unitIds
  keywords
  content
  answers
  wrongs
  explanation
  props
}
    `;
exports.LessonFlashcard = (0, graphql_tag_1.default) `
    fragment LessonFlashcard on LessonFlashcard {
  ...LessonFlashcardFields
  mesg {
    ...MessageInfoFields
  }
  creator {
    ...LessonCreatorFields
  }
}
    ${exports.LessonFlashcardFields}
${exports.MessageInfoFields}
${exports.LessonCreatorFields}`;
exports.LessonFlashcardDeckFields = (0, graphql_tag_1.default) `
    fragment LessonFlashcardDeckFields on LessonFlashcardDeck {
  id
  createdAt
  updatedAt
  deletedAt
  uuid
  creatorUuid
  type
  title
  description
  coverUrl
  difficulty
  unitIds
  cardUuids
  commerceProductId
}
    `;
exports.LessonFlashcardDeck = (0, graphql_tag_1.default) `
    fragment LessonFlashcardDeck on LessonFlashcardDeck {
  ...LessonFlashcardDeckFields
  creator {
    ...LessonCreatorFields
  }
}
    ${exports.LessonFlashcardDeckFields}
${exports.LessonCreatorFields}`;
exports.LessonItemGroupFields = (0, graphql_tag_1.default) `
    fragment LessonItemGroupFields on LessonItemGroup {
  id
  title
}
    `;
exports.LessonItemGroup = (0, graphql_tag_1.default) `
    fragment LessonItemGroup on LessonItemGroup {
  ...LessonItemGroupFields
}
    ${exports.LessonItemGroupFields}`;
exports.LessonKeywordFields = (0, graphql_tag_1.default) `
    fragment LessonKeywordFields on LessonKeyword {
  id
  createdAt
  updatedAt
  keyword
  description
  url
}
    `;
exports.LessonKeyword = (0, graphql_tag_1.default) `
    fragment LessonKeyword on LessonKeyword {
  ...LessonKeywordFields
}
    ${exports.LessonKeywordFields}`;
exports.LessonSubject = (0, graphql_tag_1.default) `
    fragment LessonSubject on LessonSubject {
  ...LessonSubjectFields
}
    ${exports.LessonSubjectFields}`;
exports.LessonUnitFields = (0, graphql_tag_1.default) `
    fragment LessonUnitFields on LessonUnit {
  id
  createdAt
  updatedAt
  index
  title
  type
  subjectId
  level
  superUnitId
}
    `;
exports.LessonUnit = (0, graphql_tag_1.default) `
    fragment LessonUnit on LessonUnit {
  ...LessonUnitFields
  subject {
    ...LessonSubjectFields
  }
  superUnit {
    ...LessonUnitFields
  }
}
    ${exports.LessonUnitFields}
${exports.LessonSubjectFields}`;
exports.LessonUser_FlashcardDeckFields = (0, graphql_tag_1.default) `
    fragment LessonUser_FlashcardDeckFields on LessonUser_FlashcardDeck {
  id
  createdAt
  updatedAt
  deletedAt
  mode
  comprehension
  progress
  lastAccessedAt
  lastCardId
  userId
  deckUuid
  commerceProductId
  commerceOrderId
}
    `;
exports.LessonUser_FlashcardDeck = (0, graphql_tag_1.default) `
    fragment LessonUser_FlashcardDeck on LessonUser_FlashcardDeck {
  ...LessonUser_FlashcardDeckFields
}
    ${exports.LessonUser_FlashcardDeckFields}`;
exports.LessonVideoFields = (0, graphql_tag_1.default) `
    fragment LessonVideoFields on LessonVideo {
  id
  createdAt
  updatedAt
  deletedAt
  uuid
  creatorUuid
  mesgId
  title
  description
  unitIds
  keywords
  type
  source
  videoId
  thumbnailUrl
  duration
  groupId
  indexInGroup
  images
  previewClip
  lessonUuid
}
    `;
exports.LessonVideo = (0, graphql_tag_1.default) `
    fragment LessonVideo on LessonVideo {
  ...LessonVideoFields
  creator {
    ...LessonCreatorFields
  }
  mesg {
    ...MessageInfoFields
  }
  group {
    ...LessonItemGroupFields
  }
  lesson {
    ...LessonVideoFields
  }
}
    ${exports.LessonVideoFields}
${exports.LessonCreatorFields}
${exports.MessageInfoFields}
${exports.LessonItemGroupFields}`;
exports.LessonWatchHistoryFields = (0, graphql_tag_1.default) `
    fragment LessonWatchHistoryFields on LessonWatchHistory {
  id
  createdAt
  updatedAt
  deletedAt
  lessonUuid
  lessonMesgId
  watchCount
  totalWatchTime
  lastWatchPosition
  userId
}
    `;
exports.LessonWatchHistory = (0, graphql_tag_1.default) `
    fragment LessonWatchHistory on LessonWatchHistory {
  ...LessonWatchHistoryFields
  lessonMesgInfo {
    ...MessageInfoFields
  }
  user {
    ...UserFields
  }
}
    ${exports.LessonWatchHistoryFields}
${exports.MessageInfoFields}
${exports.UserFields}`;
exports.LessonYouTubeUser = (0, graphql_tag_1.default) `
    fragment LessonYouTubeUser on LessonYouTubeUser {
  ...LessonYouTubeUserFields
  creator {
    ...LessonCreatorFields
  }
}
    ${exports.LessonYouTubeUserFields}
${exports.LessonCreatorFields}`;
exports.MesgNotificationFields = (0, graphql_tag_1.default) `
    fragment MesgNotificationFields on MesgNotification {
  id
  createdAt
  messageId
  chatRoomId
  userId
}
    `;
exports.MesgNotification = (0, graphql_tag_1.default) `
    fragment MesgNotification on MesgNotification {
  ...MesgNotificationFields
  user {
    ...UserFields
  }
}
    ${exports.MesgNotificationFields}
${exports.UserFields}`;
exports.MessageInfo = (0, graphql_tag_1.default) `
    fragment MessageInfo on MessageInfo {
  ...MessageInfoFields
  channel {
    ...ChannelFields
  }
  chatRoom {
    ...ChatRoomFields
  }
  jobOffer {
    ...JobOfferFields
  }
  lessonVideo {
    ...LessonVideoFields
  }
  lessonQuestion {
    ...LessonExamQuestionFields
  }
  lessonFlashcard {
    ...LessonFlashcardFields
  }
}
    ${exports.MessageInfoFields}
${exports.ChannelFields}
${exports.ChatRoomFields}
${exports.JobOfferFields}
${exports.LessonVideoFields}
${exports.LessonExamQuestionFields}
${exports.LessonFlashcardFields}`;
exports.MessageTranslationFields = (0, graphql_tag_1.default) `
    fragment MessageTranslationFields on MessageTranslation {
  id
  target
  version
  lastAccessedAt
  mesgT
  mesgId
}
    `;
exports.MessageTranslation = (0, graphql_tag_1.default) `
    fragment MessageTranslation on MessageTranslation {
  ...MessageTranslationFields
}
    ${exports.MessageTranslationFields}`;
exports.PaymentFields = (0, graphql_tag_1.default) `
    fragment PaymentFields on Payment {
  id
  amount
  amountForeign
  refunded
  refundedForeign
  currency
  exchRate
  tid
  pgVendor
  formData
  moid
  goodName
  status
  payMethod
  resultCode
  resultMsg
  eventCode
  detail
  approvedAt
  createdAt
  updatedAt
  userId
  channelId
  jobResponseId
  commerceOrderId
  subscriptionId
}
    `;
exports.PaymentAPIFailureLogFields = (0, graphql_tag_1.default) `
    fragment PaymentAPIFailureLogFields on PaymentAPIFailureLog {
  paymentId
  params
  response
  createdAt
  updatedAt
}
    `;
exports.SubscriptionFields = (0, graphql_tag_1.default) `
    fragment SubscriptionFields on Subscription {
  id
  createdAt
  updatedAt
  status
  isSandbox
  isAutoRenewal
  transactionId
  originalTransactionId
  preTransactionId
  pgVendor
  isOriginal
  purchaseToken
  userToken
  notificationId
  details
  validFrom
  validTo
  cancelledAt
  cancelReason
  priceExt
  currency
  quotaSpecs
  externalProductId
  productId
  channelId
  userId
  sellerUserId
  sellerId
}
    `;
exports.Payment = (0, graphql_tag_1.default) `
    fragment Payment on Payment {
  ...PaymentFields
  paymentAPIfailureLog {
    ...PaymentAPIFailureLogFields
  }
  user {
    ...UserFields
  }
  channel {
    ...ChannelFields
  }
  jobResponse {
    ...JobOfferResponseFields
  }
  commerceOrder {
    ...CommerceOrderFields
  }
  subscription {
    ...SubscriptionFields
  }
}
    ${exports.PaymentFields}
${exports.PaymentAPIFailureLogFields}
${exports.UserFields}
${exports.ChannelFields}
${exports.JobOfferResponseFields}
${exports.CommerceOrderFields}
${exports.SubscriptionFields}`;
exports.PaymentAPIFailureLog = (0, graphql_tag_1.default) `
    fragment PaymentAPIFailureLog on PaymentAPIFailureLog {
  ...PaymentAPIFailureLogFields
  payment {
    ...PaymentFields
  }
}
    ${exports.PaymentAPIFailureLogFields}
${exports.PaymentFields}`;
exports.PaymentIntentFields = (0, graphql_tag_1.default) `
    fragment PaymentIntentFields on PaymentIntent {
  id
  createdAt
  tid
  moid
  pgVendor
  payMethod
  userId
  userUuid
  channelId
  commerceProductId
}
    `;
exports.PaymentIntent = (0, graphql_tag_1.default) `
    fragment PaymentIntent on PaymentIntent {
  ...PaymentIntentFields
  commerceProduct {
    ...CommerceProductFields
  }
}
    ${exports.PaymentIntentFields}
${exports.CommerceProductFields}`;
exports.PaymentStatusHistoryFields = (0, graphql_tag_1.default) `
    fragment PaymentStatusHistoryFields on PaymentStatusHistory {
  id
  paymentId
  status
  amount
  createdAt
  updatedAt
}
    `;
exports.PaymentStatusHistory = (0, graphql_tag_1.default) `
    fragment PaymentStatusHistory on PaymentStatusHistory {
  ...PaymentStatusHistoryFields
  payment {
    ...PaymentFields
  }
}
    ${exports.PaymentStatusHistoryFields}
${exports.PaymentFields}`;
exports.PlaceFields = (0, graphql_tag_1.default) `
    fragment PlaceFields on Place {
  id
  createdAt
  updatedAt
  category
  subCategory
  name
  description
  props
  longitude
  latitude
  address
  region
  channelId
}
    `;
exports.Place = (0, graphql_tag_1.default) `
    fragment Place on Place {
  ...PlaceFields
}
    ${exports.PlaceFields}`;
exports.PluginFields = (0, graphql_tag_1.default) `
    fragment PluginFields on Plugin {
  id
  uuid
  title
  type
  seq
  submitAt
  approvedAt
  rejectedAt
  rejectReason
  version
  channelId
}
    `;
exports.Plugin = (0, graphql_tag_1.default) `
    fragment Plugin on Plugin {
  ...PluginFields
  channel {
    ...ChannelFields
  }
}
    ${exports.PluginFields}
${exports.ChannelFields}`;
exports.ProductFields = (0, graphql_tag_1.default) `
    fragment ProductFields on Product {
  id
  type
  name
  desc
  cat
  sub
  priceExt
  currency
  duration
  extraTerms
  channelId
  price
}
    `;
exports.Product = (0, graphql_tag_1.default) `
    fragment Product on Product {
  ...ProductFields
  channel {
    ...ChannelFields
  }
}
    ${exports.ProductFields}
${exports.ChannelFields}`;
exports.Profile = (0, graphql_tag_1.default) `
    fragment Profile on Profile {
  ...ProfileFields
  user {
    ...UserFields
  }
  lessonCreator {
    ...LessonCreatorFields
  }
}
    ${exports.ProfileFields}
${exports.UserFields}
${exports.LessonCreatorFields}`;
exports.ProfileChannel_UserFields = (0, graphql_tag_1.default) `
    fragment ProfileChannel_UserFields on ProfileChannel_User {
  id
  createdAt
  viewCount
  firstViewAt
  latestViewAt
  channelId
  userId
  profileChannelId
}
    `;
exports.ProfileChannel_User = (0, graphql_tag_1.default) `
    fragment ProfileChannel_User on ProfileChannel_User {
  ...ProfileChannel_UserFields
  channel {
    ...ChannelFields
  }
  user {
    ...UserFields
  }
  profileChannel {
    ...Profile_ChannelFields
  }
}
    ${exports.ProfileChannel_UserFields}
${exports.ChannelFields}
${exports.UserFields}
${exports.Profile_ChannelFields}`;
exports.ProfileInfoFields = (0, graphql_tag_1.default) `
    fragment ProfileInfoFields on ProfileInfo {
  id
  type
  data
  profileId
}
    `;
exports.ProfileInfo = (0, graphql_tag_1.default) `
    fragment ProfileInfo on ProfileInfo {
  ...ProfileInfoFields
  profile {
    ...ProfileFields
  }
}
    ${exports.ProfileInfoFields}
${exports.ProfileFields}`;
exports.ProfileReviewFields = (0, graphql_tag_1.default) `
    fragment ProfileReviewFields on ProfileReview {
  id
  createdAt
  type
  role
  predefinedCode
  description
  reviewerId
  revieweeId
}
    `;
exports.ProfileReview = (0, graphql_tag_1.default) `
    fragment ProfileReview on ProfileReview {
  ...ProfileReviewFields
  reviewer {
    ...ProfileFields
  }
  reviewee {
    ...ProfileFields
  }
}
    ${exports.ProfileReviewFields}
${exports.ProfileFields}`;
exports.Profile_Channel = (0, graphql_tag_1.default) `
    fragment Profile_Channel on Profile_Channel {
  ...Profile_ChannelFields
  profile {
    ...ProfileFields
  }
  channel {
    ...ChannelFields
  }
  user {
    ...UserFields
  }
}
    ${exports.Profile_ChannelFields}
${exports.ProfileFields}
${exports.ChannelFields}
${exports.UserFields}`;
exports.Profile_ChannelActivityFields = (0, graphql_tag_1.default) `
    fragment Profile_ChannelActivityFields on Profile_ChannelActivity {
  id
  point
  pointSpent
  level
  followerCount
  referCount
  postCount
  attendCount
  ratingCount
  reviewCount
  customPoint
  resetAt
  pointTerm
  recentFollowerCount
  recentReferCount
  recentPostCount
  recentAttendCount
  recentRatingCount
  recentReviewCount
  latestPointAt
  props
  channelId
  userId
  profileChannelId
  subscProductId
}
    `;
exports.Profile_ChannelActivity = (0, graphql_tag_1.default) `
    fragment Profile_ChannelActivity on Profile_ChannelActivity {
  ...Profile_ChannelActivityFields
  profileChannel {
    ...Profile_ChannelFields
  }
  subscProduct {
    ...CommerceProductFields
  }
}
    ${exports.Profile_ChannelActivityFields}
${exports.Profile_ChannelFields}
${exports.CommerceProductFields}`;
exports.Profile_ChatRoomFields = (0, graphql_tag_1.default) `
    fragment Profile_ChatRoomFields on Profile_ChatRoom {
  id
  role
  profileId
  chatRoomId
  userId
}
    `;
exports.Profile_ChatRoom = (0, graphql_tag_1.default) `
    fragment Profile_ChatRoom on Profile_ChatRoom {
  ...Profile_ChatRoomFields
  profile {
    ...ProfileFields
  }
  chatRoom {
    ...ChatRoomFields
  }
  user {
    ...UserFields
  }
}
    ${exports.Profile_ChatRoomFields}
${exports.ProfileFields}
${exports.ChatRoomFields}
${exports.UserFields}`;
exports.QuotaFields = (0, graphql_tag_1.default) `
    fragment QuotaFields on Quota {
  id
  createdAt
  updatedAt
  channelId
  userId
  type
  validFrom
  validTo
  revokedAt
  limit
  preUsed
  balance
  subscriptionId
}
    `;
exports.Quota = (0, graphql_tag_1.default) `
    fragment Quota on Quota {
  ...QuotaFields
}
    ${exports.QuotaFields}`;
exports.QuotaUsageFields = (0, graphql_tag_1.default) `
    fragment QuotaUsageFields on QuotaUsage {
  id
  createdAt
  channelId
  userId
  type
  itemId
  amount
  quotaId
}
    `;
exports.QuotaUsage = (0, graphql_tag_1.default) `
    fragment QuotaUsage on QuotaUsage {
  ...QuotaUsageFields
}
    ${exports.QuotaUsageFields}`;
exports.Reaction = (0, graphql_tag_1.default) `
    fragment Reaction on Reaction {
  ...ReactionFields
  user {
    ...UserFields
  }
  targetUser {
    ...UserFields
  }
  parentReaction {
    ...ReactionFields
  }
  channel {
    ...ChannelFields
  }
  chatRoom {
    ...ChatRoomFields
  }
}
    ${exports.ReactionFields}
${exports.UserFields}
${exports.ChannelFields}
${exports.ChatRoomFields}`;
exports.ReportActionFields = (0, graphql_tag_1.default) `
    fragment ReportActionFields on ReportAction {
  id
  createdAt
  description
  abusingReportId
  penaltyId
}
    `;
exports.UserPenaltyFields = (0, graphql_tag_1.default) `
    fragment UserPenaltyFields on UserPenalty {
  id
  createdAt
  type
  hours
  props
  reason
  acknowledgedAt
  userId
}
    `;
exports.ReportAction = (0, graphql_tag_1.default) `
    fragment ReportAction on ReportAction {
  ...ReportActionFields
  abusingReport {
    ...AbusingReportFields
  }
  penalty {
    ...UserPenaltyFields
  }
}
    ${exports.ReportActionFields}
${exports.AbusingReportFields}
${exports.UserPenaltyFields}`;
exports.SearchWordFields = (0, graphql_tag_1.default) `
    fragment SearchWordFields on SearchWord {
  id
  createdAt
  words
  userId
}
    `;
exports.SearchWord = (0, graphql_tag_1.default) `
    fragment SearchWord on SearchWord {
  ...SearchWordFields
  user {
    ...UserFields
  }
}
    ${exports.SearchWordFields}
${exports.UserFields}`;
exports.SecretFields = (0, graphql_tag_1.default) `
    fragment SecretFields on Secret {
  id
  key
  value
}
    `;
exports.Secret = (0, graphql_tag_1.default) `
    fragment Secret on Secret {
  ...SecretFields
}
    ${exports.SecretFields}`;
exports.ServerErrorFields = (0, graphql_tag_1.default) `
    fragment ServerErrorFields on ServerError {
  id
  createdAt
  type
  message
}
    `;
exports.ServerError = (0, graphql_tag_1.default) `
    fragment ServerError on ServerError {
  ...ServerErrorFields
}
    ${exports.ServerErrorFields}`;
exports.Settlement = (0, graphql_tag_1.default) `
    fragment Settlement on Settlement {
  ...SettlementFields
  channel {
    ...ChannelFields
  }
  user {
    ...UserFields
  }
  profile {
    ...ProfileFields
  }
}
    ${exports.SettlementFields}
${exports.ChannelFields}
${exports.UserFields}
${exports.ProfileFields}`;
exports.SettlementItem = (0, graphql_tag_1.default) `
    fragment SettlementItem on SettlementItem {
  ...SettlementItemFields
  jrsp {
    ...JobOfferResponseFields
  }
  jobOffer {
    ...JobOfferFields
  }
  commerceOrder {
    ...CommerceOrderFields
  }
  commerceProduct {
    ...CommerceProductFields
  }
  subscription {
    ...SubscriptionFields
  }
  settlement {
    ...SettlementFields
  }
  channel {
    ...ChannelFields
  }
  user {
    ...UserFields
  }
}
    ${exports.SettlementItemFields}
${exports.JobOfferResponseFields}
${exports.JobOfferFields}
${exports.CommerceOrderFields}
${exports.CommerceProductFields}
${exports.SubscriptionFields}
${exports.SettlementFields}
${exports.ChannelFields}
${exports.UserFields}`;
exports.SignInFields = (0, graphql_tag_1.default) `
    fragment SignInFields on SignIn {
  id
  deviceType
  deviceId
  token
  validUntil
  userId
}
    `;
exports.SignIn = (0, graphql_tag_1.default) `
    fragment SignIn on SignIn {
  ...SignInFields
  user {
    ...UserFields
  }
}
    ${exports.SignInFields}
${exports.UserFields}`;
exports.SignInTelVerificationFields = (0, graphql_tag_1.default) `
    fragment SignInTelVerificationFields on SignInTelVerification {
  id
  tel
  code
  validUntil
  count
}
    `;
exports.SignInTelVerification = (0, graphql_tag_1.default) `
    fragment SignInTelVerification on SignInTelVerification {
  ...SignInTelVerificationFields
}
    ${exports.SignInTelVerificationFields}`;
exports.Subscription = (0, graphql_tag_1.default) `
    fragment Subscription on Subscription {
  ...SubscriptionFields
  product {
    ...CommerceProductFields
  }
  seller {
    ...ProfileFields
  }
  settleItem {
    ...SettlementItemFields
  }
}
    ${exports.SubscriptionFields}
${exports.CommerceProductFields}
${exports.ProfileFields}
${exports.SettlementItemFields}`;
exports.SubscriptionHistoryFields = (0, graphql_tag_1.default) `
    fragment SubscriptionHistoryFields on SubscriptionHistory {
  id
  hId
  hValidFrom
  hValidTo
  hPreId
  createdAt
  updatedAt
  status
  isSandbox
  isAutoRenewal
  transactionId
  originalTransactionId
  preTransactionId
  pgVendor
  isOriginal
  purchaseToken
  userToken
  notificationId
  details
  validFrom
  validTo
  cancelledAt
  cancelReason
  priceExt
  currency
  quotaSpecs
  externalProductId
  productId
  product
  channelId
  userId
  sellerUserId
  sellerId
  seller
  payments
  settleItem
}
    `;
exports.SubscriptionHistory = (0, graphql_tag_1.default) `
    fragment SubscriptionHistory on SubscriptionHistory {
  ...SubscriptionHistoryFields
}
    ${exports.SubscriptionHistoryFields}`;
exports.SysInfoFields = (0, graphql_tag_1.default) `
    fragment SysInfoFields on SysInfo {
  id
  pluginUrlTemplate
  categories
  versionIos
  versionAndroid
  ext
  forex
  commission
  companyInfo
}
    `;
exports.SysInfo = (0, graphql_tag_1.default) `
    fragment SysInfo on SysInfo {
  ...SysInfoFields
}
    ${exports.SysInfoFields}`;
exports.SysNoticeFields = (0, graphql_tag_1.default) `
    fragment SysNoticeFields on SysNotice {
  id
  createdAt
  isImportant
  subject
  content
  html
  channelId
}
    `;
exports.SysNotice = (0, graphql_tag_1.default) `
    fragment SysNotice on SysNotice {
  ...SysNoticeFields
}
    ${exports.SysNoticeFields}`;
exports.SysNotificationFields = (0, graphql_tag_1.default) `
    fragment SysNotificationFields on SysNotification {
  id
  createdAt
  type
  info
  receiverId
  receiverUserId
  channelId
}
    `;
exports.SysNotification = (0, graphql_tag_1.default) `
    fragment SysNotification on SysNotification {
  ...SysNotificationFields
  receiver {
    ...ProfileFields
  }
  receiverUser {
    ...UserFields
  }
  channel {
    ...ChannelFields
  }
}
    ${exports.SysNotificationFields}
${exports.ProfileFields}
${exports.UserFields}
${exports.ChannelFields}`;
exports.SysPictureFields = (0, graphql_tag_1.default) `
    fragment SysPictureFields on SysPicture {
  id
  type
  url
  thumbnailId
}
    `;
exports.SysPicture = (0, graphql_tag_1.default) `
    fragment SysPicture on SysPicture {
  ...SysPictureFields
}
    ${exports.SysPictureFields}`;
exports.ThumbnailFields = (0, graphql_tag_1.default) `
    fragment ThumbnailFields on Thumbnail {
  id
  data
}
    `;
exports.Thumbnail = (0, graphql_tag_1.default) `
    fragment Thumbnail on Thumbnail {
  ...ThumbnailFields
}
    ${exports.ThumbnailFields}`;
exports.UrlMetadataFields = (0, graphql_tag_1.default) `
    fragment UrlMetadataFields on UrlMetadata {
  id
  createdAt
  url
  data
}
    `;
exports.UrlMetadata = (0, graphql_tag_1.default) `
    fragment UrlMetadata on UrlMetadata {
  ...UrlMetadataFields
}
    ${exports.UrlMetadataFields}`;
exports.User = (0, graphql_tag_1.default) `
    fragment User on User {
  ...UserFields
  Channel {
    ...ChannelFields
  }
  lessonCreator {
    ...LessonCreatorFields
  }
}
    ${exports.UserFields}
${exports.ChannelFields}
${exports.LessonCreatorFields}`;
exports.UserAdActionFields = (0, graphql_tag_1.default) `
    fragment UserAdActionFields on UserAdAction {
  id
  createdAt
  action
  refererId
  adId
  userId
}
    `;
exports.UserAdAction = (0, graphql_tag_1.default) `
    fragment UserAdAction on UserAdAction {
  ...UserAdActionFields
  ad {
    ...AdvertisementFields
  }
  user {
    ...UserFields
  }
}
    ${exports.UserAdActionFields}
${exports.AdvertisementFields}
${exports.UserFields}`;
exports.UserBlockingFields = (0, graphql_tag_1.default) `
    fragment UserBlockingFields on UserBlocking {
  id
  createdAt
  blockerId
  blockeeId
  blockeeProfileId
}
    `;
exports.UserBlocking = (0, graphql_tag_1.default) `
    fragment UserBlocking on UserBlocking {
  ...UserBlockingFields
  blocker {
    ...UserFields
  }
  blockee {
    ...UserFields
  }
  blockeeProfile {
    ...ProfileFields
  }
}
    ${exports.UserBlockingFields}
${exports.UserFields}
${exports.ProfileFields}`;
exports.UserChannelAccountFields = (0, graphql_tag_1.default) `
    fragment UserChannelAccountFields on UserChannelAccount {
  id
  createdAt
  updatedAt
  balance
  provision
  channelId
  userId
}
    `;
exports.UserChannelAccount = (0, graphql_tag_1.default) `
    fragment UserChannelAccount on UserChannelAccount {
  ...UserChannelAccountFields
  user {
    ...UserFields
  }
}
    ${exports.UserChannelAccountFields}
${exports.UserFields}`;
exports.UserIdentityFields = (0, graphql_tag_1.default) `
    fragment UserIdentityFields on UserIdentity {
  id
  name
  idNo
  tel
}
    `;
exports.UserIdentity = (0, graphql_tag_1.default) `
    fragment UserIdentity on UserIdentity {
  ...UserIdentityFields
}
    ${exports.UserIdentityFields}`;
exports.UserKeywordFields = (0, graphql_tag_1.default) `
    fragment UserKeywordFields on UserKeyword {
  id
  keywords
  locations
  userId
}
    `;
exports.UserKeyword = (0, graphql_tag_1.default) `
    fragment UserKeyword on UserKeyword {
  ...UserKeywordFields
  user {
    ...UserFields
  }
}
    ${exports.UserKeywordFields}
${exports.UserFields}`;
exports.UserLogFields = (0, graphql_tag_1.default) `
    fragment UserLogFields on UserLog {
  id
  createdAt
  type
  body
  userId
  uuid
}
    `;
exports.UserLog = (0, graphql_tag_1.default) `
    fragment UserLog on UserLog {
  ...UserLogFields
  user {
    ...UserFields
  }
}
    ${exports.UserLogFields}
${exports.UserFields}`;
exports.UserPenalty = (0, graphql_tag_1.default) `
    fragment UserPenalty on UserPenalty {
  ...UserPenaltyFields
  user {
    ...UserFields
  }
}
    ${exports.UserPenaltyFields}
${exports.UserFields}`;
exports.UserPointLogFields = (0, graphql_tag_1.default) `
    fragment UserPointLogFields on UserPointLog {
  id
  createdAt
  channelId
  point
  reason
  userId
}
    `;
exports.UserPointLog = (0, graphql_tag_1.default) `
    fragment UserPointLog on UserPointLog {
  ...UserPointLogFields
  user {
    ...UserFields
  }
}
    ${exports.UserPointLogFields}
${exports.UserFields}`;
exports.UserPointWithdrawRequestFields = (0, graphql_tag_1.default) `
    fragment UserPointWithdrawRequestFields on UserPointWithdrawRequest {
  id
  createdAt
  point
  withdrewAt
  canceledAt
  note
  userId
  channelId
}
    `;
exports.UserPointWithdrawRequest = (0, graphql_tag_1.default) `
    fragment UserPointWithdrawRequest on UserPointWithdrawRequest {
  ...UserPointWithdrawRequestFields
  user {
    ...UserFields
  }
  channel {
    ...ChannelFields
  }
}
    ${exports.UserPointWithdrawRequestFields}
${exports.UserFields}
${exports.ChannelFields}`;
exports.UserUsageFields = (0, graphql_tag_1.default) `
    fragment UserUsageFields on UserUsage {
  id
  data
}
    `;
exports.UserUsage = (0, graphql_tag_1.default) `
    fragment UserUsage on UserUsage {
  ...UserUsageFields
}
    ${exports.UserUsageFields}`;
exports.User_ChatRoomViewFields = (0, graphql_tag_1.default) `
    fragment User_ChatRoomViewFields on User_ChatRoomView {
  id
  filter
  lastMessageId
  lastMessageSeq
  lastAccessedAt
  updatedAt
  userId
  chatRoomId
}
    `;
exports.User_ChatRoomView = (0, graphql_tag_1.default) `
    fragment User_ChatRoomView on User_ChatRoomView {
  ...User_ChatRoomViewFields
  user {
    ...UserFields
  }
  chatRoom {
    ...ChatRoomFields
  }
}
    ${exports.User_ChatRoomViewFields}
${exports.UserFields}
${exports.ChatRoomFields}`;
exports.User_ProfileFields = (0, graphql_tag_1.default) `
    fragment User_ProfileFields on User_Profile {
  id
  access
  userId
  profileId
}
    `;
exports.User_Profile = (0, graphql_tag_1.default) `
    fragment User_Profile on User_Profile {
  ...User_ProfileFields
  user {
    ...UserFields
  }
  profile {
    ...ProfileFields
  }
}
    ${exports.User_ProfileFields}
${exports.UserFields}
${exports.ProfileFields}`;
exports.VersionChangeFields = (0, graphql_tag_1.default) `
    fragment VersionChangeFields on VersionChange {
  id
  version
  changes
  bugs
  changesEn
  bugsEn
  break
}
    `;
exports.VersionChange = (0, graphql_tag_1.default) `
    fragment VersionChange on VersionChange {
  ...VersionChangeFields
}
    ${exports.VersionChangeFields}`;
exports.findUniqueAbusingReport = (0, graphql_tag_1.default) `
    query findUniqueAbusingReport($where: AbusingReportWhereUniqueInput!) {
  findUniqueAbusingReport(where: $where) {
    ...AbusingReport
  }
}
    ${exports.AbusingReport}`;
exports.findManyAbusingReport = (0, graphql_tag_1.default) `
    query findManyAbusingReport($where: AbusingReportWhereInput, $orderBy: [AbusingReportOrderByWithRelationInput!], $cursor: AbusingReportWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAbusingReport(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...AbusingReport
  }
}
    ${exports.AbusingReport}`;
exports.findManyAbusingReportCount = (0, graphql_tag_1.default) `
    query findManyAbusingReportCount($where: AbusingReportWhereInput, $orderBy: [AbusingReportOrderByWithRelationInput!], $cursor: AbusingReportWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAbusingReportCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneAbusingReport = (0, graphql_tag_1.default) `
    mutation createOneAbusingReport($data: AbusingReportCreateInput!) {
  createOneAbusingReport(data: $data) {
    ...AbusingReport
  }
}
    ${exports.AbusingReport}`;
exports.updateOneAbusingReport = (0, graphql_tag_1.default) `
    mutation updateOneAbusingReport($where: AbusingReportWhereUniqueInput!, $data: AbusingReportUpdateInput!) {
  updateOneAbusingReport(where: $where, data: $data) {
    ...AbusingReport
  }
}
    ${exports.AbusingReport}`;
exports.deleteOneAbusingReport = (0, graphql_tag_1.default) `
    mutation deleteOneAbusingReport($where: AbusingReportWhereUniqueInput!) {
  deleteOneAbusingReport(where: $where) {
    ...AbusingReport
  }
}
    ${exports.AbusingReport}`;
exports.deleteManyAbusingReport = (0, graphql_tag_1.default) `
    mutation deleteManyAbusingReport($where: AbusingReportWhereInput) {
  deleteManyAbusingReport(where: $where) {
    count
  }
}
    `;
exports.updateManyAbusingReport = (0, graphql_tag_1.default) `
    mutation updateManyAbusingReport($where: AbusingReportWhereInput, $data: AbusingReportUpdateManyMutationInput!) {
  updateManyAbusingReport(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueAccountInfo = (0, graphql_tag_1.default) `
    query findUniqueAccountInfo($where: AccountInfoWhereUniqueInput!) {
  findUniqueAccountInfo(where: $where) {
    ...AccountInfo
  }
}
    ${exports.AccountInfo}`;
exports.findManyAccountInfoCount = (0, graphql_tag_1.default) `
    query findManyAccountInfoCount($where: AccountInfoWhereInput, $orderBy: [AccountInfoOrderByWithRelationInput!], $cursor: AccountInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAccountInfoCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.findUniqueAdvertisement = (0, graphql_tag_1.default) `
    query findUniqueAdvertisement($where: AdvertisementWhereUniqueInput!) {
  findUniqueAdvertisement(where: $where) {
    ...Advertisement
  }
}
    ${exports.Advertisement}`;
exports.findManyAdvertisement = (0, graphql_tag_1.default) `
    query findManyAdvertisement($where: AdvertisementWhereInput, $orderBy: [AdvertisementOrderByWithRelationInput!], $cursor: AdvertisementWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAdvertisement(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Advertisement
  }
}
    ${exports.Advertisement}`;
exports.findManyAdvertisementCount = (0, graphql_tag_1.default) `
    query findManyAdvertisementCount($where: AdvertisementWhereInput, $orderBy: [AdvertisementOrderByWithRelationInput!], $cursor: AdvertisementWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAdvertisementCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneAdvertisement = (0, graphql_tag_1.default) `
    mutation createOneAdvertisement($data: AdvertisementCreateInput!) {
  createOneAdvertisement(data: $data) {
    ...Advertisement
  }
}
    ${exports.Advertisement}`;
exports.updateOneAdvertisement = (0, graphql_tag_1.default) `
    mutation updateOneAdvertisement($where: AdvertisementWhereUniqueInput!, $data: AdvertisementUpdateInput!) {
  updateOneAdvertisement(where: $where, data: $data) {
    ...Advertisement
  }
}
    ${exports.Advertisement}`;
exports.deleteOneAdvertisement = (0, graphql_tag_1.default) `
    mutation deleteOneAdvertisement($where: AdvertisementWhereUniqueInput!) {
  deleteOneAdvertisement(where: $where) {
    ...Advertisement
  }
}
    ${exports.Advertisement}`;
exports.deleteManyAdvertisement = (0, graphql_tag_1.default) `
    mutation deleteManyAdvertisement($where: AdvertisementWhereInput) {
  deleteManyAdvertisement(where: $where) {
    count
  }
}
    `;
exports.updateManyAdvertisement = (0, graphql_tag_1.default) `
    mutation updateManyAdvertisement($where: AdvertisementWhereInput, $data: AdvertisementUpdateManyMutationInput!) {
  updateManyAdvertisement(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueAdvertiser = (0, graphql_tag_1.default) `
    query findUniqueAdvertiser($where: AdvertiserWhereUniqueInput!) {
  findUniqueAdvertiser(where: $where) {
    ...Advertiser
  }
}
    ${exports.Advertiser}`;
exports.findManyAdvertiser = (0, graphql_tag_1.default) `
    query findManyAdvertiser($where: AdvertiserWhereInput, $orderBy: [AdvertiserOrderByWithRelationInput!], $cursor: AdvertiserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAdvertiser(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Advertiser
  }
}
    ${exports.Advertiser}`;
exports.findManyAdvertiserCount = (0, graphql_tag_1.default) `
    query findManyAdvertiserCount($where: AdvertiserWhereInput, $orderBy: [AdvertiserOrderByWithRelationInput!], $cursor: AdvertiserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAdvertiserCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneAdvertiser = (0, graphql_tag_1.default) `
    mutation createOneAdvertiser($data: AdvertiserCreateInput!) {
  createOneAdvertiser(data: $data) {
    ...Advertiser
  }
}
    ${exports.Advertiser}`;
exports.updateOneAdvertiser = (0, graphql_tag_1.default) `
    mutation updateOneAdvertiser($where: AdvertiserWhereUniqueInput!, $data: AdvertiserUpdateInput!) {
  updateOneAdvertiser(where: $where, data: $data) {
    ...Advertiser
  }
}
    ${exports.Advertiser}`;
exports.deleteOneAdvertiser = (0, graphql_tag_1.default) `
    mutation deleteOneAdvertiser($where: AdvertiserWhereUniqueInput!) {
  deleteOneAdvertiser(where: $where) {
    ...Advertiser
  }
}
    ${exports.Advertiser}`;
exports.deleteManyAdvertiser = (0, graphql_tag_1.default) `
    mutation deleteManyAdvertiser($where: AdvertiserWhereInput) {
  deleteManyAdvertiser(where: $where) {
    count
  }
}
    `;
exports.updateManyAdvertiser = (0, graphql_tag_1.default) `
    mutation updateManyAdvertiser($where: AdvertiserWhereInput, $data: AdvertiserUpdateManyMutationInput!) {
  updateManyAdvertiser(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueAiChatMessage = (0, graphql_tag_1.default) `
    query findUniqueAiChatMessage($where: AiChatMessageWhereUniqueInput!) {
  findUniqueAiChatMessage(where: $where) {
    ...AiChatMessage
  }
}
    ${exports.AiChatMessage}`;
exports.findManyAiChatMessage = (0, graphql_tag_1.default) `
    query findManyAiChatMessage($where: AiChatMessageWhereInput, $orderBy: [AiChatMessageOrderByWithRelationInput!], $cursor: AiChatMessageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAiChatMessage(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...AiChatMessage
  }
}
    ${exports.AiChatMessage}`;
exports.findManyAiChatMessageCount = (0, graphql_tag_1.default) `
    query findManyAiChatMessageCount($where: AiChatMessageWhereInput, $orderBy: [AiChatMessageOrderByWithRelationInput!], $cursor: AiChatMessageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAiChatMessageCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneAiChatMessage = (0, graphql_tag_1.default) `
    mutation createOneAiChatMessage($data: AiChatMessageCreateInput!) {
  createOneAiChatMessage(data: $data) {
    ...AiChatMessage
  }
}
    ${exports.AiChatMessage}`;
exports.updateOneAiChatMessage = (0, graphql_tag_1.default) `
    mutation updateOneAiChatMessage($where: AiChatMessageWhereUniqueInput!, $data: AiChatMessageUpdateInput!) {
  updateOneAiChatMessage(where: $where, data: $data) {
    ...AiChatMessage
  }
}
    ${exports.AiChatMessage}`;
exports.deleteOneAiChatMessage = (0, graphql_tag_1.default) `
    mutation deleteOneAiChatMessage($where: AiChatMessageWhereUniqueInput!) {
  deleteOneAiChatMessage(where: $where) {
    ...AiChatMessage
  }
}
    ${exports.AiChatMessage}`;
exports.deleteManyAiChatMessage = (0, graphql_tag_1.default) `
    mutation deleteManyAiChatMessage($where: AiChatMessageWhereInput) {
  deleteManyAiChatMessage(where: $where) {
    count
  }
}
    `;
exports.updateManyAiChatMessage = (0, graphql_tag_1.default) `
    mutation updateManyAiChatMessage($where: AiChatMessageWhereInput, $data: AiChatMessageUpdateManyMutationInput!) {
  updateManyAiChatMessage(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueAiChatRoom = (0, graphql_tag_1.default) `
    query findUniqueAiChatRoom($where: AiChatRoomWhereUniqueInput!) {
  findUniqueAiChatRoom(where: $where) {
    ...AiChatRoom
  }
}
    ${exports.AiChatRoom}`;
exports.findManyAiChatRoom = (0, graphql_tag_1.default) `
    query findManyAiChatRoom($where: AiChatRoomWhereInput, $orderBy: [AiChatRoomOrderByWithRelationInput!], $cursor: AiChatRoomWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAiChatRoom(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...AiChatRoom
  }
}
    ${exports.AiChatRoom}`;
exports.findManyAiChatRoomCount = (0, graphql_tag_1.default) `
    query findManyAiChatRoomCount($where: AiChatRoomWhereInput, $orderBy: [AiChatRoomOrderByWithRelationInput!], $cursor: AiChatRoomWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAiChatRoomCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneAiChatRoom = (0, graphql_tag_1.default) `
    mutation createOneAiChatRoom($data: AiChatRoomCreateInput!) {
  createOneAiChatRoom(data: $data) {
    ...AiChatRoom
  }
}
    ${exports.AiChatRoom}`;
exports.updateOneAiChatRoom = (0, graphql_tag_1.default) `
    mutation updateOneAiChatRoom($where: AiChatRoomWhereUniqueInput!, $data: AiChatRoomUpdateInput!) {
  updateOneAiChatRoom(where: $where, data: $data) {
    ...AiChatRoom
  }
}
    ${exports.AiChatRoom}`;
exports.deleteOneAiChatRoom = (0, graphql_tag_1.default) `
    mutation deleteOneAiChatRoom($where: AiChatRoomWhereUniqueInput!) {
  deleteOneAiChatRoom(where: $where) {
    ...AiChatRoom
  }
}
    ${exports.AiChatRoom}`;
exports.deleteManyAiChatRoom = (0, graphql_tag_1.default) `
    mutation deleteManyAiChatRoom($where: AiChatRoomWhereInput) {
  deleteManyAiChatRoom(where: $where) {
    count
  }
}
    `;
exports.updateManyAiChatRoom = (0, graphql_tag_1.default) `
    mutation updateManyAiChatRoom($where: AiChatRoomWhereInput, $data: AiChatRoomUpdateManyMutationInput!) {
  updateManyAiChatRoom(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueAppInfo = (0, graphql_tag_1.default) `
    query findUniqueAppInfo($where: AppInfoWhereUniqueInput!) {
  findUniqueAppInfo(where: $where) {
    ...AppInfo
  }
}
    ${exports.AppInfo}`;
exports.findManyAppInfo = (0, graphql_tag_1.default) `
    query findManyAppInfo($where: AppInfoWhereInput, $orderBy: [AppInfoOrderByWithRelationInput!], $cursor: AppInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAppInfo(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...AppInfo
  }
}
    ${exports.AppInfo}`;
exports.findManyAppInfoCount = (0, graphql_tag_1.default) `
    query findManyAppInfoCount($where: AppInfoWhereInput, $orderBy: [AppInfoOrderByWithRelationInput!], $cursor: AppInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAppInfoCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneAppInfo = (0, graphql_tag_1.default) `
    mutation createOneAppInfo($data: AppInfoCreateInput!) {
  createOneAppInfo(data: $data) {
    ...AppInfo
  }
}
    ${exports.AppInfo}`;
exports.updateOneAppInfo = (0, graphql_tag_1.default) `
    mutation updateOneAppInfo($where: AppInfoWhereUniqueInput!, $data: AppInfoUpdateInput!) {
  updateOneAppInfo(where: $where, data: $data) {
    ...AppInfo
  }
}
    ${exports.AppInfo}`;
exports.deleteOneAppInfo = (0, graphql_tag_1.default) `
    mutation deleteOneAppInfo($where: AppInfoWhereUniqueInput!) {
  deleteOneAppInfo(where: $where) {
    ...AppInfo
  }
}
    ${exports.AppInfo}`;
exports.deleteManyAppInfo = (0, graphql_tag_1.default) `
    mutation deleteManyAppInfo($where: AppInfoWhereInput) {
  deleteManyAppInfo(where: $where) {
    count
  }
}
    `;
exports.updateManyAppInfo = (0, graphql_tag_1.default) `
    mutation updateManyAppInfo($where: AppInfoWhereInput, $data: AppInfoUpdateManyMutationInput!) {
  updateManyAppInfo(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueApplications = (0, graphql_tag_1.default) `
    query findUniqueApplications($where: ApplicationsWhereUniqueInput!) {
  findUniqueApplications(where: $where) {
    ...Applications
  }
}
    ${exports.Applications}`;
exports.findManyApplications = (0, graphql_tag_1.default) `
    query findManyApplications($where: ApplicationsWhereInput, $orderBy: [ApplicationsOrderByWithRelationInput!], $cursor: ApplicationsWhereUniqueInput, $skip: Int, $take: Int) {
  findManyApplications(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Applications
  }
}
    ${exports.Applications}`;
exports.findManyApplicationsCount = (0, graphql_tag_1.default) `
    query findManyApplicationsCount($where: ApplicationsWhereInput, $orderBy: [ApplicationsOrderByWithRelationInput!], $cursor: ApplicationsWhereUniqueInput, $skip: Int, $take: Int) {
  findManyApplicationsCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneApplications = (0, graphql_tag_1.default) `
    mutation createOneApplications($data: ApplicationsCreateInput!) {
  createOneApplications(data: $data) {
    ...Applications
  }
}
    ${exports.Applications}`;
exports.updateOneApplications = (0, graphql_tag_1.default) `
    mutation updateOneApplications($where: ApplicationsWhereUniqueInput!, $data: ApplicationsUpdateInput!) {
  updateOneApplications(where: $where, data: $data) {
    ...Applications
  }
}
    ${exports.Applications}`;
exports.deleteOneApplications = (0, graphql_tag_1.default) `
    mutation deleteOneApplications($where: ApplicationsWhereUniqueInput!) {
  deleteOneApplications(where: $where) {
    ...Applications
  }
}
    ${exports.Applications}`;
exports.deleteManyApplications = (0, graphql_tag_1.default) `
    mutation deleteManyApplications($where: ApplicationsWhereInput) {
  deleteManyApplications(where: $where) {
    count
  }
}
    `;
exports.updateManyApplications = (0, graphql_tag_1.default) `
    mutation updateManyApplications($where: ApplicationsWhereInput, $data: ApplicationsUpdateManyMutationInput!) {
  updateManyApplications(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueAttachment = (0, graphql_tag_1.default) `
    query findUniqueAttachment($where: AttachmentWhereUniqueInput!) {
  findUniqueAttachment(where: $where) {
    ...Attachment
  }
}
    ${exports.Attachment}`;
exports.findManyAttachment = (0, graphql_tag_1.default) `
    query findManyAttachment($where: AttachmentWhereInput, $orderBy: [AttachmentOrderByWithRelationInput!], $cursor: AttachmentWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAttachment(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Attachment
  }
}
    ${exports.Attachment}`;
exports.findManyAttachmentCount = (0, graphql_tag_1.default) `
    query findManyAttachmentCount($where: AttachmentWhereInput, $orderBy: [AttachmentOrderByWithRelationInput!], $cursor: AttachmentWhereUniqueInput, $skip: Int, $take: Int) {
  findManyAttachmentCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneAttachment = (0, graphql_tag_1.default) `
    mutation createOneAttachment($data: AttachmentCreateInput!) {
  createOneAttachment(data: $data) {
    ...Attachment
  }
}
    ${exports.Attachment}`;
exports.updateOneAttachment = (0, graphql_tag_1.default) `
    mutation updateOneAttachment($where: AttachmentWhereUniqueInput!, $data: AttachmentUpdateInput!) {
  updateOneAttachment(where: $where, data: $data) {
    ...Attachment
  }
}
    ${exports.Attachment}`;
exports.deleteOneAttachment = (0, graphql_tag_1.default) `
    mutation deleteOneAttachment($where: AttachmentWhereUniqueInput!) {
  deleteOneAttachment(where: $where) {
    ...Attachment
  }
}
    ${exports.Attachment}`;
exports.deleteManyAttachment = (0, graphql_tag_1.default) `
    mutation deleteManyAttachment($where: AttachmentWhereInput) {
  deleteManyAttachment(where: $where) {
    count
  }
}
    `;
exports.updateManyAttachment = (0, graphql_tag_1.default) `
    mutation updateManyAttachment($where: AttachmentWhereInput, $data: AttachmentUpdateManyMutationInput!) {
  updateManyAttachment(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueBannedWords = (0, graphql_tag_1.default) `
    query findUniqueBannedWords($where: BannedWordsWhereUniqueInput!) {
  findUniqueBannedWords(where: $where) {
    ...BannedWords
  }
}
    ${exports.BannedWords}`;
exports.findManyBannedWords = (0, graphql_tag_1.default) `
    query findManyBannedWords($where: BannedWordsWhereInput, $orderBy: [BannedWordsOrderByWithRelationInput!], $cursor: BannedWordsWhereUniqueInput, $skip: Int, $take: Int) {
  findManyBannedWords(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...BannedWords
  }
}
    ${exports.BannedWords}`;
exports.findManyBannedWordsCount = (0, graphql_tag_1.default) `
    query findManyBannedWordsCount($where: BannedWordsWhereInput, $orderBy: [BannedWordsOrderByWithRelationInput!], $cursor: BannedWordsWhereUniqueInput, $skip: Int, $take: Int) {
  findManyBannedWordsCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneBannedWords = (0, graphql_tag_1.default) `
    mutation createOneBannedWords($data: BannedWordsCreateInput!) {
  createOneBannedWords(data: $data) {
    ...BannedWords
  }
}
    ${exports.BannedWords}`;
exports.updateOneBannedWords = (0, graphql_tag_1.default) `
    mutation updateOneBannedWords($where: BannedWordsWhereUniqueInput!, $data: BannedWordsUpdateInput!) {
  updateOneBannedWords(where: $where, data: $data) {
    ...BannedWords
  }
}
    ${exports.BannedWords}`;
exports.deleteOneBannedWords = (0, graphql_tag_1.default) `
    mutation deleteOneBannedWords($where: BannedWordsWhereUniqueInput!) {
  deleteOneBannedWords(where: $where) {
    ...BannedWords
  }
}
    ${exports.BannedWords}`;
exports.deleteManyBannedWords = (0, graphql_tag_1.default) `
    mutation deleteManyBannedWords($where: BannedWordsWhereInput) {
  deleteManyBannedWords(where: $where) {
    count
  }
}
    `;
exports.updateManyBannedWords = (0, graphql_tag_1.default) `
    mutation updateManyBannedWords($where: BannedWordsWhereInput, $data: BannedWordsUpdateManyMutationInput!) {
  updateManyBannedWords(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueCategory = (0, graphql_tag_1.default) `
    query findUniqueCategory($where: CategoryWhereUniqueInput!) {
  findUniqueCategory(where: $where) {
    ...Category
  }
}
    ${exports.Category}`;
exports.findManyCategory = (0, graphql_tag_1.default) `
    query findManyCategory($where: CategoryWhereInput, $orderBy: [CategoryOrderByWithRelationInput!], $cursor: CategoryWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCategory(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Category
  }
}
    ${exports.Category}`;
exports.findManyCategoryCount = (0, graphql_tag_1.default) `
    query findManyCategoryCount($where: CategoryWhereInput, $orderBy: [CategoryOrderByWithRelationInput!], $cursor: CategoryWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCategoryCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneCategory = (0, graphql_tag_1.default) `
    mutation createOneCategory($data: CategoryCreateInput!) {
  createOneCategory(data: $data) {
    ...Category
  }
}
    ${exports.Category}`;
exports.updateOneCategory = (0, graphql_tag_1.default) `
    mutation updateOneCategory($where: CategoryWhereUniqueInput!, $data: CategoryUpdateInput!) {
  updateOneCategory(where: $where, data: $data) {
    ...Category
  }
}
    ${exports.Category}`;
exports.deleteOneCategory = (0, graphql_tag_1.default) `
    mutation deleteOneCategory($where: CategoryWhereUniqueInput!) {
  deleteOneCategory(where: $where) {
    ...Category
  }
}
    ${exports.Category}`;
exports.deleteManyCategory = (0, graphql_tag_1.default) `
    mutation deleteManyCategory($where: CategoryWhereInput) {
  deleteManyCategory(where: $where) {
    count
  }
}
    `;
exports.updateManyCategory = (0, graphql_tag_1.default) `
    mutation updateManyCategory($where: CategoryWhereInput, $data: CategoryUpdateManyMutationInput!) {
  updateManyCategory(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueCategoryKeyword = (0, graphql_tag_1.default) `
    query findUniqueCategoryKeyword($where: CategoryKeywordWhereUniqueInput!) {
  findUniqueCategoryKeyword(where: $where) {
    ...CategoryKeyword
  }
}
    ${exports.CategoryKeyword}`;
exports.findManyCategoryKeyword = (0, graphql_tag_1.default) `
    query findManyCategoryKeyword($where: CategoryKeywordWhereInput, $orderBy: [CategoryKeywordOrderByWithRelationInput!], $cursor: CategoryKeywordWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCategoryKeyword(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...CategoryKeyword
  }
}
    ${exports.CategoryKeyword}`;
exports.findManyCategoryKeywordCount = (0, graphql_tag_1.default) `
    query findManyCategoryKeywordCount($where: CategoryKeywordWhereInput, $orderBy: [CategoryKeywordOrderByWithRelationInput!], $cursor: CategoryKeywordWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCategoryKeywordCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneCategoryKeyword = (0, graphql_tag_1.default) `
    mutation createOneCategoryKeyword($data: CategoryKeywordCreateInput!) {
  createOneCategoryKeyword(data: $data) {
    ...CategoryKeyword
  }
}
    ${exports.CategoryKeyword}`;
exports.updateOneCategoryKeyword = (0, graphql_tag_1.default) `
    mutation updateOneCategoryKeyword($where: CategoryKeywordWhereUniqueInput!, $data: CategoryKeywordUpdateInput!) {
  updateOneCategoryKeyword(where: $where, data: $data) {
    ...CategoryKeyword
  }
}
    ${exports.CategoryKeyword}`;
exports.deleteOneCategoryKeyword = (0, graphql_tag_1.default) `
    mutation deleteOneCategoryKeyword($where: CategoryKeywordWhereUniqueInput!) {
  deleteOneCategoryKeyword(where: $where) {
    ...CategoryKeyword
  }
}
    ${exports.CategoryKeyword}`;
exports.deleteManyCategoryKeyword = (0, graphql_tag_1.default) `
    mutation deleteManyCategoryKeyword($where: CategoryKeywordWhereInput) {
  deleteManyCategoryKeyword(where: $where) {
    count
  }
}
    `;
exports.updateManyCategoryKeyword = (0, graphql_tag_1.default) `
    mutation updateManyCategoryKeyword($where: CategoryKeywordWhereInput, $data: CategoryKeywordUpdateManyMutationInput!) {
  updateManyCategoryKeyword(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueChannel = (0, graphql_tag_1.default) `
    query findUniqueChannel($where: ChannelWhereUniqueInput!) {
  findUniqueChannel(where: $where) {
    ...Channel
  }
}
    ${exports.Channel}`;
exports.findManyChannel = (0, graphql_tag_1.default) `
    query findManyChannel($where: ChannelWhereInput, $orderBy: [ChannelOrderByWithRelationInput!], $cursor: ChannelWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannel(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Channel
  }
}
    ${exports.Channel}`;
exports.findManyChannelCount = (0, graphql_tag_1.default) `
    query findManyChannelCount($where: ChannelWhereInput, $orderBy: [ChannelOrderByWithRelationInput!], $cursor: ChannelWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneChannel = (0, graphql_tag_1.default) `
    mutation createOneChannel($data: ChannelCreateInput!) {
  createOneChannel(data: $data) {
    ...Channel
  }
}
    ${exports.Channel}`;
exports.updateOneChannel = (0, graphql_tag_1.default) `
    mutation updateOneChannel($where: ChannelWhereUniqueInput!, $data: ChannelUpdateInput!) {
  updateOneChannel(where: $where, data: $data) {
    ...Channel
  }
}
    ${exports.Channel}`;
exports.deleteOneChannel = (0, graphql_tag_1.default) `
    mutation deleteOneChannel($where: ChannelWhereUniqueInput!) {
  deleteOneChannel(where: $where) {
    ...Channel
  }
}
    ${exports.Channel}`;
exports.deleteManyChannel = (0, graphql_tag_1.default) `
    mutation deleteManyChannel($where: ChannelWhereInput) {
  deleteManyChannel(where: $where) {
    count
  }
}
    `;
exports.updateManyChannel = (0, graphql_tag_1.default) `
    mutation updateManyChannel($where: ChannelWhereInput, $data: ChannelUpdateManyMutationInput!) {
  updateManyChannel(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueChannelBizInfo = (0, graphql_tag_1.default) `
    query findUniqueChannelBizInfo($where: ChannelBizInfoWhereUniqueInput!) {
  findUniqueChannelBizInfo(where: $where) {
    ...ChannelBizInfo
  }
}
    ${exports.ChannelBizInfo}`;
exports.findManyChannelBizInfo = (0, graphql_tag_1.default) `
    query findManyChannelBizInfo($where: ChannelBizInfoWhereInput, $orderBy: [ChannelBizInfoOrderByWithRelationInput!], $cursor: ChannelBizInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelBizInfo(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ChannelBizInfo
  }
}
    ${exports.ChannelBizInfo}`;
exports.findManyChannelBizInfoCount = (0, graphql_tag_1.default) `
    query findManyChannelBizInfoCount($where: ChannelBizInfoWhereInput, $orderBy: [ChannelBizInfoOrderByWithRelationInput!], $cursor: ChannelBizInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelBizInfoCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneChannelBizInfo = (0, graphql_tag_1.default) `
    mutation createOneChannelBizInfo($data: ChannelBizInfoCreateInput!) {
  createOneChannelBizInfo(data: $data) {
    ...ChannelBizInfo
  }
}
    ${exports.ChannelBizInfo}`;
exports.updateOneChannelBizInfo = (0, graphql_tag_1.default) `
    mutation updateOneChannelBizInfo($where: ChannelBizInfoWhereUniqueInput!, $data: ChannelBizInfoUpdateInput!) {
  updateOneChannelBizInfo(where: $where, data: $data) {
    ...ChannelBizInfo
  }
}
    ${exports.ChannelBizInfo}`;
exports.deleteOneChannelBizInfo = (0, graphql_tag_1.default) `
    mutation deleteOneChannelBizInfo($where: ChannelBizInfoWhereUniqueInput!) {
  deleteOneChannelBizInfo(where: $where) {
    ...ChannelBizInfo
  }
}
    ${exports.ChannelBizInfo}`;
exports.deleteManyChannelBizInfo = (0, graphql_tag_1.default) `
    mutation deleteManyChannelBizInfo($where: ChannelBizInfoWhereInput) {
  deleteManyChannelBizInfo(where: $where) {
    count
  }
}
    `;
exports.updateManyChannelBizInfo = (0, graphql_tag_1.default) `
    mutation updateManyChannelBizInfo($where: ChannelBizInfoWhereInput, $data: ChannelBizInfoUpdateManyMutationInput!) {
  updateManyChannelBizInfo(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueChannelChatRoomMenu = (0, graphql_tag_1.default) `
    query findUniqueChannelChatRoomMenu($where: ChannelChatRoomMenuWhereUniqueInput!) {
  findUniqueChannelChatRoomMenu(where: $where) {
    ...ChannelChatRoomMenu
  }
}
    ${exports.ChannelChatRoomMenu}`;
exports.findManyChannelChatRoomMenu = (0, graphql_tag_1.default) `
    query findManyChannelChatRoomMenu($where: ChannelChatRoomMenuWhereInput, $orderBy: [ChannelChatRoomMenuOrderByWithRelationInput!], $cursor: ChannelChatRoomMenuWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelChatRoomMenu(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ChannelChatRoomMenu
  }
}
    ${exports.ChannelChatRoomMenu}`;
exports.findManyChannelChatRoomMenuCount = (0, graphql_tag_1.default) `
    query findManyChannelChatRoomMenuCount($where: ChannelChatRoomMenuWhereInput, $orderBy: [ChannelChatRoomMenuOrderByWithRelationInput!], $cursor: ChannelChatRoomMenuWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelChatRoomMenuCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneChannelChatRoomMenu = (0, graphql_tag_1.default) `
    mutation createOneChannelChatRoomMenu($data: ChannelChatRoomMenuCreateInput!) {
  createOneChannelChatRoomMenu(data: $data) {
    ...ChannelChatRoomMenu
  }
}
    ${exports.ChannelChatRoomMenu}`;
exports.updateOneChannelChatRoomMenu = (0, graphql_tag_1.default) `
    mutation updateOneChannelChatRoomMenu($where: ChannelChatRoomMenuWhereUniqueInput!, $data: ChannelChatRoomMenuUpdateInput!) {
  updateOneChannelChatRoomMenu(where: $where, data: $data) {
    ...ChannelChatRoomMenu
  }
}
    ${exports.ChannelChatRoomMenu}`;
exports.deleteOneChannelChatRoomMenu = (0, graphql_tag_1.default) `
    mutation deleteOneChannelChatRoomMenu($where: ChannelChatRoomMenuWhereUniqueInput!) {
  deleteOneChannelChatRoomMenu(where: $where) {
    ...ChannelChatRoomMenu
  }
}
    ${exports.ChannelChatRoomMenu}`;
exports.deleteManyChannelChatRoomMenu = (0, graphql_tag_1.default) `
    mutation deleteManyChannelChatRoomMenu($where: ChannelChatRoomMenuWhereInput) {
  deleteManyChannelChatRoomMenu(where: $where) {
    count
  }
}
    `;
exports.updateManyChannelChatRoomMenu = (0, graphql_tag_1.default) `
    mutation updateManyChannelChatRoomMenu($where: ChannelChatRoomMenuWhereInput, $data: ChannelChatRoomMenuUpdateManyMutationInput!) {
  updateManyChannelChatRoomMenu(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueChannelDeviceToken = (0, graphql_tag_1.default) `
    query findUniqueChannelDeviceToken($where: ChannelDeviceTokenWhereUniqueInput!) {
  findUniqueChannelDeviceToken(where: $where) {
    ...ChannelDeviceToken
  }
}
    ${exports.ChannelDeviceToken}`;
exports.findManyChannelDeviceToken = (0, graphql_tag_1.default) `
    query findManyChannelDeviceToken($where: ChannelDeviceTokenWhereInput, $orderBy: [ChannelDeviceTokenOrderByWithRelationInput!], $cursor: ChannelDeviceTokenWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelDeviceToken(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ChannelDeviceToken
  }
}
    ${exports.ChannelDeviceToken}`;
exports.findManyChannelDeviceTokenCount = (0, graphql_tag_1.default) `
    query findManyChannelDeviceTokenCount($where: ChannelDeviceTokenWhereInput, $orderBy: [ChannelDeviceTokenOrderByWithRelationInput!], $cursor: ChannelDeviceTokenWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelDeviceTokenCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneChannelDeviceToken = (0, graphql_tag_1.default) `
    mutation createOneChannelDeviceToken($data: ChannelDeviceTokenCreateInput!) {
  createOneChannelDeviceToken(data: $data) {
    ...ChannelDeviceToken
  }
}
    ${exports.ChannelDeviceToken}`;
exports.updateOneChannelDeviceToken = (0, graphql_tag_1.default) `
    mutation updateOneChannelDeviceToken($where: ChannelDeviceTokenWhereUniqueInput!, $data: ChannelDeviceTokenUpdateInput!) {
  updateOneChannelDeviceToken(where: $where, data: $data) {
    ...ChannelDeviceToken
  }
}
    ${exports.ChannelDeviceToken}`;
exports.deleteOneChannelDeviceToken = (0, graphql_tag_1.default) `
    mutation deleteOneChannelDeviceToken($where: ChannelDeviceTokenWhereUniqueInput!) {
  deleteOneChannelDeviceToken(where: $where) {
    ...ChannelDeviceToken
  }
}
    ${exports.ChannelDeviceToken}`;
exports.deleteManyChannelDeviceToken = (0, graphql_tag_1.default) `
    mutation deleteManyChannelDeviceToken($where: ChannelDeviceTokenWhereInput) {
  deleteManyChannelDeviceToken(where: $where) {
    count
  }
}
    `;
exports.updateManyChannelDeviceToken = (0, graphql_tag_1.default) `
    mutation updateManyChannelDeviceToken($where: ChannelDeviceTokenWhereInput, $data: ChannelDeviceTokenUpdateManyMutationInput!) {
  updateManyChannelDeviceToken(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueChannelDictionary = (0, graphql_tag_1.default) `
    query findUniqueChannelDictionary($where: ChannelDictionaryWhereUniqueInput!) {
  findUniqueChannelDictionary(where: $where) {
    ...ChannelDictionary
  }
}
    ${exports.ChannelDictionary}`;
exports.findManyChannelDictionary = (0, graphql_tag_1.default) `
    query findManyChannelDictionary($where: ChannelDictionaryWhereInput, $orderBy: [ChannelDictionaryOrderByWithRelationInput!], $cursor: ChannelDictionaryWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelDictionary(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ChannelDictionary
  }
}
    ${exports.ChannelDictionary}`;
exports.findManyChannelDictionaryCount = (0, graphql_tag_1.default) `
    query findManyChannelDictionaryCount($where: ChannelDictionaryWhereInput, $orderBy: [ChannelDictionaryOrderByWithRelationInput!], $cursor: ChannelDictionaryWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelDictionaryCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneChannelDictionary = (0, graphql_tag_1.default) `
    mutation createOneChannelDictionary($data: ChannelDictionaryCreateInput!) {
  createOneChannelDictionary(data: $data) {
    ...ChannelDictionary
  }
}
    ${exports.ChannelDictionary}`;
exports.updateOneChannelDictionary = (0, graphql_tag_1.default) `
    mutation updateOneChannelDictionary($where: ChannelDictionaryWhereUniqueInput!, $data: ChannelDictionaryUpdateInput!) {
  updateOneChannelDictionary(where: $where, data: $data) {
    ...ChannelDictionary
  }
}
    ${exports.ChannelDictionary}`;
exports.deleteOneChannelDictionary = (0, graphql_tag_1.default) `
    mutation deleteOneChannelDictionary($where: ChannelDictionaryWhereUniqueInput!) {
  deleteOneChannelDictionary(where: $where) {
    ...ChannelDictionary
  }
}
    ${exports.ChannelDictionary}`;
exports.deleteManyChannelDictionary = (0, graphql_tag_1.default) `
    mutation deleteManyChannelDictionary($where: ChannelDictionaryWhereInput) {
  deleteManyChannelDictionary(where: $where) {
    count
  }
}
    `;
exports.updateManyChannelDictionary = (0, graphql_tag_1.default) `
    mutation updateManyChannelDictionary($where: ChannelDictionaryWhereInput, $data: ChannelDictionaryUpdateManyMutationInput!) {
  updateManyChannelDictionary(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueChannelExpert = (0, graphql_tag_1.default) `
    query findUniqueChannelExpert($where: ChannelExpertWhereUniqueInput!) {
  findUniqueChannelExpert(where: $where) {
    ...ChannelExpert
  }
}
    ${exports.ChannelExpert}`;
exports.findManyChannelExpert = (0, graphql_tag_1.default) `
    query findManyChannelExpert($where: ChannelExpertWhereInput, $orderBy: [ChannelExpertOrderByWithRelationInput!], $cursor: ChannelExpertWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelExpert(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ChannelExpert
  }
}
    ${exports.ChannelExpert}`;
exports.findManyChannelExpertCount = (0, graphql_tag_1.default) `
    query findManyChannelExpertCount($where: ChannelExpertWhereInput, $orderBy: [ChannelExpertOrderByWithRelationInput!], $cursor: ChannelExpertWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelExpertCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneChannelExpert = (0, graphql_tag_1.default) `
    mutation createOneChannelExpert($data: ChannelExpertCreateInput!) {
  createOneChannelExpert(data: $data) {
    ...ChannelExpert
  }
}
    ${exports.ChannelExpert}`;
exports.updateOneChannelExpert = (0, graphql_tag_1.default) `
    mutation updateOneChannelExpert($where: ChannelExpertWhereUniqueInput!, $data: ChannelExpertUpdateInput!) {
  updateOneChannelExpert(where: $where, data: $data) {
    ...ChannelExpert
  }
}
    ${exports.ChannelExpert}`;
exports.deleteOneChannelExpert = (0, graphql_tag_1.default) `
    mutation deleteOneChannelExpert($where: ChannelExpertWhereUniqueInput!) {
  deleteOneChannelExpert(where: $where) {
    ...ChannelExpert
  }
}
    ${exports.ChannelExpert}`;
exports.deleteManyChannelExpert = (0, graphql_tag_1.default) `
    mutation deleteManyChannelExpert($where: ChannelExpertWhereInput) {
  deleteManyChannelExpert(where: $where) {
    count
  }
}
    `;
exports.updateManyChannelExpert = (0, graphql_tag_1.default) `
    mutation updateManyChannelExpert($where: ChannelExpertWhereInput, $data: ChannelExpertUpdateManyMutationInput!) {
  updateManyChannelExpert(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueChannelUserUsage = (0, graphql_tag_1.default) `
    query findUniqueChannelUserUsage($where: ChannelUserUsageWhereUniqueInput!) {
  findUniqueChannelUserUsage(where: $where) {
    ...ChannelUserUsage
  }
}
    ${exports.ChannelUserUsage}`;
exports.findManyChannelUserUsage = (0, graphql_tag_1.default) `
    query findManyChannelUserUsage($where: ChannelUserUsageWhereInput, $orderBy: [ChannelUserUsageOrderByWithRelationInput!], $cursor: ChannelUserUsageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelUserUsage(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ChannelUserUsage
  }
}
    ${exports.ChannelUserUsage}`;
exports.findManyChannelUserUsageCount = (0, graphql_tag_1.default) `
    query findManyChannelUserUsageCount($where: ChannelUserUsageWhereInput, $orderBy: [ChannelUserUsageOrderByWithRelationInput!], $cursor: ChannelUserUsageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChannelUserUsageCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneChannelUserUsage = (0, graphql_tag_1.default) `
    mutation createOneChannelUserUsage($data: ChannelUserUsageCreateInput!) {
  createOneChannelUserUsage(data: $data) {
    ...ChannelUserUsage
  }
}
    ${exports.ChannelUserUsage}`;
exports.updateOneChannelUserUsage = (0, graphql_tag_1.default) `
    mutation updateOneChannelUserUsage($where: ChannelUserUsageWhereUniqueInput!, $data: ChannelUserUsageUpdateInput!) {
  updateOneChannelUserUsage(where: $where, data: $data) {
    ...ChannelUserUsage
  }
}
    ${exports.ChannelUserUsage}`;
exports.deleteOneChannelUserUsage = (0, graphql_tag_1.default) `
    mutation deleteOneChannelUserUsage($where: ChannelUserUsageWhereUniqueInput!) {
  deleteOneChannelUserUsage(where: $where) {
    ...ChannelUserUsage
  }
}
    ${exports.ChannelUserUsage}`;
exports.deleteManyChannelUserUsage = (0, graphql_tag_1.default) `
    mutation deleteManyChannelUserUsage($where: ChannelUserUsageWhereInput) {
  deleteManyChannelUserUsage(where: $where) {
    count
  }
}
    `;
exports.updateManyChannelUserUsage = (0, graphql_tag_1.default) `
    mutation updateManyChannelUserUsage($where: ChannelUserUsageWhereInput, $data: ChannelUserUsageUpdateManyMutationInput!) {
  updateManyChannelUserUsage(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueChatRoom = (0, graphql_tag_1.default) `
    query findUniqueChatRoom($where: ChatRoomWhereUniqueInput!) {
  findUniqueChatRoom(where: $where) {
    ...ChatRoom
  }
}
    ${exports.ChatRoom}`;
exports.findManyChatRoom = (0, graphql_tag_1.default) `
    query findManyChatRoom($where: ChatRoomWhereInput, $orderBy: [ChatRoomOrderByWithRelationInput!], $cursor: ChatRoomWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChatRoom(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ChatRoom
  }
}
    ${exports.ChatRoom}`;
exports.findManyChatRoomCount = (0, graphql_tag_1.default) `
    query findManyChatRoomCount($where: ChatRoomWhereInput, $orderBy: [ChatRoomOrderByWithRelationInput!], $cursor: ChatRoomWhereUniqueInput, $skip: Int, $take: Int) {
  findManyChatRoomCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneChatRoom = (0, graphql_tag_1.default) `
    mutation createOneChatRoom($data: ChatRoomCreateInput!) {
  createOneChatRoom(data: $data) {
    ...ChatRoom
  }
}
    ${exports.ChatRoom}`;
exports.updateOneChatRoom = (0, graphql_tag_1.default) `
    mutation updateOneChatRoom($where: ChatRoomWhereUniqueInput!, $data: ChatRoomUpdateInput!) {
  updateOneChatRoom(where: $where, data: $data) {
    ...ChatRoom
  }
}
    ${exports.ChatRoom}`;
exports.deleteOneChatRoom = (0, graphql_tag_1.default) `
    mutation deleteOneChatRoom($where: ChatRoomWhereUniqueInput!) {
  deleteOneChatRoom(where: $where) {
    ...ChatRoom
  }
}
    ${exports.ChatRoom}`;
exports.deleteManyChatRoom = (0, graphql_tag_1.default) `
    mutation deleteManyChatRoom($where: ChatRoomWhereInput) {
  deleteManyChatRoom(where: $where) {
    count
  }
}
    `;
exports.updateManyChatRoom = (0, graphql_tag_1.default) `
    mutation updateManyChatRoom($where: ChatRoomWhereInput, $data: ChatRoomUpdateManyMutationInput!) {
  updateManyChatRoom(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueClientVersions = (0, graphql_tag_1.default) `
    query findUniqueClientVersions($where: ClientVersionsWhereUniqueInput!) {
  findUniqueClientVersions(where: $where) {
    ...ClientVersions
  }
}
    ${exports.ClientVersions}`;
exports.findManyClientVersions = (0, graphql_tag_1.default) `
    query findManyClientVersions($where: ClientVersionsWhereInput, $orderBy: [ClientVersionsOrderByWithRelationInput!], $cursor: ClientVersionsWhereUniqueInput, $skip: Int, $take: Int) {
  findManyClientVersions(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ClientVersions
  }
}
    ${exports.ClientVersions}`;
exports.findManyClientVersionsCount = (0, graphql_tag_1.default) `
    query findManyClientVersionsCount($where: ClientVersionsWhereInput, $orderBy: [ClientVersionsOrderByWithRelationInput!], $cursor: ClientVersionsWhereUniqueInput, $skip: Int, $take: Int) {
  findManyClientVersionsCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneClientVersions = (0, graphql_tag_1.default) `
    mutation createOneClientVersions($data: ClientVersionsCreateInput!) {
  createOneClientVersions(data: $data) {
    ...ClientVersions
  }
}
    ${exports.ClientVersions}`;
exports.updateOneClientVersions = (0, graphql_tag_1.default) `
    mutation updateOneClientVersions($where: ClientVersionsWhereUniqueInput!, $data: ClientVersionsUpdateInput!) {
  updateOneClientVersions(where: $where, data: $data) {
    ...ClientVersions
  }
}
    ${exports.ClientVersions}`;
exports.deleteOneClientVersions = (0, graphql_tag_1.default) `
    mutation deleteOneClientVersions($where: ClientVersionsWhereUniqueInput!) {
  deleteOneClientVersions(where: $where) {
    ...ClientVersions
  }
}
    ${exports.ClientVersions}`;
exports.deleteManyClientVersions = (0, graphql_tag_1.default) `
    mutation deleteManyClientVersions($where: ClientVersionsWhereInput) {
  deleteManyClientVersions(where: $where) {
    count
  }
}
    `;
exports.updateManyClientVersions = (0, graphql_tag_1.default) `
    mutation updateManyClientVersions($where: ClientVersionsWhereInput, $data: ClientVersionsUpdateManyMutationInput!) {
  updateManyClientVersions(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueCommerceOrder = (0, graphql_tag_1.default) `
    query findUniqueCommerceOrder($where: CommerceOrderWhereUniqueInput!) {
  findUniqueCommerceOrder(where: $where) {
    ...CommerceOrder
  }
}
    ${exports.CommerceOrder}`;
exports.findManyCommerceOrder = (0, graphql_tag_1.default) `
    query findManyCommerceOrder($where: CommerceOrderWhereInput, $orderBy: [CommerceOrderOrderByWithRelationInput!], $cursor: CommerceOrderWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCommerceOrder(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...CommerceOrder
  }
}
    ${exports.CommerceOrder}`;
exports.findManyCommerceOrderCount = (0, graphql_tag_1.default) `
    query findManyCommerceOrderCount($where: CommerceOrderWhereInput, $orderBy: [CommerceOrderOrderByWithRelationInput!], $cursor: CommerceOrderWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCommerceOrderCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneCommerceOrder = (0, graphql_tag_1.default) `
    mutation createOneCommerceOrder($data: CommerceOrderCreateInput!) {
  createOneCommerceOrder(data: $data) {
    ...CommerceOrder
  }
}
    ${exports.CommerceOrder}`;
exports.updateOneCommerceOrder = (0, graphql_tag_1.default) `
    mutation updateOneCommerceOrder($where: CommerceOrderWhereUniqueInput!, $data: CommerceOrderUpdateInput!) {
  updateOneCommerceOrder(where: $where, data: $data) {
    ...CommerceOrder
  }
}
    ${exports.CommerceOrder}`;
exports.deleteOneCommerceOrder = (0, graphql_tag_1.default) `
    mutation deleteOneCommerceOrder($where: CommerceOrderWhereUniqueInput!) {
  deleteOneCommerceOrder(where: $where) {
    ...CommerceOrder
  }
}
    ${exports.CommerceOrder}`;
exports.deleteManyCommerceOrder = (0, graphql_tag_1.default) `
    mutation deleteManyCommerceOrder($where: CommerceOrderWhereInput) {
  deleteManyCommerceOrder(where: $where) {
    count
  }
}
    `;
exports.updateManyCommerceOrder = (0, graphql_tag_1.default) `
    mutation updateManyCommerceOrder($where: CommerceOrderWhereInput, $data: CommerceOrderUpdateManyMutationInput!) {
  updateManyCommerceOrder(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueCommerceOrderReview = (0, graphql_tag_1.default) `
    query findUniqueCommerceOrderReview($where: CommerceOrderReviewWhereUniqueInput!) {
  findUniqueCommerceOrderReview(where: $where) {
    ...CommerceOrderReview
  }
}
    ${exports.CommerceOrderReview}`;
exports.findManyCommerceOrderReview = (0, graphql_tag_1.default) `
    query findManyCommerceOrderReview($where: CommerceOrderReviewWhereInput, $orderBy: [CommerceOrderReviewOrderByWithRelationInput!], $cursor: CommerceOrderReviewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCommerceOrderReview(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...CommerceOrderReview
  }
}
    ${exports.CommerceOrderReview}`;
exports.findManyCommerceOrderReviewCount = (0, graphql_tag_1.default) `
    query findManyCommerceOrderReviewCount($where: CommerceOrderReviewWhereInput, $orderBy: [CommerceOrderReviewOrderByWithRelationInput!], $cursor: CommerceOrderReviewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCommerceOrderReviewCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneCommerceOrderReview = (0, graphql_tag_1.default) `
    mutation createOneCommerceOrderReview($data: CommerceOrderReviewCreateInput!) {
  createOneCommerceOrderReview(data: $data) {
    ...CommerceOrderReview
  }
}
    ${exports.CommerceOrderReview}`;
exports.updateOneCommerceOrderReview = (0, graphql_tag_1.default) `
    mutation updateOneCommerceOrderReview($where: CommerceOrderReviewWhereUniqueInput!, $data: CommerceOrderReviewUpdateInput!) {
  updateOneCommerceOrderReview(where: $where, data: $data) {
    ...CommerceOrderReview
  }
}
    ${exports.CommerceOrderReview}`;
exports.deleteOneCommerceOrderReview = (0, graphql_tag_1.default) `
    mutation deleteOneCommerceOrderReview($where: CommerceOrderReviewWhereUniqueInput!) {
  deleteOneCommerceOrderReview(where: $where) {
    ...CommerceOrderReview
  }
}
    ${exports.CommerceOrderReview}`;
exports.deleteManyCommerceOrderReview = (0, graphql_tag_1.default) `
    mutation deleteManyCommerceOrderReview($where: CommerceOrderReviewWhereInput) {
  deleteManyCommerceOrderReview(where: $where) {
    count
  }
}
    `;
exports.updateManyCommerceOrderReview = (0, graphql_tag_1.default) `
    mutation updateManyCommerceOrderReview($where: CommerceOrderReviewWhereInput, $data: CommerceOrderReviewUpdateManyMutationInput!) {
  updateManyCommerceOrderReview(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueCommerceProduct = (0, graphql_tag_1.default) `
    query findUniqueCommerceProduct($where: CommerceProductWhereUniqueInput!) {
  findUniqueCommerceProduct(where: $where) {
    ...CommerceProduct
  }
}
    ${exports.CommerceProduct}`;
exports.findManyCommerceProduct = (0, graphql_tag_1.default) `
    query findManyCommerceProduct($where: CommerceProductWhereInput, $orderBy: [CommerceProductOrderByWithRelationInput!], $cursor: CommerceProductWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCommerceProduct(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...CommerceProduct
  }
}
    ${exports.CommerceProduct}`;
exports.findManyCommerceProductCount = (0, graphql_tag_1.default) `
    query findManyCommerceProductCount($where: CommerceProductWhereInput, $orderBy: [CommerceProductOrderByWithRelationInput!], $cursor: CommerceProductWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCommerceProductCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneCommerceProduct = (0, graphql_tag_1.default) `
    mutation createOneCommerceProduct($data: CommerceProductCreateInput!) {
  createOneCommerceProduct(data: $data) {
    ...CommerceProduct
  }
}
    ${exports.CommerceProduct}`;
exports.updateOneCommerceProduct = (0, graphql_tag_1.default) `
    mutation updateOneCommerceProduct($where: CommerceProductWhereUniqueInput!, $data: CommerceProductUpdateInput!) {
  updateOneCommerceProduct(where: $where, data: $data) {
    ...CommerceProduct
  }
}
    ${exports.CommerceProduct}`;
exports.deleteOneCommerceProduct = (0, graphql_tag_1.default) `
    mutation deleteOneCommerceProduct($where: CommerceProductWhereUniqueInput!) {
  deleteOneCommerceProduct(where: $where) {
    ...CommerceProduct
  }
}
    ${exports.CommerceProduct}`;
exports.deleteManyCommerceProduct = (0, graphql_tag_1.default) `
    mutation deleteManyCommerceProduct($where: CommerceProductWhereInput) {
  deleteManyCommerceProduct(where: $where) {
    count
  }
}
    `;
exports.findUniqueCommerceProductReview = (0, graphql_tag_1.default) `
    query findUniqueCommerceProductReview($where: CommerceProductReviewWhereUniqueInput!) {
  findUniqueCommerceProductReview(where: $where) {
    ...CommerceProductReview
  }
}
    ${exports.CommerceProductReview}`;
exports.findManyCommerceProductReview = (0, graphql_tag_1.default) `
    query findManyCommerceProductReview($where: CommerceProductReviewWhereInput, $orderBy: [CommerceProductReviewOrderByWithRelationInput!], $cursor: CommerceProductReviewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCommerceProductReview(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...CommerceProductReview
  }
}
    ${exports.CommerceProductReview}`;
exports.findManyCommerceProductReviewCount = (0, graphql_tag_1.default) `
    query findManyCommerceProductReviewCount($where: CommerceProductReviewWhereInput, $orderBy: [CommerceProductReviewOrderByWithRelationInput!], $cursor: CommerceProductReviewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCommerceProductReviewCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneCommerceProductReview = (0, graphql_tag_1.default) `
    mutation createOneCommerceProductReview($data: CommerceProductReviewCreateInput!) {
  createOneCommerceProductReview(data: $data) {
    ...CommerceProductReview
  }
}
    ${exports.CommerceProductReview}`;
exports.updateOneCommerceProductReview = (0, graphql_tag_1.default) `
    mutation updateOneCommerceProductReview($where: CommerceProductReviewWhereUniqueInput!, $data: CommerceProductReviewUpdateInput!) {
  updateOneCommerceProductReview(where: $where, data: $data) {
    ...CommerceProductReview
  }
}
    ${exports.CommerceProductReview}`;
exports.deleteOneCommerceProductReview = (0, graphql_tag_1.default) `
    mutation deleteOneCommerceProductReview($where: CommerceProductReviewWhereUniqueInput!) {
  deleteOneCommerceProductReview(where: $where) {
    ...CommerceProductReview
  }
}
    ${exports.CommerceProductReview}`;
exports.deleteManyCommerceProductReview = (0, graphql_tag_1.default) `
    mutation deleteManyCommerceProductReview($where: CommerceProductReviewWhereInput) {
  deleteManyCommerceProductReview(where: $where) {
    count
  }
}
    `;
exports.updateManyCommerceProductReview = (0, graphql_tag_1.default) `
    mutation updateManyCommerceProductReview($where: CommerceProductReviewWhereInput, $data: CommerceProductReviewUpdateManyMutationInput!) {
  updateManyCommerceProductReview(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueCustomerCommunicationLog = (0, graphql_tag_1.default) `
    query findUniqueCustomerCommunicationLog($where: CustomerCommunicationLogWhereUniqueInput!) {
  findUniqueCustomerCommunicationLog(where: $where) {
    ...CustomerCommunicationLog
  }
}
    ${exports.CustomerCommunicationLog}`;
exports.findManyCustomerCommunicationLog = (0, graphql_tag_1.default) `
    query findManyCustomerCommunicationLog($where: CustomerCommunicationLogWhereInput, $orderBy: [CustomerCommunicationLogOrderByWithRelationInput!], $cursor: CustomerCommunicationLogWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCustomerCommunicationLog(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...CustomerCommunicationLog
  }
}
    ${exports.CustomerCommunicationLog}`;
exports.findManyCustomerCommunicationLogCount = (0, graphql_tag_1.default) `
    query findManyCustomerCommunicationLogCount($where: CustomerCommunicationLogWhereInput, $orderBy: [CustomerCommunicationLogOrderByWithRelationInput!], $cursor: CustomerCommunicationLogWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCustomerCommunicationLogCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneCustomerCommunicationLog = (0, graphql_tag_1.default) `
    mutation createOneCustomerCommunicationLog($data: CustomerCommunicationLogCreateInput!) {
  createOneCustomerCommunicationLog(data: $data) {
    ...CustomerCommunicationLog
  }
}
    ${exports.CustomerCommunicationLog}`;
exports.updateOneCustomerCommunicationLog = (0, graphql_tag_1.default) `
    mutation updateOneCustomerCommunicationLog($where: CustomerCommunicationLogWhereUniqueInput!, $data: CustomerCommunicationLogUpdateInput!) {
  updateOneCustomerCommunicationLog(where: $where, data: $data) {
    ...CustomerCommunicationLog
  }
}
    ${exports.CustomerCommunicationLog}`;
exports.deleteOneCustomerCommunicationLog = (0, graphql_tag_1.default) `
    mutation deleteOneCustomerCommunicationLog($where: CustomerCommunicationLogWhereUniqueInput!) {
  deleteOneCustomerCommunicationLog(where: $where) {
    ...CustomerCommunicationLog
  }
}
    ${exports.CustomerCommunicationLog}`;
exports.deleteManyCustomerCommunicationLog = (0, graphql_tag_1.default) `
    mutation deleteManyCustomerCommunicationLog($where: CustomerCommunicationLogWhereInput) {
  deleteManyCustomerCommunicationLog(where: $where) {
    count
  }
}
    `;
exports.updateManyCustomerCommunicationLog = (0, graphql_tag_1.default) `
    mutation updateManyCustomerCommunicationLog($where: CustomerCommunicationLogWhereInput, $data: CustomerCommunicationLogUpdateManyMutationInput!) {
  updateManyCustomerCommunicationLog(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueCustomerRelationship = (0, graphql_tag_1.default) `
    query findUniqueCustomerRelationship($where: CustomerRelationshipWhereUniqueInput!) {
  findUniqueCustomerRelationship(where: $where) {
    ...CustomerRelationship
  }
}
    ${exports.CustomerRelationship}`;
exports.findManyCustomerRelationship = (0, graphql_tag_1.default) `
    query findManyCustomerRelationship($where: CustomerRelationshipWhereInput, $orderBy: [CustomerRelationshipOrderByWithRelationInput!], $cursor: CustomerRelationshipWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCustomerRelationship(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...CustomerRelationship
  }
}
    ${exports.CustomerRelationship}`;
exports.findManyCustomerRelationshipCount = (0, graphql_tag_1.default) `
    query findManyCustomerRelationshipCount($where: CustomerRelationshipWhereInput, $orderBy: [CustomerRelationshipOrderByWithRelationInput!], $cursor: CustomerRelationshipWhereUniqueInput, $skip: Int, $take: Int) {
  findManyCustomerRelationshipCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneCustomerRelationship = (0, graphql_tag_1.default) `
    mutation createOneCustomerRelationship($data: CustomerRelationshipCreateInput!) {
  createOneCustomerRelationship(data: $data) {
    ...CustomerRelationship
  }
}
    ${exports.CustomerRelationship}`;
exports.updateOneCustomerRelationship = (0, graphql_tag_1.default) `
    mutation updateOneCustomerRelationship($where: CustomerRelationshipWhereUniqueInput!, $data: CustomerRelationshipUpdateInput!) {
  updateOneCustomerRelationship(where: $where, data: $data) {
    ...CustomerRelationship
  }
}
    ${exports.CustomerRelationship}`;
exports.deleteOneCustomerRelationship = (0, graphql_tag_1.default) `
    mutation deleteOneCustomerRelationship($where: CustomerRelationshipWhereUniqueInput!) {
  deleteOneCustomerRelationship(where: $where) {
    ...CustomerRelationship
  }
}
    ${exports.CustomerRelationship}`;
exports.deleteManyCustomerRelationship = (0, graphql_tag_1.default) `
    mutation deleteManyCustomerRelationship($where: CustomerRelationshipWhereInput) {
  deleteManyCustomerRelationship(where: $where) {
    count
  }
}
    `;
exports.updateManyCustomerRelationship = (0, graphql_tag_1.default) `
    mutation updateManyCustomerRelationship($where: CustomerRelationshipWhereInput, $data: CustomerRelationshipUpdateManyMutationInput!) {
  updateManyCustomerRelationship(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueDeletedUser = (0, graphql_tag_1.default) `
    query findUniqueDeletedUser($where: DeletedUserWhereUniqueInput!) {
  findUniqueDeletedUser(where: $where) {
    ...DeletedUser
  }
}
    ${exports.DeletedUser}`;
exports.findManyDeletedUser = (0, graphql_tag_1.default) `
    query findManyDeletedUser($where: DeletedUserWhereInput, $orderBy: [DeletedUserOrderByWithRelationInput!], $cursor: DeletedUserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDeletedUser(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...DeletedUser
  }
}
    ${exports.DeletedUser}`;
exports.findManyDeletedUserCount = (0, graphql_tag_1.default) `
    query findManyDeletedUserCount($where: DeletedUserWhereInput, $orderBy: [DeletedUserOrderByWithRelationInput!], $cursor: DeletedUserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDeletedUserCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneDeletedUser = (0, graphql_tag_1.default) `
    mutation createOneDeletedUser($data: DeletedUserCreateInput!) {
  createOneDeletedUser(data: $data) {
    ...DeletedUser
  }
}
    ${exports.DeletedUser}`;
exports.updateOneDeletedUser = (0, graphql_tag_1.default) `
    mutation updateOneDeletedUser($where: DeletedUserWhereUniqueInput!, $data: DeletedUserUpdateInput!) {
  updateOneDeletedUser(where: $where, data: $data) {
    ...DeletedUser
  }
}
    ${exports.DeletedUser}`;
exports.deleteOneDeletedUser = (0, graphql_tag_1.default) `
    mutation deleteOneDeletedUser($where: DeletedUserWhereUniqueInput!) {
  deleteOneDeletedUser(where: $where) {
    ...DeletedUser
  }
}
    ${exports.DeletedUser}`;
exports.deleteManyDeletedUser = (0, graphql_tag_1.default) `
    mutation deleteManyDeletedUser($where: DeletedUserWhereInput) {
  deleteManyDeletedUser(where: $where) {
    count
  }
}
    `;
exports.updateManyDeletedUser = (0, graphql_tag_1.default) `
    mutation updateManyDeletedUser($where: DeletedUserWhereInput, $data: DeletedUserUpdateManyMutationInput!) {
  updateManyDeletedUser(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueDeviceToken_Topics = (0, graphql_tag_1.default) `
    query findUniqueDeviceToken_Topics($where: DeviceToken_TopicsWhereUniqueInput!) {
  findUniqueDeviceToken_Topics(where: $where) {
    ...DeviceToken_Topics
  }
}
    ${exports.DeviceToken_Topics}`;
exports.findManyDeviceToken_Topics = (0, graphql_tag_1.default) `
    query findManyDeviceToken_Topics($where: DeviceToken_TopicsWhereInput, $orderBy: [DeviceToken_TopicsOrderByWithRelationInput!], $cursor: DeviceToken_TopicsWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDeviceToken_Topics(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...DeviceToken_Topics
  }
}
    ${exports.DeviceToken_Topics}`;
exports.findManyDeviceToken_TopicsCount = (0, graphql_tag_1.default) `
    query findManyDeviceToken_TopicsCount($where: DeviceToken_TopicsWhereInput, $orderBy: [DeviceToken_TopicsOrderByWithRelationInput!], $cursor: DeviceToken_TopicsWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDeviceToken_TopicsCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneDeviceToken_Topics = (0, graphql_tag_1.default) `
    mutation createOneDeviceToken_Topics($data: DeviceToken_TopicsCreateInput!) {
  createOneDeviceToken_Topics(data: $data) {
    ...DeviceToken_Topics
  }
}
    ${exports.DeviceToken_Topics}`;
exports.updateOneDeviceToken_Topics = (0, graphql_tag_1.default) `
    mutation updateOneDeviceToken_Topics($where: DeviceToken_TopicsWhereUniqueInput!, $data: DeviceToken_TopicsUpdateInput!) {
  updateOneDeviceToken_Topics(where: $where, data: $data) {
    ...DeviceToken_Topics
  }
}
    ${exports.DeviceToken_Topics}`;
exports.deleteOneDeviceToken_Topics = (0, graphql_tag_1.default) `
    mutation deleteOneDeviceToken_Topics($where: DeviceToken_TopicsWhereUniqueInput!) {
  deleteOneDeviceToken_Topics(where: $where) {
    ...DeviceToken_Topics
  }
}
    ${exports.DeviceToken_Topics}`;
exports.deleteManyDeviceToken_Topics = (0, graphql_tag_1.default) `
    mutation deleteManyDeviceToken_Topics($where: DeviceToken_TopicsWhereInput) {
  deleteManyDeviceToken_Topics(where: $where) {
    count
  }
}
    `;
exports.updateManyDeviceToken_Topics = (0, graphql_tag_1.default) `
    mutation updateManyDeviceToken_Topics($where: DeviceToken_TopicsWhereInput, $data: DeviceToken_TopicsUpdateManyMutationInput!) {
  updateManyDeviceToken_Topics(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueDocument = (0, graphql_tag_1.default) `
    query findUniqueDocument($where: DocumentWhereUniqueInput!) {
  findUniqueDocument(where: $where) {
    ...Document
  }
}
    ${exports.Document}`;
exports.findManyDocument = (0, graphql_tag_1.default) `
    query findManyDocument($where: DocumentWhereInput, $orderBy: [DocumentOrderByWithRelationInput!], $cursor: DocumentWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDocument(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Document
  }
}
    ${exports.Document}`;
exports.findManyDocumentCount = (0, graphql_tag_1.default) `
    query findManyDocumentCount($where: DocumentWhereInput, $orderBy: [DocumentOrderByWithRelationInput!], $cursor: DocumentWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDocumentCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneDocument = (0, graphql_tag_1.default) `
    mutation createOneDocument($data: DocumentCreateInput!) {
  createOneDocument(data: $data) {
    ...Document
  }
}
    ${exports.Document}`;
exports.updateOneDocument = (0, graphql_tag_1.default) `
    mutation updateOneDocument($where: DocumentWhereUniqueInput!, $data: DocumentUpdateInput!) {
  updateOneDocument(where: $where, data: $data) {
    ...Document
  }
}
    ${exports.Document}`;
exports.deleteOneDocument = (0, graphql_tag_1.default) `
    mutation deleteOneDocument($where: DocumentWhereUniqueInput!) {
  deleteOneDocument(where: $where) {
    ...Document
  }
}
    ${exports.Document}`;
exports.deleteManyDocument = (0, graphql_tag_1.default) `
    mutation deleteManyDocument($where: DocumentWhereInput) {
  deleteManyDocument(where: $where) {
    count
  }
}
    `;
exports.updateManyDocument = (0, graphql_tag_1.default) `
    mutation updateManyDocument($where: DocumentWhereInput, $data: DocumentUpdateManyMutationInput!) {
  updateManyDocument(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueDontShowAgain = (0, graphql_tag_1.default) `
    query findUniqueDontShowAgain($where: DontShowAgainWhereUniqueInput!) {
  findUniqueDontShowAgain(where: $where) {
    ...DontShowAgain
  }
}
    ${exports.DontShowAgain}`;
exports.findManyDontShowAgain = (0, graphql_tag_1.default) `
    query findManyDontShowAgain($where: DontShowAgainWhereInput, $orderBy: [DontShowAgainOrderByWithRelationInput!], $cursor: DontShowAgainWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDontShowAgain(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...DontShowAgain
  }
}
    ${exports.DontShowAgain}`;
exports.findManyDontShowAgainCount = (0, graphql_tag_1.default) `
    query findManyDontShowAgainCount($where: DontShowAgainWhereInput, $orderBy: [DontShowAgainOrderByWithRelationInput!], $cursor: DontShowAgainWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDontShowAgainCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneDontShowAgain = (0, graphql_tag_1.default) `
    mutation createOneDontShowAgain($data: DontShowAgainCreateInput!) {
  createOneDontShowAgain(data: $data) {
    ...DontShowAgain
  }
}
    ${exports.DontShowAgain}`;
exports.updateOneDontShowAgain = (0, graphql_tag_1.default) `
    mutation updateOneDontShowAgain($where: DontShowAgainWhereUniqueInput!, $data: DontShowAgainUpdateInput!) {
  updateOneDontShowAgain(where: $where, data: $data) {
    ...DontShowAgain
  }
}
    ${exports.DontShowAgain}`;
exports.deleteOneDontShowAgain = (0, graphql_tag_1.default) `
    mutation deleteOneDontShowAgain($where: DontShowAgainWhereUniqueInput!) {
  deleteOneDontShowAgain(where: $where) {
    ...DontShowAgain
  }
}
    ${exports.DontShowAgain}`;
exports.deleteManyDontShowAgain = (0, graphql_tag_1.default) `
    mutation deleteManyDontShowAgain($where: DontShowAgainWhereInput) {
  deleteManyDontShowAgain(where: $where) {
    count
  }
}
    `;
exports.updateManyDontShowAgain = (0, graphql_tag_1.default) `
    mutation updateManyDontShowAgain($where: DontShowAgainWhereInput, $data: DontShowAgainUpdateManyMutationInput!) {
  updateManyDontShowAgain(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueDynamicLink = (0, graphql_tag_1.default) `
    query findUniqueDynamicLink($where: DynamicLinkWhereUniqueInput!) {
  findUniqueDynamicLink(where: $where) {
    ...DynamicLink
  }
}
    ${exports.DynamicLink}`;
exports.findManyDynamicLink = (0, graphql_tag_1.default) `
    query findManyDynamicLink($where: DynamicLinkWhereInput, $orderBy: [DynamicLinkOrderByWithRelationInput!], $cursor: DynamicLinkWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDynamicLink(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...DynamicLink
  }
}
    ${exports.DynamicLink}`;
exports.findManyDynamicLinkCount = (0, graphql_tag_1.default) `
    query findManyDynamicLinkCount($where: DynamicLinkWhereInput, $orderBy: [DynamicLinkOrderByWithRelationInput!], $cursor: DynamicLinkWhereUniqueInput, $skip: Int, $take: Int) {
  findManyDynamicLinkCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneDynamicLink = (0, graphql_tag_1.default) `
    mutation createOneDynamicLink($data: DynamicLinkCreateInput!) {
  createOneDynamicLink(data: $data) {
    ...DynamicLink
  }
}
    ${exports.DynamicLink}`;
exports.updateOneDynamicLink = (0, graphql_tag_1.default) `
    mutation updateOneDynamicLink($where: DynamicLinkWhereUniqueInput!, $data: DynamicLinkUpdateInput!) {
  updateOneDynamicLink(where: $where, data: $data) {
    ...DynamicLink
  }
}
    ${exports.DynamicLink}`;
exports.deleteOneDynamicLink = (0, graphql_tag_1.default) `
    mutation deleteOneDynamicLink($where: DynamicLinkWhereUniqueInput!) {
  deleteOneDynamicLink(where: $where) {
    ...DynamicLink
  }
}
    ${exports.DynamicLink}`;
exports.deleteManyDynamicLink = (0, graphql_tag_1.default) `
    mutation deleteManyDynamicLink($where: DynamicLinkWhereInput) {
  deleteManyDynamicLink(where: $where) {
    count
  }
}
    `;
exports.updateManyDynamicLink = (0, graphql_tag_1.default) `
    mutation updateManyDynamicLink($where: DynamicLinkWhereInput, $data: DynamicLinkUpdateManyMutationInput!) {
  updateManyDynamicLink(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueExpertInfo = (0, graphql_tag_1.default) `
    query findUniqueExpertInfo($where: ExpertInfoWhereUniqueInput!) {
  findUniqueExpertInfo(where: $where) {
    ...ExpertInfo
  }
}
    ${exports.ExpertInfo}`;
exports.findManyExpertInfo = (0, graphql_tag_1.default) `
    query findManyExpertInfo($where: ExpertInfoWhereInput, $orderBy: [ExpertInfoOrderByWithRelationInput!], $cursor: ExpertInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyExpertInfo(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ExpertInfo
  }
}
    ${exports.ExpertInfo}`;
exports.findManyExpertInfoCount = (0, graphql_tag_1.default) `
    query findManyExpertInfoCount($where: ExpertInfoWhereInput, $orderBy: [ExpertInfoOrderByWithRelationInput!], $cursor: ExpertInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyExpertInfoCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneExpertInfo = (0, graphql_tag_1.default) `
    mutation createOneExpertInfo($data: ExpertInfoCreateInput!) {
  createOneExpertInfo(data: $data) {
    ...ExpertInfo
  }
}
    ${exports.ExpertInfo}`;
exports.updateOneExpertInfo = (0, graphql_tag_1.default) `
    mutation updateOneExpertInfo($where: ExpertInfoWhereUniqueInput!, $data: ExpertInfoUpdateInput!) {
  updateOneExpertInfo(where: $where, data: $data) {
    ...ExpertInfo
  }
}
    ${exports.ExpertInfo}`;
exports.deleteOneExpertInfo = (0, graphql_tag_1.default) `
    mutation deleteOneExpertInfo($where: ExpertInfoWhereUniqueInput!) {
  deleteOneExpertInfo(where: $where) {
    ...ExpertInfo
  }
}
    ${exports.ExpertInfo}`;
exports.deleteManyExpertInfo = (0, graphql_tag_1.default) `
    mutation deleteManyExpertInfo($where: ExpertInfoWhereInput) {
  deleteManyExpertInfo(where: $where) {
    count
  }
}
    `;
exports.updateManyExpertInfo = (0, graphql_tag_1.default) `
    mutation updateManyExpertInfo($where: ExpertInfoWhereInput, $data: ExpertInfoUpdateManyMutationInput!) {
  updateManyExpertInfo(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueExternalRequest = (0, graphql_tag_1.default) `
    query findUniqueExternalRequest($where: ExternalRequestWhereUniqueInput!) {
  findUniqueExternalRequest(where: $where) {
    ...ExternalRequest
  }
}
    ${exports.ExternalRequest}`;
exports.findManyExternalRequest = (0, graphql_tag_1.default) `
    query findManyExternalRequest($where: ExternalRequestWhereInput, $orderBy: [ExternalRequestOrderByWithRelationInput!], $cursor: ExternalRequestWhereUniqueInput, $skip: Int, $take: Int) {
  findManyExternalRequest(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ExternalRequest
  }
}
    ${exports.ExternalRequest}`;
exports.findManyExternalRequestCount = (0, graphql_tag_1.default) `
    query findManyExternalRequestCount($where: ExternalRequestWhereInput, $orderBy: [ExternalRequestOrderByWithRelationInput!], $cursor: ExternalRequestWhereUniqueInput, $skip: Int, $take: Int) {
  findManyExternalRequestCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneExternalRequest = (0, graphql_tag_1.default) `
    mutation createOneExternalRequest($data: ExternalRequestCreateInput!) {
  createOneExternalRequest(data: $data) {
    ...ExternalRequest
  }
}
    ${exports.ExternalRequest}`;
exports.updateOneExternalRequest = (0, graphql_tag_1.default) `
    mutation updateOneExternalRequest($where: ExternalRequestWhereUniqueInput!, $data: ExternalRequestUpdateInput!) {
  updateOneExternalRequest(where: $where, data: $data) {
    ...ExternalRequest
  }
}
    ${exports.ExternalRequest}`;
exports.deleteOneExternalRequest = (0, graphql_tag_1.default) `
    mutation deleteOneExternalRequest($where: ExternalRequestWhereUniqueInput!) {
  deleteOneExternalRequest(where: $where) {
    ...ExternalRequest
  }
}
    ${exports.ExternalRequest}`;
exports.deleteManyExternalRequest = (0, graphql_tag_1.default) `
    mutation deleteManyExternalRequest($where: ExternalRequestWhereInput) {
  deleteManyExternalRequest(where: $where) {
    count
  }
}
    `;
exports.updateManyExternalRequest = (0, graphql_tag_1.default) `
    mutation updateManyExternalRequest($where: ExternalRequestWhereInput, $data: ExternalRequestUpdateManyMutationInput!) {
  updateManyExternalRequest(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueFaQ = (0, graphql_tag_1.default) `
    query findUniqueFaQ($where: FaQWhereUniqueInput!) {
  findUniqueFaQ(where: $where) {
    ...FaQ
  }
}
    ${exports.FaQ}`;
exports.findManyFaQ = (0, graphql_tag_1.default) `
    query findManyFaQ($where: FaQWhereInput, $orderBy: [FaQOrderByWithRelationInput!], $cursor: FaQWhereUniqueInput, $skip: Int, $take: Int) {
  findManyFaQ(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...FaQ
  }
}
    ${exports.FaQ}`;
exports.findManyFaQCount = (0, graphql_tag_1.default) `
    query findManyFaQCount($where: FaQWhereInput, $orderBy: [FaQOrderByWithRelationInput!], $cursor: FaQWhereUniqueInput, $skip: Int, $take: Int) {
  findManyFaQCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneFaQ = (0, graphql_tag_1.default) `
    mutation createOneFaQ($data: FaQCreateInput!) {
  createOneFaQ(data: $data) {
    ...FaQ
  }
}
    ${exports.FaQ}`;
exports.updateOneFaQ = (0, graphql_tag_1.default) `
    mutation updateOneFaQ($where: FaQWhereUniqueInput!, $data: FaQUpdateInput!) {
  updateOneFaQ(where: $where, data: $data) {
    ...FaQ
  }
}
    ${exports.FaQ}`;
exports.deleteOneFaQ = (0, graphql_tag_1.default) `
    mutation deleteOneFaQ($where: FaQWhereUniqueInput!) {
  deleteOneFaQ(where: $where) {
    ...FaQ
  }
}
    ${exports.FaQ}`;
exports.deleteManyFaQ = (0, graphql_tag_1.default) `
    mutation deleteManyFaQ($where: FaQWhereInput) {
  deleteManyFaQ(where: $where) {
    count
  }
}
    `;
exports.updateManyFaQ = (0, graphql_tag_1.default) `
    mutation updateManyFaQ($where: FaQWhereInput, $data: FaQUpdateManyMutationInput!) {
  updateManyFaQ(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueFollow = (0, graphql_tag_1.default) `
    query findUniqueFollow($where: FollowWhereUniqueInput!) {
  findUniqueFollow(where: $where) {
    ...Follow
  }
}
    ${exports.Follow}`;
exports.findManyFollow = (0, graphql_tag_1.default) `
    query findManyFollow($where: FollowWhereInput, $orderBy: [FollowOrderByWithRelationInput!], $cursor: FollowWhereUniqueInput, $skip: Int, $take: Int) {
  findManyFollow(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Follow
  }
}
    ${exports.Follow}`;
exports.findManyFollowCount = (0, graphql_tag_1.default) `
    query findManyFollowCount($where: FollowWhereInput, $orderBy: [FollowOrderByWithRelationInput!], $cursor: FollowWhereUniqueInput, $skip: Int, $take: Int) {
  findManyFollowCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneFollow = (0, graphql_tag_1.default) `
    mutation createOneFollow($data: FollowCreateInput!) {
  createOneFollow(data: $data) {
    ...Follow
  }
}
    ${exports.Follow}`;
exports.updateOneFollow = (0, graphql_tag_1.default) `
    mutation updateOneFollow($where: FollowWhereUniqueInput!, $data: FollowUpdateInput!) {
  updateOneFollow(where: $where, data: $data) {
    ...Follow
  }
}
    ${exports.Follow}`;
exports.deleteOneFollow = (0, graphql_tag_1.default) `
    mutation deleteOneFollow($where: FollowWhereUniqueInput!) {
  deleteOneFollow(where: $where) {
    ...Follow
  }
}
    ${exports.Follow}`;
exports.deleteManyFollow = (0, graphql_tag_1.default) `
    mutation deleteManyFollow($where: FollowWhereInput) {
  deleteManyFollow(where: $where) {
    count
  }
}
    `;
exports.updateManyFollow = (0, graphql_tag_1.default) `
    mutation updateManyFollow($where: FollowWhereInput, $data: FollowUpdateManyMutationInput!) {
  updateManyFollow(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueHashTag = (0, graphql_tag_1.default) `
    query findUniqueHashTag($where: HashTagWhereUniqueInput!) {
  findUniqueHashTag(where: $where) {
    ...HashTag
  }
}
    ${exports.HashTag}`;
exports.findManyHashTag = (0, graphql_tag_1.default) `
    query findManyHashTag($where: HashTagWhereInput, $orderBy: [HashTagOrderByWithRelationInput!], $cursor: HashTagWhereUniqueInput, $skip: Int, $take: Int) {
  findManyHashTag(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...HashTag
  }
}
    ${exports.HashTag}`;
exports.findManyHashTagCount = (0, graphql_tag_1.default) `
    query findManyHashTagCount($where: HashTagWhereInput, $orderBy: [HashTagOrderByWithRelationInput!], $cursor: HashTagWhereUniqueInput, $skip: Int, $take: Int) {
  findManyHashTagCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneHashTag = (0, graphql_tag_1.default) `
    mutation createOneHashTag($data: HashTagCreateInput!) {
  createOneHashTag(data: $data) {
    ...HashTag
  }
}
    ${exports.HashTag}`;
exports.updateOneHashTag = (0, graphql_tag_1.default) `
    mutation updateOneHashTag($where: HashTagWhereUniqueInput!, $data: HashTagUpdateInput!) {
  updateOneHashTag(where: $where, data: $data) {
    ...HashTag
  }
}
    ${exports.HashTag}`;
exports.deleteOneHashTag = (0, graphql_tag_1.default) `
    mutation deleteOneHashTag($where: HashTagWhereUniqueInput!) {
  deleteOneHashTag(where: $where) {
    ...HashTag
  }
}
    ${exports.HashTag}`;
exports.deleteManyHashTag = (0, graphql_tag_1.default) `
    mutation deleteManyHashTag($where: HashTagWhereInput) {
  deleteManyHashTag(where: $where) {
    count
  }
}
    `;
exports.updateManyHashTag = (0, graphql_tag_1.default) `
    mutation updateManyHashTag($where: HashTagWhereInput, $data: HashTagUpdateManyMutationInput!) {
  updateManyHashTag(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueJobOffer = (0, graphql_tag_1.default) `
    query findUniqueJobOffer($where: JobOfferWhereUniqueInput!) {
  findUniqueJobOffer(where: $where) {
    ...JobOffer
  }
}
    ${exports.JobOffer}`;
exports.findManyJobOffer = (0, graphql_tag_1.default) `
    query findManyJobOffer($where: JobOfferWhereInput, $orderBy: [JobOfferOrderByWithRelationInput!], $cursor: JobOfferWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobOffer(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...JobOffer
  }
}
    ${exports.JobOffer}`;
exports.findManyJobOfferCount = (0, graphql_tag_1.default) `
    query findManyJobOfferCount($where: JobOfferWhereInput, $orderBy: [JobOfferOrderByWithRelationInput!], $cursor: JobOfferWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobOfferCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneJobOffer = (0, graphql_tag_1.default) `
    mutation createOneJobOffer($data: JobOfferCreateInput!) {
  createOneJobOffer(data: $data) {
    ...JobOffer
  }
}
    ${exports.JobOffer}`;
exports.updateOneJobOffer = (0, graphql_tag_1.default) `
    mutation updateOneJobOffer($where: JobOfferWhereUniqueInput!, $data: JobOfferUpdateInput!) {
  updateOneJobOffer(where: $where, data: $data) {
    ...JobOffer
  }
}
    ${exports.JobOffer}`;
exports.deleteOneJobOffer = (0, graphql_tag_1.default) `
    mutation deleteOneJobOffer($where: JobOfferWhereUniqueInput!) {
  deleteOneJobOffer(where: $where) {
    ...JobOffer
  }
}
    ${exports.JobOffer}`;
exports.deleteManyJobOffer = (0, graphql_tag_1.default) `
    mutation deleteManyJobOffer($where: JobOfferWhereInput) {
  deleteManyJobOffer(where: $where) {
    count
  }
}
    `;
exports.updateManyJobOffer = (0, graphql_tag_1.default) `
    mutation updateManyJobOffer($where: JobOfferWhereInput, $data: JobOfferUpdateManyMutationInput!) {
  updateManyJobOffer(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueJobOfferResponse = (0, graphql_tag_1.default) `
    query findUniqueJobOfferResponse($where: JobOfferResponseWhereUniqueInput!) {
  findUniqueJobOfferResponse(where: $where) {
    ...JobOfferResponse
  }
}
    ${exports.JobOfferResponse}`;
exports.findManyJobOfferResponse = (0, graphql_tag_1.default) `
    query findManyJobOfferResponse($where: JobOfferResponseWhereInput, $orderBy: [JobOfferResponseOrderByWithRelationInput!], $cursor: JobOfferResponseWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobOfferResponse(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...JobOfferResponse
  }
}
    ${exports.JobOfferResponse}`;
exports.findManyJobOfferResponseCount = (0, graphql_tag_1.default) `
    query findManyJobOfferResponseCount($where: JobOfferResponseWhereInput, $orderBy: [JobOfferResponseOrderByWithRelationInput!], $cursor: JobOfferResponseWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobOfferResponseCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.updateOneJobOfferResponse = (0, graphql_tag_1.default) `
    mutation updateOneJobOfferResponse($where: JobOfferResponseWhereUniqueInput!, $data: JobOfferResponseUpdateInput!) {
  updateOneJobOfferResponse(where: $where, data: $data) {
    ...JobOfferResponse
  }
}
    ${exports.JobOfferResponse}`;
exports.deleteOneJobOfferResponse = (0, graphql_tag_1.default) `
    mutation deleteOneJobOfferResponse($where: JobOfferResponseWhereUniqueInput!) {
  deleteOneJobOfferResponse(where: $where) {
    ...JobOfferResponse
  }
}
    ${exports.JobOfferResponse}`;
exports.deleteManyJobOfferResponse = (0, graphql_tag_1.default) `
    mutation deleteManyJobOfferResponse($where: JobOfferResponseWhereInput) {
  deleteManyJobOfferResponse(where: $where) {
    count
  }
}
    `;
exports.findUniqueJobOutput = (0, graphql_tag_1.default) `
    query findUniqueJobOutput($where: JobOutputWhereUniqueInput!) {
  findUniqueJobOutput(where: $where) {
    ...JobOutput
  }
}
    ${exports.JobOutput}`;
exports.findManyJobOutput = (0, graphql_tag_1.default) `
    query findManyJobOutput($where: JobOutputWhereInput, $orderBy: [JobOutputOrderByWithRelationInput!], $cursor: JobOutputWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobOutput(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...JobOutput
  }
}
    ${exports.JobOutput}`;
exports.findManyJobOutputCount = (0, graphql_tag_1.default) `
    query findManyJobOutputCount($where: JobOutputWhereInput, $orderBy: [JobOutputOrderByWithRelationInput!], $cursor: JobOutputWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobOutputCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneJobOutput = (0, graphql_tag_1.default) `
    mutation createOneJobOutput($data: JobOutputCreateInput!) {
  createOneJobOutput(data: $data) {
    ...JobOutput
  }
}
    ${exports.JobOutput}`;
exports.updateOneJobOutput = (0, graphql_tag_1.default) `
    mutation updateOneJobOutput($where: JobOutputWhereUniqueInput!, $data: JobOutputUpdateInput!) {
  updateOneJobOutput(where: $where, data: $data) {
    ...JobOutput
  }
}
    ${exports.JobOutput}`;
exports.deleteOneJobOutput = (0, graphql_tag_1.default) `
    mutation deleteOneJobOutput($where: JobOutputWhereUniqueInput!) {
  deleteOneJobOutput(where: $where) {
    ...JobOutput
  }
}
    ${exports.JobOutput}`;
exports.deleteManyJobOutput = (0, graphql_tag_1.default) `
    mutation deleteManyJobOutput($where: JobOutputWhereInput) {
  deleteManyJobOutput(where: $where) {
    count
  }
}
    `;
exports.updateManyJobOutput = (0, graphql_tag_1.default) `
    mutation updateManyJobOutput($where: JobOutputWhereInput, $data: JobOutputUpdateManyMutationInput!) {
  updateManyJobOutput(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueJobReview = (0, graphql_tag_1.default) `
    query findUniqueJobReview($where: JobReviewWhereUniqueInput!) {
  findUniqueJobReview(where: $where) {
    ...JobReview
  }
}
    ${exports.JobReview}`;
exports.findManyJobReview = (0, graphql_tag_1.default) `
    query findManyJobReview($where: JobReviewWhereInput, $orderBy: [JobReviewOrderByWithRelationInput!], $cursor: JobReviewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobReview(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...JobReview
  }
}
    ${exports.JobReview}`;
exports.findManyJobReviewCount = (0, graphql_tag_1.default) `
    query findManyJobReviewCount($where: JobReviewWhereInput, $orderBy: [JobReviewOrderByWithRelationInput!], $cursor: JobReviewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobReviewCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneJobReview = (0, graphql_tag_1.default) `
    mutation createOneJobReview($data: JobReviewCreateInput!) {
  createOneJobReview(data: $data) {
    ...JobReview
  }
}
    ${exports.JobReview}`;
exports.updateOneJobReview = (0, graphql_tag_1.default) `
    mutation updateOneJobReview($where: JobReviewWhereUniqueInput!, $data: JobReviewUpdateInput!) {
  updateOneJobReview(where: $where, data: $data) {
    ...JobReview
  }
}
    ${exports.JobReview}`;
exports.deleteOneJobReview = (0, graphql_tag_1.default) `
    mutation deleteOneJobReview($where: JobReviewWhereUniqueInput!) {
  deleteOneJobReview(where: $where) {
    ...JobReview
  }
}
    ${exports.JobReview}`;
exports.deleteManyJobReview = (0, graphql_tag_1.default) `
    mutation deleteManyJobReview($where: JobReviewWhereInput) {
  deleteManyJobReview(where: $where) {
    count
  }
}
    `;
exports.updateManyJobReview = (0, graphql_tag_1.default) `
    mutation updateManyJobReview($where: JobReviewWhereInput, $data: JobReviewUpdateManyMutationInput!) {
  updateManyJobReview(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueJobTransaction = (0, graphql_tag_1.default) `
    query findUniqueJobTransaction($where: JobTransactionWhereUniqueInput!) {
  findUniqueJobTransaction(where: $where) {
    ...JobTransaction
  }
}
    ${exports.JobTransaction}`;
exports.findManyJobTransaction = (0, graphql_tag_1.default) `
    query findManyJobTransaction($where: JobTransactionWhereInput, $orderBy: [JobTransactionOrderByWithRelationInput!], $cursor: JobTransactionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobTransaction(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...JobTransaction
  }
}
    ${exports.JobTransaction}`;
exports.findManyJobTransactionCount = (0, graphql_tag_1.default) `
    query findManyJobTransactionCount($where: JobTransactionWhereInput, $orderBy: [JobTransactionOrderByWithRelationInput!], $cursor: JobTransactionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyJobTransactionCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneJobTransaction = (0, graphql_tag_1.default) `
    mutation createOneJobTransaction($data: JobTransactionCreateInput!) {
  createOneJobTransaction(data: $data) {
    ...JobTransaction
  }
}
    ${exports.JobTransaction}`;
exports.updateOneJobTransaction = (0, graphql_tag_1.default) `
    mutation updateOneJobTransaction($where: JobTransactionWhereUniqueInput!, $data: JobTransactionUpdateInput!) {
  updateOneJobTransaction(where: $where, data: $data) {
    ...JobTransaction
  }
}
    ${exports.JobTransaction}`;
exports.deleteOneJobTransaction = (0, graphql_tag_1.default) `
    mutation deleteOneJobTransaction($where: JobTransactionWhereUniqueInput!) {
  deleteOneJobTransaction(where: $where) {
    ...JobTransaction
  }
}
    ${exports.JobTransaction}`;
exports.deleteManyJobTransaction = (0, graphql_tag_1.default) `
    mutation deleteManyJobTransaction($where: JobTransactionWhereInput) {
  deleteManyJobTransaction(where: $where) {
    count
  }
}
    `;
exports.updateManyJobTransaction = (0, graphql_tag_1.default) `
    mutation updateManyJobTransaction($where: JobTransactionWhereInput, $data: JobTransactionUpdateManyMutationInput!) {
  updateManyJobTransaction(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonCreator = (0, graphql_tag_1.default) `
    query findUniqueLessonCreator($where: LessonCreatorWhereUniqueInput!) {
  findUniqueLessonCreator(where: $where) {
    ...LessonCreator
  }
}
    ${exports.LessonCreator}`;
exports.findManyLessonCreator = (0, graphql_tag_1.default) `
    query findManyLessonCreator($where: LessonCreatorWhereInput, $orderBy: [LessonCreatorOrderByWithRelationInput!], $cursor: LessonCreatorWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonCreator(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonCreator
  }
}
    ${exports.LessonCreator}`;
exports.findManyLessonCreatorCount = (0, graphql_tag_1.default) `
    query findManyLessonCreatorCount($where: LessonCreatorWhereInput, $orderBy: [LessonCreatorOrderByWithRelationInput!], $cursor: LessonCreatorWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonCreatorCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonCreator = (0, graphql_tag_1.default) `
    mutation createOneLessonCreator($data: LessonCreatorCreateInput!) {
  createOneLessonCreator(data: $data) {
    ...LessonCreator
  }
}
    ${exports.LessonCreator}`;
exports.updateOneLessonCreator = (0, graphql_tag_1.default) `
    mutation updateOneLessonCreator($where: LessonCreatorWhereUniqueInput!, $data: LessonCreatorUpdateInput!) {
  updateOneLessonCreator(where: $where, data: $data) {
    ...LessonCreator
  }
}
    ${exports.LessonCreator}`;
exports.deleteOneLessonCreator = (0, graphql_tag_1.default) `
    mutation deleteOneLessonCreator($where: LessonCreatorWhereUniqueInput!) {
  deleteOneLessonCreator(where: $where) {
    ...LessonCreator
  }
}
    ${exports.LessonCreator}`;
exports.deleteManyLessonCreator = (0, graphql_tag_1.default) `
    mutation deleteManyLessonCreator($where: LessonCreatorWhereInput) {
  deleteManyLessonCreator(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonCreator = (0, graphql_tag_1.default) `
    mutation updateManyLessonCreator($where: LessonCreatorWhereInput, $data: LessonCreatorUpdateManyMutationInput!) {
  updateManyLessonCreator(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonExam = (0, graphql_tag_1.default) `
    query findUniqueLessonExam($where: LessonExamWhereUniqueInput!) {
  findUniqueLessonExam(where: $where) {
    ...LessonExam
  }
}
    ${exports.LessonExam}`;
exports.findManyLessonExam = (0, graphql_tag_1.default) `
    query findManyLessonExam($where: LessonExamWhereInput, $orderBy: [LessonExamOrderByWithRelationInput!], $cursor: LessonExamWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonExam(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonExam
  }
}
    ${exports.LessonExam}`;
exports.findManyLessonExamCount = (0, graphql_tag_1.default) `
    query findManyLessonExamCount($where: LessonExamWhereInput, $orderBy: [LessonExamOrderByWithRelationInput!], $cursor: LessonExamWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonExamCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonExam = (0, graphql_tag_1.default) `
    mutation createOneLessonExam($data: LessonExamCreateInput!) {
  createOneLessonExam(data: $data) {
    ...LessonExam
  }
}
    ${exports.LessonExam}`;
exports.updateOneLessonExam = (0, graphql_tag_1.default) `
    mutation updateOneLessonExam($where: LessonExamWhereUniqueInput!, $data: LessonExamUpdateInput!) {
  updateOneLessonExam(where: $where, data: $data) {
    ...LessonExam
  }
}
    ${exports.LessonExam}`;
exports.deleteOneLessonExam = (0, graphql_tag_1.default) `
    mutation deleteOneLessonExam($where: LessonExamWhereUniqueInput!) {
  deleteOneLessonExam(where: $where) {
    ...LessonExam
  }
}
    ${exports.LessonExam}`;
exports.deleteManyLessonExam = (0, graphql_tag_1.default) `
    mutation deleteManyLessonExam($where: LessonExamWhereInput) {
  deleteManyLessonExam(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonExam = (0, graphql_tag_1.default) `
    mutation updateManyLessonExam($where: LessonExamWhereInput, $data: LessonExamUpdateManyMutationInput!) {
  updateManyLessonExam(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonExamQuestion = (0, graphql_tag_1.default) `
    query findUniqueLessonExamQuestion($where: LessonExamQuestionWhereUniqueInput!) {
  findUniqueLessonExamQuestion(where: $where) {
    ...LessonExamQuestion
  }
}
    ${exports.LessonExamQuestion}`;
exports.findManyLessonExamQuestion = (0, graphql_tag_1.default) `
    query findManyLessonExamQuestion($where: LessonExamQuestionWhereInput, $orderBy: [LessonExamQuestionOrderByWithRelationInput!], $cursor: LessonExamQuestionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonExamQuestion(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonExamQuestion
  }
}
    ${exports.LessonExamQuestion}`;
exports.findManyLessonExamQuestionCount = (0, graphql_tag_1.default) `
    query findManyLessonExamQuestionCount($where: LessonExamQuestionWhereInput, $orderBy: [LessonExamQuestionOrderByWithRelationInput!], $cursor: LessonExamQuestionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonExamQuestionCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonExamQuestion = (0, graphql_tag_1.default) `
    mutation createOneLessonExamQuestion($data: LessonExamQuestionCreateInput!) {
  createOneLessonExamQuestion(data: $data) {
    ...LessonExamQuestion
  }
}
    ${exports.LessonExamQuestion}`;
exports.updateOneLessonExamQuestion = (0, graphql_tag_1.default) `
    mutation updateOneLessonExamQuestion($where: LessonExamQuestionWhereUniqueInput!, $data: LessonExamQuestionUpdateInput!) {
  updateOneLessonExamQuestion(where: $where, data: $data) {
    ...LessonExamQuestion
  }
}
    ${exports.LessonExamQuestion}`;
exports.deleteOneLessonExamQuestion = (0, graphql_tag_1.default) `
    mutation deleteOneLessonExamQuestion($where: LessonExamQuestionWhereUniqueInput!) {
  deleteOneLessonExamQuestion(where: $where) {
    ...LessonExamQuestion
  }
}
    ${exports.LessonExamQuestion}`;
exports.deleteManyLessonExamQuestion = (0, graphql_tag_1.default) `
    mutation deleteManyLessonExamQuestion($where: LessonExamQuestionWhereInput) {
  deleteManyLessonExamQuestion(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonExamQuestion = (0, graphql_tag_1.default) `
    mutation updateManyLessonExamQuestion($where: LessonExamQuestionWhereInput, $data: LessonExamQuestionUpdateManyMutationInput!) {
  updateManyLessonExamQuestion(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonFlashcard = (0, graphql_tag_1.default) `
    query findUniqueLessonFlashcard($where: LessonFlashcardWhereUniqueInput!) {
  findUniqueLessonFlashcard(where: $where) {
    ...LessonFlashcard
  }
}
    ${exports.LessonFlashcard}`;
exports.findManyLessonFlashcard = (0, graphql_tag_1.default) `
    query findManyLessonFlashcard($where: LessonFlashcardWhereInput, $orderBy: [LessonFlashcardOrderByWithRelationInput!], $cursor: LessonFlashcardWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonFlashcard(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonFlashcard
  }
}
    ${exports.LessonFlashcard}`;
exports.findManyLessonFlashcardCount = (0, graphql_tag_1.default) `
    query findManyLessonFlashcardCount($where: LessonFlashcardWhereInput, $orderBy: [LessonFlashcardOrderByWithRelationInput!], $cursor: LessonFlashcardWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonFlashcardCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonFlashcard = (0, graphql_tag_1.default) `
    mutation createOneLessonFlashcard($data: LessonFlashcardCreateInput!) {
  createOneLessonFlashcard(data: $data) {
    ...LessonFlashcard
  }
}
    ${exports.LessonFlashcard}`;
exports.updateOneLessonFlashcard = (0, graphql_tag_1.default) `
    mutation updateOneLessonFlashcard($where: LessonFlashcardWhereUniqueInput!, $data: LessonFlashcardUpdateInput!) {
  updateOneLessonFlashcard(where: $where, data: $data) {
    ...LessonFlashcard
  }
}
    ${exports.LessonFlashcard}`;
exports.deleteOneLessonFlashcard = (0, graphql_tag_1.default) `
    mutation deleteOneLessonFlashcard($where: LessonFlashcardWhereUniqueInput!) {
  deleteOneLessonFlashcard(where: $where) {
    ...LessonFlashcard
  }
}
    ${exports.LessonFlashcard}`;
exports.deleteManyLessonFlashcard = (0, graphql_tag_1.default) `
    mutation deleteManyLessonFlashcard($where: LessonFlashcardWhereInput) {
  deleteManyLessonFlashcard(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonFlashcard = (0, graphql_tag_1.default) `
    mutation updateManyLessonFlashcard($where: LessonFlashcardWhereInput, $data: LessonFlashcardUpdateManyMutationInput!) {
  updateManyLessonFlashcard(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonFlashcardDeck = (0, graphql_tag_1.default) `
    query findUniqueLessonFlashcardDeck($where: LessonFlashcardDeckWhereUniqueInput!) {
  findUniqueLessonFlashcardDeck(where: $where) {
    ...LessonFlashcardDeck
  }
}
    ${exports.LessonFlashcardDeck}`;
exports.findManyLessonFlashcardDeck = (0, graphql_tag_1.default) `
    query findManyLessonFlashcardDeck($where: LessonFlashcardDeckWhereInput, $orderBy: [LessonFlashcardDeckOrderByWithRelationInput!], $cursor: LessonFlashcardDeckWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonFlashcardDeck(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonFlashcardDeck
  }
}
    ${exports.LessonFlashcardDeck}`;
exports.findManyLessonFlashcardDeckCount = (0, graphql_tag_1.default) `
    query findManyLessonFlashcardDeckCount($where: LessonFlashcardDeckWhereInput, $orderBy: [LessonFlashcardDeckOrderByWithRelationInput!], $cursor: LessonFlashcardDeckWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonFlashcardDeckCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonFlashcardDeck = (0, graphql_tag_1.default) `
    mutation createOneLessonFlashcardDeck($data: LessonFlashcardDeckCreateInput!) {
  createOneLessonFlashcardDeck(data: $data) {
    ...LessonFlashcardDeck
  }
}
    ${exports.LessonFlashcardDeck}`;
exports.updateOneLessonFlashcardDeck = (0, graphql_tag_1.default) `
    mutation updateOneLessonFlashcardDeck($where: LessonFlashcardDeckWhereUniqueInput!, $data: LessonFlashcardDeckUpdateInput!) {
  updateOneLessonFlashcardDeck(where: $where, data: $data) {
    ...LessonFlashcardDeck
  }
}
    ${exports.LessonFlashcardDeck}`;
exports.deleteOneLessonFlashcardDeck = (0, graphql_tag_1.default) `
    mutation deleteOneLessonFlashcardDeck($where: LessonFlashcardDeckWhereUniqueInput!) {
  deleteOneLessonFlashcardDeck(where: $where) {
    ...LessonFlashcardDeck
  }
}
    ${exports.LessonFlashcardDeck}`;
exports.deleteManyLessonFlashcardDeck = (0, graphql_tag_1.default) `
    mutation deleteManyLessonFlashcardDeck($where: LessonFlashcardDeckWhereInput) {
  deleteManyLessonFlashcardDeck(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonFlashcardDeck = (0, graphql_tag_1.default) `
    mutation updateManyLessonFlashcardDeck($where: LessonFlashcardDeckWhereInput, $data: LessonFlashcardDeckUpdateManyMutationInput!) {
  updateManyLessonFlashcardDeck(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonItemGroup = (0, graphql_tag_1.default) `
    query findUniqueLessonItemGroup($where: LessonItemGroupWhereUniqueInput!) {
  findUniqueLessonItemGroup(where: $where) {
    ...LessonItemGroup
  }
}
    ${exports.LessonItemGroup}`;
exports.findManyLessonItemGroup = (0, graphql_tag_1.default) `
    query findManyLessonItemGroup($where: LessonItemGroupWhereInput, $orderBy: [LessonItemGroupOrderByWithRelationInput!], $cursor: LessonItemGroupWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonItemGroup(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonItemGroup
  }
}
    ${exports.LessonItemGroup}`;
exports.findManyLessonItemGroupCount = (0, graphql_tag_1.default) `
    query findManyLessonItemGroupCount($where: LessonItemGroupWhereInput, $orderBy: [LessonItemGroupOrderByWithRelationInput!], $cursor: LessonItemGroupWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonItemGroupCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonItemGroup = (0, graphql_tag_1.default) `
    mutation createOneLessonItemGroup($data: LessonItemGroupCreateInput!) {
  createOneLessonItemGroup(data: $data) {
    ...LessonItemGroup
  }
}
    ${exports.LessonItemGroup}`;
exports.updateOneLessonItemGroup = (0, graphql_tag_1.default) `
    mutation updateOneLessonItemGroup($where: LessonItemGroupWhereUniqueInput!, $data: LessonItemGroupUpdateInput!) {
  updateOneLessonItemGroup(where: $where, data: $data) {
    ...LessonItemGroup
  }
}
    ${exports.LessonItemGroup}`;
exports.deleteOneLessonItemGroup = (0, graphql_tag_1.default) `
    mutation deleteOneLessonItemGroup($where: LessonItemGroupWhereUniqueInput!) {
  deleteOneLessonItemGroup(where: $where) {
    ...LessonItemGroup
  }
}
    ${exports.LessonItemGroup}`;
exports.deleteManyLessonItemGroup = (0, graphql_tag_1.default) `
    mutation deleteManyLessonItemGroup($where: LessonItemGroupWhereInput) {
  deleteManyLessonItemGroup(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonItemGroup = (0, graphql_tag_1.default) `
    mutation updateManyLessonItemGroup($where: LessonItemGroupWhereInput, $data: LessonItemGroupUpdateManyMutationInput!) {
  updateManyLessonItemGroup(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonKeyword = (0, graphql_tag_1.default) `
    query findUniqueLessonKeyword($where: LessonKeywordWhereUniqueInput!) {
  findUniqueLessonKeyword(where: $where) {
    ...LessonKeyword
  }
}
    ${exports.LessonKeyword}`;
exports.findManyLessonKeyword = (0, graphql_tag_1.default) `
    query findManyLessonKeyword($where: LessonKeywordWhereInput, $orderBy: [LessonKeywordOrderByWithRelationInput!], $cursor: LessonKeywordWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonKeyword(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonKeyword
  }
}
    ${exports.LessonKeyword}`;
exports.findManyLessonKeywordCount = (0, graphql_tag_1.default) `
    query findManyLessonKeywordCount($where: LessonKeywordWhereInput, $orderBy: [LessonKeywordOrderByWithRelationInput!], $cursor: LessonKeywordWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonKeywordCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonKeyword = (0, graphql_tag_1.default) `
    mutation createOneLessonKeyword($data: LessonKeywordCreateInput!) {
  createOneLessonKeyword(data: $data) {
    ...LessonKeyword
  }
}
    ${exports.LessonKeyword}`;
exports.updateOneLessonKeyword = (0, graphql_tag_1.default) `
    mutation updateOneLessonKeyword($where: LessonKeywordWhereUniqueInput!, $data: LessonKeywordUpdateInput!) {
  updateOneLessonKeyword(where: $where, data: $data) {
    ...LessonKeyword
  }
}
    ${exports.LessonKeyword}`;
exports.deleteOneLessonKeyword = (0, graphql_tag_1.default) `
    mutation deleteOneLessonKeyword($where: LessonKeywordWhereUniqueInput!) {
  deleteOneLessonKeyword(where: $where) {
    ...LessonKeyword
  }
}
    ${exports.LessonKeyword}`;
exports.deleteManyLessonKeyword = (0, graphql_tag_1.default) `
    mutation deleteManyLessonKeyword($where: LessonKeywordWhereInput) {
  deleteManyLessonKeyword(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonKeyword = (0, graphql_tag_1.default) `
    mutation updateManyLessonKeyword($where: LessonKeywordWhereInput, $data: LessonKeywordUpdateManyMutationInput!) {
  updateManyLessonKeyword(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonSubject = (0, graphql_tag_1.default) `
    query findUniqueLessonSubject($where: LessonSubjectWhereUniqueInput!) {
  findUniqueLessonSubject(where: $where) {
    ...LessonSubject
  }
}
    ${exports.LessonSubject}`;
exports.findManyLessonSubject = (0, graphql_tag_1.default) `
    query findManyLessonSubject($where: LessonSubjectWhereInput, $orderBy: [LessonSubjectOrderByWithRelationInput!], $cursor: LessonSubjectWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonSubject(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonSubject
  }
}
    ${exports.LessonSubject}`;
exports.findManyLessonSubjectCount = (0, graphql_tag_1.default) `
    query findManyLessonSubjectCount($where: LessonSubjectWhereInput, $orderBy: [LessonSubjectOrderByWithRelationInput!], $cursor: LessonSubjectWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonSubjectCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonSubject = (0, graphql_tag_1.default) `
    mutation createOneLessonSubject($data: LessonSubjectCreateInput!) {
  createOneLessonSubject(data: $data) {
    ...LessonSubject
  }
}
    ${exports.LessonSubject}`;
exports.updateOneLessonSubject = (0, graphql_tag_1.default) `
    mutation updateOneLessonSubject($where: LessonSubjectWhereUniqueInput!, $data: LessonSubjectUpdateInput!) {
  updateOneLessonSubject(where: $where, data: $data) {
    ...LessonSubject
  }
}
    ${exports.LessonSubject}`;
exports.deleteOneLessonSubject = (0, graphql_tag_1.default) `
    mutation deleteOneLessonSubject($where: LessonSubjectWhereUniqueInput!) {
  deleteOneLessonSubject(where: $where) {
    ...LessonSubject
  }
}
    ${exports.LessonSubject}`;
exports.deleteManyLessonSubject = (0, graphql_tag_1.default) `
    mutation deleteManyLessonSubject($where: LessonSubjectWhereInput) {
  deleteManyLessonSubject(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonSubject = (0, graphql_tag_1.default) `
    mutation updateManyLessonSubject($where: LessonSubjectWhereInput, $data: LessonSubjectUpdateManyMutationInput!) {
  updateManyLessonSubject(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonUnit = (0, graphql_tag_1.default) `
    query findUniqueLessonUnit($where: LessonUnitWhereUniqueInput!) {
  findUniqueLessonUnit(where: $where) {
    ...LessonUnit
  }
}
    ${exports.LessonUnit}`;
exports.findManyLessonUnit = (0, graphql_tag_1.default) `
    query findManyLessonUnit($where: LessonUnitWhereInput, $orderBy: [LessonUnitOrderByWithRelationInput!], $cursor: LessonUnitWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonUnit(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonUnit
  }
}
    ${exports.LessonUnit}`;
exports.findManyLessonUnitCount = (0, graphql_tag_1.default) `
    query findManyLessonUnitCount($where: LessonUnitWhereInput, $orderBy: [LessonUnitOrderByWithRelationInput!], $cursor: LessonUnitWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonUnitCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonUnit = (0, graphql_tag_1.default) `
    mutation createOneLessonUnit($data: LessonUnitCreateInput!) {
  createOneLessonUnit(data: $data) {
    ...LessonUnit
  }
}
    ${exports.LessonUnit}`;
exports.updateOneLessonUnit = (0, graphql_tag_1.default) `
    mutation updateOneLessonUnit($where: LessonUnitWhereUniqueInput!, $data: LessonUnitUpdateInput!) {
  updateOneLessonUnit(where: $where, data: $data) {
    ...LessonUnit
  }
}
    ${exports.LessonUnit}`;
exports.deleteOneLessonUnit = (0, graphql_tag_1.default) `
    mutation deleteOneLessonUnit($where: LessonUnitWhereUniqueInput!) {
  deleteOneLessonUnit(where: $where) {
    ...LessonUnit
  }
}
    ${exports.LessonUnit}`;
exports.deleteManyLessonUnit = (0, graphql_tag_1.default) `
    mutation deleteManyLessonUnit($where: LessonUnitWhereInput) {
  deleteManyLessonUnit(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonUnit = (0, graphql_tag_1.default) `
    mutation updateManyLessonUnit($where: LessonUnitWhereInput, $data: LessonUnitUpdateManyMutationInput!) {
  updateManyLessonUnit(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonUser_FlashcardDeck = (0, graphql_tag_1.default) `
    query findUniqueLessonUser_FlashcardDeck($where: LessonUser_FlashcardDeckWhereUniqueInput!) {
  findUniqueLessonUser_FlashcardDeck(where: $where) {
    ...LessonUser_FlashcardDeck
  }
}
    ${exports.LessonUser_FlashcardDeck}`;
exports.findManyLessonUser_FlashcardDeck = (0, graphql_tag_1.default) `
    query findManyLessonUser_FlashcardDeck($where: LessonUser_FlashcardDeckWhereInput, $orderBy: [LessonUser_FlashcardDeckOrderByWithRelationInput!], $cursor: LessonUser_FlashcardDeckWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonUser_FlashcardDeck(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonUser_FlashcardDeck
  }
}
    ${exports.LessonUser_FlashcardDeck}`;
exports.findManyLessonUser_FlashcardDeckCount = (0, graphql_tag_1.default) `
    query findManyLessonUser_FlashcardDeckCount($where: LessonUser_FlashcardDeckWhereInput, $orderBy: [LessonUser_FlashcardDeckOrderByWithRelationInput!], $cursor: LessonUser_FlashcardDeckWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonUser_FlashcardDeckCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonUser_FlashcardDeck = (0, graphql_tag_1.default) `
    mutation createOneLessonUser_FlashcardDeck($data: LessonUser_FlashcardDeckCreateInput!) {
  createOneLessonUser_FlashcardDeck(data: $data) {
    ...LessonUser_FlashcardDeck
  }
}
    ${exports.LessonUser_FlashcardDeck}`;
exports.updateOneLessonUser_FlashcardDeck = (0, graphql_tag_1.default) `
    mutation updateOneLessonUser_FlashcardDeck($where: LessonUser_FlashcardDeckWhereUniqueInput!, $data: LessonUser_FlashcardDeckUpdateInput!) {
  updateOneLessonUser_FlashcardDeck(where: $where, data: $data) {
    ...LessonUser_FlashcardDeck
  }
}
    ${exports.LessonUser_FlashcardDeck}`;
exports.deleteOneLessonUser_FlashcardDeck = (0, graphql_tag_1.default) `
    mutation deleteOneLessonUser_FlashcardDeck($where: LessonUser_FlashcardDeckWhereUniqueInput!) {
  deleteOneLessonUser_FlashcardDeck(where: $where) {
    ...LessonUser_FlashcardDeck
  }
}
    ${exports.LessonUser_FlashcardDeck}`;
exports.deleteManyLessonUser_FlashcardDeck = (0, graphql_tag_1.default) `
    mutation deleteManyLessonUser_FlashcardDeck($where: LessonUser_FlashcardDeckWhereInput) {
  deleteManyLessonUser_FlashcardDeck(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonUser_FlashcardDeck = (0, graphql_tag_1.default) `
    mutation updateManyLessonUser_FlashcardDeck($where: LessonUser_FlashcardDeckWhereInput, $data: LessonUser_FlashcardDeckUpdateManyMutationInput!) {
  updateManyLessonUser_FlashcardDeck(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonVideo = (0, graphql_tag_1.default) `
    query findUniqueLessonVideo($where: LessonVideoWhereUniqueInput!) {
  findUniqueLessonVideo(where: $where) {
    ...LessonVideo
  }
}
    ${exports.LessonVideo}`;
exports.findManyLessonVideo = (0, graphql_tag_1.default) `
    query findManyLessonVideo($where: LessonVideoWhereInput, $orderBy: [LessonVideoOrderByWithRelationInput!], $cursor: LessonVideoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonVideo(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonVideo
  }
}
    ${exports.LessonVideo}`;
exports.findManyLessonVideoCount = (0, graphql_tag_1.default) `
    query findManyLessonVideoCount($where: LessonVideoWhereInput, $orderBy: [LessonVideoOrderByWithRelationInput!], $cursor: LessonVideoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonVideoCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonVideo = (0, graphql_tag_1.default) `
    mutation createOneLessonVideo($data: LessonVideoCreateInput!) {
  createOneLessonVideo(data: $data) {
    ...LessonVideo
  }
}
    ${exports.LessonVideo}`;
exports.updateOneLessonVideo = (0, graphql_tag_1.default) `
    mutation updateOneLessonVideo($where: LessonVideoWhereUniqueInput!, $data: LessonVideoUpdateInput!) {
  updateOneLessonVideo(where: $where, data: $data) {
    ...LessonVideo
  }
}
    ${exports.LessonVideo}`;
exports.deleteOneLessonVideo = (0, graphql_tag_1.default) `
    mutation deleteOneLessonVideo($where: LessonVideoWhereUniqueInput!) {
  deleteOneLessonVideo(where: $where) {
    ...LessonVideo
  }
}
    ${exports.LessonVideo}`;
exports.deleteManyLessonVideo = (0, graphql_tag_1.default) `
    mutation deleteManyLessonVideo($where: LessonVideoWhereInput) {
  deleteManyLessonVideo(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonVideo = (0, graphql_tag_1.default) `
    mutation updateManyLessonVideo($where: LessonVideoWhereInput, $data: LessonVideoUpdateManyMutationInput!) {
  updateManyLessonVideo(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonWatchHistory = (0, graphql_tag_1.default) `
    query findUniqueLessonWatchHistory($where: LessonWatchHistoryWhereUniqueInput!) {
  findUniqueLessonWatchHistory(where: $where) {
    ...LessonWatchHistory
  }
}
    ${exports.LessonWatchHistory}`;
exports.findManyLessonWatchHistory = (0, graphql_tag_1.default) `
    query findManyLessonWatchHistory($where: LessonWatchHistoryWhereInput, $orderBy: [LessonWatchHistoryOrderByWithRelationInput!], $cursor: LessonWatchHistoryWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonWatchHistory(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonWatchHistory
  }
}
    ${exports.LessonWatchHistory}`;
exports.findManyLessonWatchHistoryCount = (0, graphql_tag_1.default) `
    query findManyLessonWatchHistoryCount($where: LessonWatchHistoryWhereInput, $orderBy: [LessonWatchHistoryOrderByWithRelationInput!], $cursor: LessonWatchHistoryWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonWatchHistoryCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonWatchHistory = (0, graphql_tag_1.default) `
    mutation createOneLessonWatchHistory($data: LessonWatchHistoryCreateInput!) {
  createOneLessonWatchHistory(data: $data) {
    ...LessonWatchHistory
  }
}
    ${exports.LessonWatchHistory}`;
exports.updateOneLessonWatchHistory = (0, graphql_tag_1.default) `
    mutation updateOneLessonWatchHistory($where: LessonWatchHistoryWhereUniqueInput!, $data: LessonWatchHistoryUpdateInput!) {
  updateOneLessonWatchHistory(where: $where, data: $data) {
    ...LessonWatchHistory
  }
}
    ${exports.LessonWatchHistory}`;
exports.deleteOneLessonWatchHistory = (0, graphql_tag_1.default) `
    mutation deleteOneLessonWatchHistory($where: LessonWatchHistoryWhereUniqueInput!) {
  deleteOneLessonWatchHistory(where: $where) {
    ...LessonWatchHistory
  }
}
    ${exports.LessonWatchHistory}`;
exports.deleteManyLessonWatchHistory = (0, graphql_tag_1.default) `
    mutation deleteManyLessonWatchHistory($where: LessonWatchHistoryWhereInput) {
  deleteManyLessonWatchHistory(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonWatchHistory = (0, graphql_tag_1.default) `
    mutation updateManyLessonWatchHistory($where: LessonWatchHistoryWhereInput, $data: LessonWatchHistoryUpdateManyMutationInput!) {
  updateManyLessonWatchHistory(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueLessonYouTubeUser = (0, graphql_tag_1.default) `
    query findUniqueLessonYouTubeUser($where: LessonYouTubeUserWhereUniqueInput!) {
  findUniqueLessonYouTubeUser(where: $where) {
    ...LessonYouTubeUser
  }
}
    ${exports.LessonYouTubeUser}`;
exports.findManyLessonYouTubeUser = (0, graphql_tag_1.default) `
    query findManyLessonYouTubeUser($where: LessonYouTubeUserWhereInput, $orderBy: [LessonYouTubeUserOrderByWithRelationInput!], $cursor: LessonYouTubeUserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonYouTubeUser(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...LessonYouTubeUser
  }
}
    ${exports.LessonYouTubeUser}`;
exports.findManyLessonYouTubeUserCount = (0, graphql_tag_1.default) `
    query findManyLessonYouTubeUserCount($where: LessonYouTubeUserWhereInput, $orderBy: [LessonYouTubeUserOrderByWithRelationInput!], $cursor: LessonYouTubeUserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyLessonYouTubeUserCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneLessonYouTubeUser = (0, graphql_tag_1.default) `
    mutation createOneLessonYouTubeUser($data: LessonYouTubeUserCreateInput!) {
  createOneLessonYouTubeUser(data: $data) {
    ...LessonYouTubeUser
  }
}
    ${exports.LessonYouTubeUser}`;
exports.updateOneLessonYouTubeUser = (0, graphql_tag_1.default) `
    mutation updateOneLessonYouTubeUser($where: LessonYouTubeUserWhereUniqueInput!, $data: LessonYouTubeUserUpdateInput!) {
  updateOneLessonYouTubeUser(where: $where, data: $data) {
    ...LessonYouTubeUser
  }
}
    ${exports.LessonYouTubeUser}`;
exports.deleteOneLessonYouTubeUser = (0, graphql_tag_1.default) `
    mutation deleteOneLessonYouTubeUser($where: LessonYouTubeUserWhereUniqueInput!) {
  deleteOneLessonYouTubeUser(where: $where) {
    ...LessonYouTubeUser
  }
}
    ${exports.LessonYouTubeUser}`;
exports.deleteManyLessonYouTubeUser = (0, graphql_tag_1.default) `
    mutation deleteManyLessonYouTubeUser($where: LessonYouTubeUserWhereInput) {
  deleteManyLessonYouTubeUser(where: $where) {
    count
  }
}
    `;
exports.updateManyLessonYouTubeUser = (0, graphql_tag_1.default) `
    mutation updateManyLessonYouTubeUser($where: LessonYouTubeUserWhereInput, $data: LessonYouTubeUserUpdateManyMutationInput!) {
  updateManyLessonYouTubeUser(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueMesgNotification = (0, graphql_tag_1.default) `
    query findUniqueMesgNotification($where: MesgNotificationWhereUniqueInput!) {
  findUniqueMesgNotification(where: $where) {
    ...MesgNotification
  }
}
    ${exports.MesgNotification}`;
exports.findManyMesgNotification = (0, graphql_tag_1.default) `
    query findManyMesgNotification($where: MesgNotificationWhereInput, $orderBy: [MesgNotificationOrderByWithRelationInput!], $cursor: MesgNotificationWhereUniqueInput, $skip: Int, $take: Int) {
  findManyMesgNotification(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...MesgNotification
  }
}
    ${exports.MesgNotification}`;
exports.findManyMesgNotificationCount = (0, graphql_tag_1.default) `
    query findManyMesgNotificationCount($where: MesgNotificationWhereInput, $orderBy: [MesgNotificationOrderByWithRelationInput!], $cursor: MesgNotificationWhereUniqueInput, $skip: Int, $take: Int) {
  findManyMesgNotificationCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneMesgNotification = (0, graphql_tag_1.default) `
    mutation createOneMesgNotification($data: MesgNotificationCreateInput!) {
  createOneMesgNotification(data: $data) {
    ...MesgNotification
  }
}
    ${exports.MesgNotification}`;
exports.updateOneMesgNotification = (0, graphql_tag_1.default) `
    mutation updateOneMesgNotification($where: MesgNotificationWhereUniqueInput!, $data: MesgNotificationUpdateInput!) {
  updateOneMesgNotification(where: $where, data: $data) {
    ...MesgNotification
  }
}
    ${exports.MesgNotification}`;
exports.deleteOneMesgNotification = (0, graphql_tag_1.default) `
    mutation deleteOneMesgNotification($where: MesgNotificationWhereUniqueInput!) {
  deleteOneMesgNotification(where: $where) {
    ...MesgNotification
  }
}
    ${exports.MesgNotification}`;
exports.deleteManyMesgNotification = (0, graphql_tag_1.default) `
    mutation deleteManyMesgNotification($where: MesgNotificationWhereInput) {
  deleteManyMesgNotification(where: $where) {
    count
  }
}
    `;
exports.updateManyMesgNotification = (0, graphql_tag_1.default) `
    mutation updateManyMesgNotification($where: MesgNotificationWhereInput, $data: MesgNotificationUpdateManyMutationInput!) {
  updateManyMesgNotification(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueMessageInfo = (0, graphql_tag_1.default) `
    query findUniqueMessageInfo($where: MessageInfoWhereUniqueInput!) {
  findUniqueMessageInfo(where: $where) {
    ...MessageInfo
  }
}
    ${exports.MessageInfo}`;
exports.findManyMessageInfo = (0, graphql_tag_1.default) `
    query findManyMessageInfo($where: MessageInfoWhereInput, $orderBy: [MessageInfoOrderByWithRelationInput!], $cursor: MessageInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyMessageInfo(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...MessageInfo
  }
}
    ${exports.MessageInfo}`;
exports.findManyMessageInfoCount = (0, graphql_tag_1.default) `
    query findManyMessageInfoCount($where: MessageInfoWhereInput, $orderBy: [MessageInfoOrderByWithRelationInput!], $cursor: MessageInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyMessageInfoCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneMessageInfo = (0, graphql_tag_1.default) `
    mutation createOneMessageInfo($data: MessageInfoCreateInput!) {
  createOneMessageInfo(data: $data) {
    ...MessageInfo
  }
}
    ${exports.MessageInfo}`;
exports.updateOneMessageInfo = (0, graphql_tag_1.default) `
    mutation updateOneMessageInfo($where: MessageInfoWhereUniqueInput!, $data: MessageInfoUpdateInput!) {
  updateOneMessageInfo(where: $where, data: $data) {
    ...MessageInfo
  }
}
    ${exports.MessageInfo}`;
exports.deleteOneMessageInfo = (0, graphql_tag_1.default) `
    mutation deleteOneMessageInfo($where: MessageInfoWhereUniqueInput!) {
  deleteOneMessageInfo(where: $where) {
    ...MessageInfo
  }
}
    ${exports.MessageInfo}`;
exports.deleteManyMessageInfo = (0, graphql_tag_1.default) `
    mutation deleteManyMessageInfo($where: MessageInfoWhereInput) {
  deleteManyMessageInfo(where: $where) {
    count
  }
}
    `;
exports.updateManyMessageInfo = (0, graphql_tag_1.default) `
    mutation updateManyMessageInfo($where: MessageInfoWhereInput, $data: MessageInfoUpdateManyMutationInput!) {
  updateManyMessageInfo(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueMessageTranslation = (0, graphql_tag_1.default) `
    query findUniqueMessageTranslation($where: MessageTranslationWhereUniqueInput!) {
  findUniqueMessageTranslation(where: $where) {
    ...MessageTranslation
  }
}
    ${exports.MessageTranslation}`;
exports.findManyMessageTranslation = (0, graphql_tag_1.default) `
    query findManyMessageTranslation($where: MessageTranslationWhereInput, $orderBy: [MessageTranslationOrderByWithRelationInput!], $cursor: MessageTranslationWhereUniqueInput, $skip: Int, $take: Int) {
  findManyMessageTranslation(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...MessageTranslation
  }
}
    ${exports.MessageTranslation}`;
exports.findManyMessageTranslationCount = (0, graphql_tag_1.default) `
    query findManyMessageTranslationCount($where: MessageTranslationWhereInput, $orderBy: [MessageTranslationOrderByWithRelationInput!], $cursor: MessageTranslationWhereUniqueInput, $skip: Int, $take: Int) {
  findManyMessageTranslationCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneMessageTranslation = (0, graphql_tag_1.default) `
    mutation createOneMessageTranslation($data: MessageTranslationCreateInput!) {
  createOneMessageTranslation(data: $data) {
    ...MessageTranslation
  }
}
    ${exports.MessageTranslation}`;
exports.updateOneMessageTranslation = (0, graphql_tag_1.default) `
    mutation updateOneMessageTranslation($where: MessageTranslationWhereUniqueInput!, $data: MessageTranslationUpdateInput!) {
  updateOneMessageTranslation(where: $where, data: $data) {
    ...MessageTranslation
  }
}
    ${exports.MessageTranslation}`;
exports.deleteOneMessageTranslation = (0, graphql_tag_1.default) `
    mutation deleteOneMessageTranslation($where: MessageTranslationWhereUniqueInput!) {
  deleteOneMessageTranslation(where: $where) {
    ...MessageTranslation
  }
}
    ${exports.MessageTranslation}`;
exports.deleteManyMessageTranslation = (0, graphql_tag_1.default) `
    mutation deleteManyMessageTranslation($where: MessageTranslationWhereInput) {
  deleteManyMessageTranslation(where: $where) {
    count
  }
}
    `;
exports.updateManyMessageTranslation = (0, graphql_tag_1.default) `
    mutation updateManyMessageTranslation($where: MessageTranslationWhereInput, $data: MessageTranslationUpdateManyMutationInput!) {
  updateManyMessageTranslation(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniquePayment = (0, graphql_tag_1.default) `
    query findUniquePayment($where: PaymentWhereUniqueInput!) {
  findUniquePayment(where: $where) {
    ...Payment
  }
}
    ${exports.Payment}`;
exports.findManyPayment = (0, graphql_tag_1.default) `
    query findManyPayment($where: PaymentWhereInput, $orderBy: [PaymentOrderByWithRelationInput!], $cursor: PaymentWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPayment(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Payment
  }
}
    ${exports.Payment}`;
exports.findManyPaymentCount = (0, graphql_tag_1.default) `
    query findManyPaymentCount($where: PaymentWhereInput, $orderBy: [PaymentOrderByWithRelationInput!], $cursor: PaymentWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPaymentCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.findUniquePaymentAPIFailureLog = (0, graphql_tag_1.default) `
    query findUniquePaymentAPIFailureLog($where: PaymentAPIFailureLogWhereUniqueInput!) {
  findUniquePaymentAPIFailureLog(where: $where) {
    ...PaymentAPIFailureLog
  }
}
    ${exports.PaymentAPIFailureLog}`;
exports.findManyPaymentAPIFailureLog = (0, graphql_tag_1.default) `
    query findManyPaymentAPIFailureLog($where: PaymentAPIFailureLogWhereInput, $orderBy: [PaymentAPIFailureLogOrderByWithRelationInput!], $cursor: PaymentAPIFailureLogWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPaymentAPIFailureLog(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...PaymentAPIFailureLog
  }
}
    ${exports.PaymentAPIFailureLog}`;
exports.findManyPaymentAPIFailureLogCount = (0, graphql_tag_1.default) `
    query findManyPaymentAPIFailureLogCount($where: PaymentAPIFailureLogWhereInput, $orderBy: [PaymentAPIFailureLogOrderByWithRelationInput!], $cursor: PaymentAPIFailureLogWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPaymentAPIFailureLogCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOnePaymentAPIFailureLog = (0, graphql_tag_1.default) `
    mutation createOnePaymentAPIFailureLog($data: PaymentAPIFailureLogCreateInput!) {
  createOnePaymentAPIFailureLog(data: $data) {
    ...PaymentAPIFailureLog
  }
}
    ${exports.PaymentAPIFailureLog}`;
exports.updateOnePaymentAPIFailureLog = (0, graphql_tag_1.default) `
    mutation updateOnePaymentAPIFailureLog($where: PaymentAPIFailureLogWhereUniqueInput!, $data: PaymentAPIFailureLogUpdateInput!) {
  updateOnePaymentAPIFailureLog(where: $where, data: $data) {
    ...PaymentAPIFailureLog
  }
}
    ${exports.PaymentAPIFailureLog}`;
exports.deleteOnePaymentAPIFailureLog = (0, graphql_tag_1.default) `
    mutation deleteOnePaymentAPIFailureLog($where: PaymentAPIFailureLogWhereUniqueInput!) {
  deleteOnePaymentAPIFailureLog(where: $where) {
    ...PaymentAPIFailureLog
  }
}
    ${exports.PaymentAPIFailureLog}`;
exports.deleteManyPaymentAPIFailureLog = (0, graphql_tag_1.default) `
    mutation deleteManyPaymentAPIFailureLog($where: PaymentAPIFailureLogWhereInput) {
  deleteManyPaymentAPIFailureLog(where: $where) {
    count
  }
}
    `;
exports.updateManyPaymentAPIFailureLog = (0, graphql_tag_1.default) `
    mutation updateManyPaymentAPIFailureLog($where: PaymentAPIFailureLogWhereInput, $data: PaymentAPIFailureLogUpdateManyMutationInput!) {
  updateManyPaymentAPIFailureLog(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniquePaymentIntent = (0, graphql_tag_1.default) `
    query findUniquePaymentIntent($where: PaymentIntentWhereUniqueInput!) {
  findUniquePaymentIntent(where: $where) {
    ...PaymentIntent
  }
}
    ${exports.PaymentIntent}`;
exports.findManyPaymentIntent = (0, graphql_tag_1.default) `
    query findManyPaymentIntent($where: PaymentIntentWhereInput, $orderBy: [PaymentIntentOrderByWithRelationInput!], $cursor: PaymentIntentWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPaymentIntent(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...PaymentIntent
  }
}
    ${exports.PaymentIntent}`;
exports.findManyPaymentIntentCount = (0, graphql_tag_1.default) `
    query findManyPaymentIntentCount($where: PaymentIntentWhereInput, $orderBy: [PaymentIntentOrderByWithRelationInput!], $cursor: PaymentIntentWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPaymentIntentCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOnePaymentIntent = (0, graphql_tag_1.default) `
    mutation createOnePaymentIntent($data: PaymentIntentCreateInput!) {
  createOnePaymentIntent(data: $data) {
    ...PaymentIntent
  }
}
    ${exports.PaymentIntent}`;
exports.updateOnePaymentIntent = (0, graphql_tag_1.default) `
    mutation updateOnePaymentIntent($where: PaymentIntentWhereUniqueInput!, $data: PaymentIntentUpdateInput!) {
  updateOnePaymentIntent(where: $where, data: $data) {
    ...PaymentIntent
  }
}
    ${exports.PaymentIntent}`;
exports.deleteOnePaymentIntent = (0, graphql_tag_1.default) `
    mutation deleteOnePaymentIntent($where: PaymentIntentWhereUniqueInput!) {
  deleteOnePaymentIntent(where: $where) {
    ...PaymentIntent
  }
}
    ${exports.PaymentIntent}`;
exports.deleteManyPaymentIntent = (0, graphql_tag_1.default) `
    mutation deleteManyPaymentIntent($where: PaymentIntentWhereInput) {
  deleteManyPaymentIntent(where: $where) {
    count
  }
}
    `;
exports.updateManyPaymentIntent = (0, graphql_tag_1.default) `
    mutation updateManyPaymentIntent($where: PaymentIntentWhereInput, $data: PaymentIntentUpdateManyMutationInput!) {
  updateManyPaymentIntent(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniquePaymentStatusHistory = (0, graphql_tag_1.default) `
    query findUniquePaymentStatusHistory($where: PaymentStatusHistoryWhereUniqueInput!) {
  findUniquePaymentStatusHistory(where: $where) {
    ...PaymentStatusHistory
  }
}
    ${exports.PaymentStatusHistory}`;
exports.findManyPaymentStatusHistory = (0, graphql_tag_1.default) `
    query findManyPaymentStatusHistory($where: PaymentStatusHistoryWhereInput, $orderBy: [PaymentStatusHistoryOrderByWithRelationInput!], $cursor: PaymentStatusHistoryWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPaymentStatusHistory(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...PaymentStatusHistory
  }
}
    ${exports.PaymentStatusHistory}`;
exports.findManyPaymentStatusHistoryCount = (0, graphql_tag_1.default) `
    query findManyPaymentStatusHistoryCount($where: PaymentStatusHistoryWhereInput, $orderBy: [PaymentStatusHistoryOrderByWithRelationInput!], $cursor: PaymentStatusHistoryWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPaymentStatusHistoryCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOnePaymentStatusHistory = (0, graphql_tag_1.default) `
    mutation createOnePaymentStatusHistory($data: PaymentStatusHistoryCreateInput!) {
  createOnePaymentStatusHistory(data: $data) {
    ...PaymentStatusHistory
  }
}
    ${exports.PaymentStatusHistory}`;
exports.updateOnePaymentStatusHistory = (0, graphql_tag_1.default) `
    mutation updateOnePaymentStatusHistory($where: PaymentStatusHistoryWhereUniqueInput!, $data: PaymentStatusHistoryUpdateInput!) {
  updateOnePaymentStatusHistory(where: $where, data: $data) {
    ...PaymentStatusHistory
  }
}
    ${exports.PaymentStatusHistory}`;
exports.deleteOnePaymentStatusHistory = (0, graphql_tag_1.default) `
    mutation deleteOnePaymentStatusHistory($where: PaymentStatusHistoryWhereUniqueInput!) {
  deleteOnePaymentStatusHistory(where: $where) {
    ...PaymentStatusHistory
  }
}
    ${exports.PaymentStatusHistory}`;
exports.deleteManyPaymentStatusHistory = (0, graphql_tag_1.default) `
    mutation deleteManyPaymentStatusHistory($where: PaymentStatusHistoryWhereInput) {
  deleteManyPaymentStatusHistory(where: $where) {
    count
  }
}
    `;
exports.updateManyPaymentStatusHistory = (0, graphql_tag_1.default) `
    mutation updateManyPaymentStatusHistory($where: PaymentStatusHistoryWhereInput, $data: PaymentStatusHistoryUpdateManyMutationInput!) {
  updateManyPaymentStatusHistory(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniquePlace = (0, graphql_tag_1.default) `
    query findUniquePlace($where: PlaceWhereUniqueInput!) {
  findUniquePlace(where: $where) {
    ...Place
  }
}
    ${exports.Place}`;
exports.findManyPlace = (0, graphql_tag_1.default) `
    query findManyPlace($where: PlaceWhereInput, $orderBy: [PlaceOrderByWithRelationInput!], $cursor: PlaceWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPlace(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Place
  }
}
    ${exports.Place}`;
exports.findManyPlaceCount = (0, graphql_tag_1.default) `
    query findManyPlaceCount($where: PlaceWhereInput, $orderBy: [PlaceOrderByWithRelationInput!], $cursor: PlaceWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPlaceCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOnePlace = (0, graphql_tag_1.default) `
    mutation createOnePlace($data: PlaceCreateInput!) {
  createOnePlace(data: $data) {
    ...Place
  }
}
    ${exports.Place}`;
exports.updateOnePlace = (0, graphql_tag_1.default) `
    mutation updateOnePlace($where: PlaceWhereUniqueInput!, $data: PlaceUpdateInput!) {
  updateOnePlace(where: $where, data: $data) {
    ...Place
  }
}
    ${exports.Place}`;
exports.deleteOnePlace = (0, graphql_tag_1.default) `
    mutation deleteOnePlace($where: PlaceWhereUniqueInput!) {
  deleteOnePlace(where: $where) {
    ...Place
  }
}
    ${exports.Place}`;
exports.deleteManyPlace = (0, graphql_tag_1.default) `
    mutation deleteManyPlace($where: PlaceWhereInput) {
  deleteManyPlace(where: $where) {
    count
  }
}
    `;
exports.updateManyPlace = (0, graphql_tag_1.default) `
    mutation updateManyPlace($where: PlaceWhereInput, $data: PlaceUpdateManyMutationInput!) {
  updateManyPlace(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniquePlugin = (0, graphql_tag_1.default) `
    query findUniquePlugin($where: PluginWhereUniqueInput!) {
  findUniquePlugin(where: $where) {
    ...Plugin
  }
}
    ${exports.Plugin}`;
exports.findManyPlugin = (0, graphql_tag_1.default) `
    query findManyPlugin($where: PluginWhereInput, $orderBy: [PluginOrderByWithRelationInput!], $cursor: PluginWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPlugin(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Plugin
  }
}
    ${exports.Plugin}`;
exports.findManyPluginCount = (0, graphql_tag_1.default) `
    query findManyPluginCount($where: PluginWhereInput, $orderBy: [PluginOrderByWithRelationInput!], $cursor: PluginWhereUniqueInput, $skip: Int, $take: Int) {
  findManyPluginCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOnePlugin = (0, graphql_tag_1.default) `
    mutation createOnePlugin($data: PluginCreateInput!) {
  createOnePlugin(data: $data) {
    ...Plugin
  }
}
    ${exports.Plugin}`;
exports.updateOnePlugin = (0, graphql_tag_1.default) `
    mutation updateOnePlugin($where: PluginWhereUniqueInput!, $data: PluginUpdateInput!) {
  updateOnePlugin(where: $where, data: $data) {
    ...Plugin
  }
}
    ${exports.Plugin}`;
exports.deleteOnePlugin = (0, graphql_tag_1.default) `
    mutation deleteOnePlugin($where: PluginWhereUniqueInput!) {
  deleteOnePlugin(where: $where) {
    ...Plugin
  }
}
    ${exports.Plugin}`;
exports.deleteManyPlugin = (0, graphql_tag_1.default) `
    mutation deleteManyPlugin($where: PluginWhereInput) {
  deleteManyPlugin(where: $where) {
    count
  }
}
    `;
exports.updateManyPlugin = (0, graphql_tag_1.default) `
    mutation updateManyPlugin($where: PluginWhereInput, $data: PluginUpdateManyMutationInput!) {
  updateManyPlugin(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueProduct = (0, graphql_tag_1.default) `
    query findUniqueProduct($where: ProductWhereUniqueInput!) {
  findUniqueProduct(where: $where) {
    ...Product
  }
}
    ${exports.Product}`;
exports.findManyProduct = (0, graphql_tag_1.default) `
    query findManyProduct($where: ProductWhereInput, $orderBy: [ProductOrderByWithRelationInput!], $cursor: ProductWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProduct(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Product
  }
}
    ${exports.Product}`;
exports.findManyProductCount = (0, graphql_tag_1.default) `
    query findManyProductCount($where: ProductWhereInput, $orderBy: [ProductOrderByWithRelationInput!], $cursor: ProductWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProductCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneProduct = (0, graphql_tag_1.default) `
    mutation createOneProduct($data: ProductCreateInput!) {
  createOneProduct(data: $data) {
    ...Product
  }
}
    ${exports.Product}`;
exports.updateOneProduct = (0, graphql_tag_1.default) `
    mutation updateOneProduct($where: ProductWhereUniqueInput!, $data: ProductUpdateInput!) {
  updateOneProduct(where: $where, data: $data) {
    ...Product
  }
}
    ${exports.Product}`;
exports.deleteOneProduct = (0, graphql_tag_1.default) `
    mutation deleteOneProduct($where: ProductWhereUniqueInput!) {
  deleteOneProduct(where: $where) {
    ...Product
  }
}
    ${exports.Product}`;
exports.deleteManyProduct = (0, graphql_tag_1.default) `
    mutation deleteManyProduct($where: ProductWhereInput) {
  deleteManyProduct(where: $where) {
    count
  }
}
    `;
exports.updateManyProduct = (0, graphql_tag_1.default) `
    mutation updateManyProduct($where: ProductWhereInput, $data: ProductUpdateManyMutationInput!) {
  updateManyProduct(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueProfile = (0, graphql_tag_1.default) `
    query findUniqueProfile($where: ProfileWhereUniqueInput!) {
  findUniqueProfile(where: $where) {
    ...Profile
  }
}
    ${exports.Profile}`;
exports.findManyProfile = (0, graphql_tag_1.default) `
    query findManyProfile($where: ProfileWhereInput, $orderBy: [ProfileOrderByWithRelationInput!], $cursor: ProfileWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfile(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Profile
  }
}
    ${exports.Profile}`;
exports.findManyProfileCount = (0, graphql_tag_1.default) `
    query findManyProfileCount($where: ProfileWhereInput, $orderBy: [ProfileOrderByWithRelationInput!], $cursor: ProfileWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfileCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneProfile = (0, graphql_tag_1.default) `
    mutation createOneProfile($data: ProfileCreateInput!) {
  createOneProfile(data: $data) {
    ...Profile
  }
}
    ${exports.Profile}`;
exports.updateOneProfile = (0, graphql_tag_1.default) `
    mutation updateOneProfile($where: ProfileWhereUniqueInput!, $data: ProfileUpdateInput!) {
  updateOneProfile(where: $where, data: $data) {
    ...Profile
  }
}
    ${exports.Profile}`;
exports.deleteOneProfile = (0, graphql_tag_1.default) `
    mutation deleteOneProfile($where: ProfileWhereUniqueInput!) {
  deleteOneProfile(where: $where) {
    ...Profile
  }
}
    ${exports.Profile}`;
exports.deleteManyProfile = (0, graphql_tag_1.default) `
    mutation deleteManyProfile($where: ProfileWhereInput) {
  deleteManyProfile(where: $where) {
    count
  }
}
    `;
exports.updateManyProfile = (0, graphql_tag_1.default) `
    mutation updateManyProfile($where: ProfileWhereInput, $data: ProfileUpdateManyMutationInput!) {
  updateManyProfile(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueProfileChannel_User = (0, graphql_tag_1.default) `
    query findUniqueProfileChannel_User($where: ProfileChannel_UserWhereUniqueInput!) {
  findUniqueProfileChannel_User(where: $where) {
    ...ProfileChannel_User
  }
}
    ${exports.ProfileChannel_User}`;
exports.findManyProfileChannel_User = (0, graphql_tag_1.default) `
    query findManyProfileChannel_User($where: ProfileChannel_UserWhereInput, $orderBy: [ProfileChannel_UserOrderByWithRelationInput!], $cursor: ProfileChannel_UserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfileChannel_User(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ProfileChannel_User
  }
}
    ${exports.ProfileChannel_User}`;
exports.findManyProfileChannel_UserCount = (0, graphql_tag_1.default) `
    query findManyProfileChannel_UserCount($where: ProfileChannel_UserWhereInput, $orderBy: [ProfileChannel_UserOrderByWithRelationInput!], $cursor: ProfileChannel_UserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfileChannel_UserCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneProfileChannel_User = (0, graphql_tag_1.default) `
    mutation createOneProfileChannel_User($data: ProfileChannel_UserCreateInput!) {
  createOneProfileChannel_User(data: $data) {
    ...ProfileChannel_User
  }
}
    ${exports.ProfileChannel_User}`;
exports.updateOneProfileChannel_User = (0, graphql_tag_1.default) `
    mutation updateOneProfileChannel_User($where: ProfileChannel_UserWhereUniqueInput!, $data: ProfileChannel_UserUpdateInput!) {
  updateOneProfileChannel_User(where: $where, data: $data) {
    ...ProfileChannel_User
  }
}
    ${exports.ProfileChannel_User}`;
exports.deleteOneProfileChannel_User = (0, graphql_tag_1.default) `
    mutation deleteOneProfileChannel_User($where: ProfileChannel_UserWhereUniqueInput!) {
  deleteOneProfileChannel_User(where: $where) {
    ...ProfileChannel_User
  }
}
    ${exports.ProfileChannel_User}`;
exports.deleteManyProfileChannel_User = (0, graphql_tag_1.default) `
    mutation deleteManyProfileChannel_User($where: ProfileChannel_UserWhereInput) {
  deleteManyProfileChannel_User(where: $where) {
    count
  }
}
    `;
exports.updateManyProfileChannel_User = (0, graphql_tag_1.default) `
    mutation updateManyProfileChannel_User($where: ProfileChannel_UserWhereInput, $data: ProfileChannel_UserUpdateManyMutationInput!) {
  updateManyProfileChannel_User(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueProfileInfo = (0, graphql_tag_1.default) `
    query findUniqueProfileInfo($where: ProfileInfoWhereUniqueInput!) {
  findUniqueProfileInfo(where: $where) {
    ...ProfileInfo
  }
}
    ${exports.ProfileInfo}`;
exports.findManyProfileInfo = (0, graphql_tag_1.default) `
    query findManyProfileInfo($where: ProfileInfoWhereInput, $orderBy: [ProfileInfoOrderByWithRelationInput!], $cursor: ProfileInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfileInfo(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ProfileInfo
  }
}
    ${exports.ProfileInfo}`;
exports.findManyProfileInfoCount = (0, graphql_tag_1.default) `
    query findManyProfileInfoCount($where: ProfileInfoWhereInput, $orderBy: [ProfileInfoOrderByWithRelationInput!], $cursor: ProfileInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfileInfoCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneProfileInfo = (0, graphql_tag_1.default) `
    mutation createOneProfileInfo($data: ProfileInfoCreateInput!) {
  createOneProfileInfo(data: $data) {
    ...ProfileInfo
  }
}
    ${exports.ProfileInfo}`;
exports.updateOneProfileInfo = (0, graphql_tag_1.default) `
    mutation updateOneProfileInfo($where: ProfileInfoWhereUniqueInput!, $data: ProfileInfoUpdateInput!) {
  updateOneProfileInfo(where: $where, data: $data) {
    ...ProfileInfo
  }
}
    ${exports.ProfileInfo}`;
exports.deleteOneProfileInfo = (0, graphql_tag_1.default) `
    mutation deleteOneProfileInfo($where: ProfileInfoWhereUniqueInput!) {
  deleteOneProfileInfo(where: $where) {
    ...ProfileInfo
  }
}
    ${exports.ProfileInfo}`;
exports.deleteManyProfileInfo = (0, graphql_tag_1.default) `
    mutation deleteManyProfileInfo($where: ProfileInfoWhereInput) {
  deleteManyProfileInfo(where: $where) {
    count
  }
}
    `;
exports.updateManyProfileInfo = (0, graphql_tag_1.default) `
    mutation updateManyProfileInfo($where: ProfileInfoWhereInput, $data: ProfileInfoUpdateManyMutationInput!) {
  updateManyProfileInfo(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueProfileReview = (0, graphql_tag_1.default) `
    query findUniqueProfileReview($where: ProfileReviewWhereUniqueInput!) {
  findUniqueProfileReview(where: $where) {
    ...ProfileReview
  }
}
    ${exports.ProfileReview}`;
exports.findManyProfileReview = (0, graphql_tag_1.default) `
    query findManyProfileReview($where: ProfileReviewWhereInput, $orderBy: [ProfileReviewOrderByWithRelationInput!], $cursor: ProfileReviewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfileReview(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ProfileReview
  }
}
    ${exports.ProfileReview}`;
exports.findManyProfileReviewCount = (0, graphql_tag_1.default) `
    query findManyProfileReviewCount($where: ProfileReviewWhereInput, $orderBy: [ProfileReviewOrderByWithRelationInput!], $cursor: ProfileReviewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfileReviewCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneProfileReview = (0, graphql_tag_1.default) `
    mutation createOneProfileReview($data: ProfileReviewCreateInput!) {
  createOneProfileReview(data: $data) {
    ...ProfileReview
  }
}
    ${exports.ProfileReview}`;
exports.updateOneProfileReview = (0, graphql_tag_1.default) `
    mutation updateOneProfileReview($where: ProfileReviewWhereUniqueInput!, $data: ProfileReviewUpdateInput!) {
  updateOneProfileReview(where: $where, data: $data) {
    ...ProfileReview
  }
}
    ${exports.ProfileReview}`;
exports.deleteOneProfileReview = (0, graphql_tag_1.default) `
    mutation deleteOneProfileReview($where: ProfileReviewWhereUniqueInput!) {
  deleteOneProfileReview(where: $where) {
    ...ProfileReview
  }
}
    ${exports.ProfileReview}`;
exports.deleteManyProfileReview = (0, graphql_tag_1.default) `
    mutation deleteManyProfileReview($where: ProfileReviewWhereInput) {
  deleteManyProfileReview(where: $where) {
    count
  }
}
    `;
exports.updateManyProfileReview = (0, graphql_tag_1.default) `
    mutation updateManyProfileReview($where: ProfileReviewWhereInput, $data: ProfileReviewUpdateManyMutationInput!) {
  updateManyProfileReview(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueProfile_Channel = (0, graphql_tag_1.default) `
    query findUniqueProfile_Channel($where: Profile_ChannelWhereUniqueInput!) {
  findUniqueProfile_Channel(where: $where) {
    ...Profile_Channel
  }
}
    ${exports.Profile_Channel}`;
exports.findManyProfile_Channel = (0, graphql_tag_1.default) `
    query findManyProfile_Channel($where: Profile_ChannelWhereInput, $orderBy: [Profile_ChannelOrderByWithRelationInput!], $cursor: Profile_ChannelWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfile_Channel(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Profile_Channel
  }
}
    ${exports.Profile_Channel}`;
exports.findManyProfile_ChannelCount = (0, graphql_tag_1.default) `
    query findManyProfile_ChannelCount($where: Profile_ChannelWhereInput, $orderBy: [Profile_ChannelOrderByWithRelationInput!], $cursor: Profile_ChannelWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfile_ChannelCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.updateOneProfile_Channel = (0, graphql_tag_1.default) `
    mutation updateOneProfile_Channel($where: Profile_ChannelWhereUniqueInput!, $data: Profile_ChannelUpdateInput!) {
  updateOneProfile_Channel(where: $where, data: $data) {
    ...Profile_Channel
  }
}
    ${exports.Profile_Channel}`;
exports.deleteOneProfile_Channel = (0, graphql_tag_1.default) `
    mutation deleteOneProfile_Channel($where: Profile_ChannelWhereUniqueInput!) {
  deleteOneProfile_Channel(where: $where) {
    ...Profile_Channel
  }
}
    ${exports.Profile_Channel}`;
exports.deleteManyProfile_Channel = (0, graphql_tag_1.default) `
    mutation deleteManyProfile_Channel($where: Profile_ChannelWhereInput) {
  deleteManyProfile_Channel(where: $where) {
    count
  }
}
    `;
exports.updateManyProfile_Channel = (0, graphql_tag_1.default) `
    mutation updateManyProfile_Channel($where: Profile_ChannelWhereInput, $data: Profile_ChannelUpdateManyMutationInput!) {
  updateManyProfile_Channel(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueProfile_ChannelActivity = (0, graphql_tag_1.default) `
    query findUniqueProfile_ChannelActivity($where: Profile_ChannelActivityWhereUniqueInput!) {
  findUniqueProfile_ChannelActivity(where: $where) {
    ...Profile_ChannelActivity
  }
}
    ${exports.Profile_ChannelActivity}`;
exports.findManyProfile_ChannelActivity = (0, graphql_tag_1.default) `
    query findManyProfile_ChannelActivity($where: Profile_ChannelActivityWhereInput, $orderBy: [Profile_ChannelActivityOrderByWithRelationInput!], $cursor: Profile_ChannelActivityWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfile_ChannelActivity(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Profile_ChannelActivity
  }
}
    ${exports.Profile_ChannelActivity}`;
exports.findManyProfile_ChannelActivityCount = (0, graphql_tag_1.default) `
    query findManyProfile_ChannelActivityCount($where: Profile_ChannelActivityWhereInput, $orderBy: [Profile_ChannelActivityOrderByWithRelationInput!], $cursor: Profile_ChannelActivityWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfile_ChannelActivityCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneProfile_ChannelActivity = (0, graphql_tag_1.default) `
    mutation createOneProfile_ChannelActivity($data: Profile_ChannelActivityCreateInput!) {
  createOneProfile_ChannelActivity(data: $data) {
    ...Profile_ChannelActivity
  }
}
    ${exports.Profile_ChannelActivity}`;
exports.updateOneProfile_ChannelActivity = (0, graphql_tag_1.default) `
    mutation updateOneProfile_ChannelActivity($where: Profile_ChannelActivityWhereUniqueInput!, $data: Profile_ChannelActivityUpdateInput!) {
  updateOneProfile_ChannelActivity(where: $where, data: $data) {
    ...Profile_ChannelActivity
  }
}
    ${exports.Profile_ChannelActivity}`;
exports.deleteOneProfile_ChannelActivity = (0, graphql_tag_1.default) `
    mutation deleteOneProfile_ChannelActivity($where: Profile_ChannelActivityWhereUniqueInput!) {
  deleteOneProfile_ChannelActivity(where: $where) {
    ...Profile_ChannelActivity
  }
}
    ${exports.Profile_ChannelActivity}`;
exports.deleteManyProfile_ChannelActivity = (0, graphql_tag_1.default) `
    mutation deleteManyProfile_ChannelActivity($where: Profile_ChannelActivityWhereInput) {
  deleteManyProfile_ChannelActivity(where: $where) {
    count
  }
}
    `;
exports.updateManyProfile_ChannelActivity = (0, graphql_tag_1.default) `
    mutation updateManyProfile_ChannelActivity($where: Profile_ChannelActivityWhereInput, $data: Profile_ChannelActivityUpdateManyMutationInput!) {
  updateManyProfile_ChannelActivity(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueProfile_ChatRoom = (0, graphql_tag_1.default) `
    query findUniqueProfile_ChatRoom($where: Profile_ChatRoomWhereUniqueInput!) {
  findUniqueProfile_ChatRoom(where: $where) {
    ...Profile_ChatRoom
  }
}
    ${exports.Profile_ChatRoom}`;
exports.findManyProfile_ChatRoom = (0, graphql_tag_1.default) `
    query findManyProfile_ChatRoom($where: Profile_ChatRoomWhereInput, $orderBy: [Profile_ChatRoomOrderByWithRelationInput!], $cursor: Profile_ChatRoomWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfile_ChatRoom(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Profile_ChatRoom
  }
}
    ${exports.Profile_ChatRoom}`;
exports.findManyProfile_ChatRoomCount = (0, graphql_tag_1.default) `
    query findManyProfile_ChatRoomCount($where: Profile_ChatRoomWhereInput, $orderBy: [Profile_ChatRoomOrderByWithRelationInput!], $cursor: Profile_ChatRoomWhereUniqueInput, $skip: Int, $take: Int) {
  findManyProfile_ChatRoomCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneProfile_ChatRoom = (0, graphql_tag_1.default) `
    mutation createOneProfile_ChatRoom($data: Profile_ChatRoomCreateInput!) {
  createOneProfile_ChatRoom(data: $data) {
    ...Profile_ChatRoom
  }
}
    ${exports.Profile_ChatRoom}`;
exports.updateOneProfile_ChatRoom = (0, graphql_tag_1.default) `
    mutation updateOneProfile_ChatRoom($where: Profile_ChatRoomWhereUniqueInput!, $data: Profile_ChatRoomUpdateInput!) {
  updateOneProfile_ChatRoom(where: $where, data: $data) {
    ...Profile_ChatRoom
  }
}
    ${exports.Profile_ChatRoom}`;
exports.deleteOneProfile_ChatRoom = (0, graphql_tag_1.default) `
    mutation deleteOneProfile_ChatRoom($where: Profile_ChatRoomWhereUniqueInput!) {
  deleteOneProfile_ChatRoom(where: $where) {
    ...Profile_ChatRoom
  }
}
    ${exports.Profile_ChatRoom}`;
exports.deleteManyProfile_ChatRoom = (0, graphql_tag_1.default) `
    mutation deleteManyProfile_ChatRoom($where: Profile_ChatRoomWhereInput) {
  deleteManyProfile_ChatRoom(where: $where) {
    count
  }
}
    `;
exports.updateManyProfile_ChatRoom = (0, graphql_tag_1.default) `
    mutation updateManyProfile_ChatRoom($where: Profile_ChatRoomWhereInput, $data: Profile_ChatRoomUpdateManyMutationInput!) {
  updateManyProfile_ChatRoom(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueQuota = (0, graphql_tag_1.default) `
    query findUniqueQuota($where: QuotaWhereUniqueInput!) {
  findUniqueQuota(where: $where) {
    ...Quota
  }
}
    ${exports.Quota}`;
exports.findManyQuota = (0, graphql_tag_1.default) `
    query findManyQuota($where: QuotaWhereInput, $orderBy: [QuotaOrderByWithRelationInput!], $cursor: QuotaWhereUniqueInput, $skip: Int, $take: Int) {
  findManyQuota(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Quota
  }
}
    ${exports.Quota}`;
exports.findManyQuotaCount = (0, graphql_tag_1.default) `
    query findManyQuotaCount($where: QuotaWhereInput, $orderBy: [QuotaOrderByWithRelationInput!], $cursor: QuotaWhereUniqueInput, $skip: Int, $take: Int) {
  findManyQuotaCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.findUniqueQuotaUsage = (0, graphql_tag_1.default) `
    query findUniqueQuotaUsage($where: QuotaUsageWhereUniqueInput!) {
  findUniqueQuotaUsage(where: $where) {
    ...QuotaUsage
  }
}
    ${exports.QuotaUsage}`;
exports.findManyQuotaUsage = (0, graphql_tag_1.default) `
    query findManyQuotaUsage($where: QuotaUsageWhereInput, $orderBy: [QuotaUsageOrderByWithRelationInput!], $cursor: QuotaUsageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyQuotaUsage(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...QuotaUsage
  }
}
    ${exports.QuotaUsage}`;
exports.findManyQuotaUsageCount = (0, graphql_tag_1.default) `
    query findManyQuotaUsageCount($where: QuotaUsageWhereInput, $orderBy: [QuotaUsageOrderByWithRelationInput!], $cursor: QuotaUsageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyQuotaUsageCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneQuotaUsage = (0, graphql_tag_1.default) `
    mutation createOneQuotaUsage($data: QuotaUsageCreateInput!) {
  createOneQuotaUsage(data: $data) {
    ...QuotaUsage
  }
}
    ${exports.QuotaUsage}`;
exports.updateOneQuotaUsage = (0, graphql_tag_1.default) `
    mutation updateOneQuotaUsage($where: QuotaUsageWhereUniqueInput!, $data: QuotaUsageUpdateInput!) {
  updateOneQuotaUsage(where: $where, data: $data) {
    ...QuotaUsage
  }
}
    ${exports.QuotaUsage}`;
exports.deleteOneQuotaUsage = (0, graphql_tag_1.default) `
    mutation deleteOneQuotaUsage($where: QuotaUsageWhereUniqueInput!) {
  deleteOneQuotaUsage(where: $where) {
    ...QuotaUsage
  }
}
    ${exports.QuotaUsage}`;
exports.deleteManyQuotaUsage = (0, graphql_tag_1.default) `
    mutation deleteManyQuotaUsage($where: QuotaUsageWhereInput) {
  deleteManyQuotaUsage(where: $where) {
    count
  }
}
    `;
exports.updateManyQuotaUsage = (0, graphql_tag_1.default) `
    mutation updateManyQuotaUsage($where: QuotaUsageWhereInput, $data: QuotaUsageUpdateManyMutationInput!) {
  updateManyQuotaUsage(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueReaction = (0, graphql_tag_1.default) `
    query findUniqueReaction($where: ReactionWhereUniqueInput!) {
  findUniqueReaction(where: $where) {
    ...Reaction
  }
}
    ${exports.Reaction}`;
exports.findManyReaction = (0, graphql_tag_1.default) `
    query findManyReaction($where: ReactionWhereInput, $orderBy: [ReactionOrderByWithRelationInput!], $cursor: ReactionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyReaction(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Reaction
  }
}
    ${exports.Reaction}`;
exports.findManyReactionCount = (0, graphql_tag_1.default) `
    query findManyReactionCount($where: ReactionWhereInput, $orderBy: [ReactionOrderByWithRelationInput!], $cursor: ReactionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyReactionCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneReaction = (0, graphql_tag_1.default) `
    mutation createOneReaction($data: ReactionCreateInput!) {
  createOneReaction(data: $data) {
    ...Reaction
  }
}
    ${exports.Reaction}`;
exports.updateOneReaction = (0, graphql_tag_1.default) `
    mutation updateOneReaction($where: ReactionWhereUniqueInput!, $data: ReactionUpdateInput!) {
  updateOneReaction(where: $where, data: $data) {
    ...Reaction
  }
}
    ${exports.Reaction}`;
exports.deleteOneReaction = (0, graphql_tag_1.default) `
    mutation deleteOneReaction($where: ReactionWhereUniqueInput!) {
  deleteOneReaction(where: $where) {
    ...Reaction
  }
}
    ${exports.Reaction}`;
exports.deleteManyReaction = (0, graphql_tag_1.default) `
    mutation deleteManyReaction($where: ReactionWhereInput) {
  deleteManyReaction(where: $where) {
    count
  }
}
    `;
exports.updateManyReaction = (0, graphql_tag_1.default) `
    mutation updateManyReaction($where: ReactionWhereInput, $data: ReactionUpdateManyMutationInput!) {
  updateManyReaction(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueReportAction = (0, graphql_tag_1.default) `
    query findUniqueReportAction($where: ReportActionWhereUniqueInput!) {
  findUniqueReportAction(where: $where) {
    ...ReportAction
  }
}
    ${exports.ReportAction}`;
exports.findManyReportAction = (0, graphql_tag_1.default) `
    query findManyReportAction($where: ReportActionWhereInput, $orderBy: [ReportActionOrderByWithRelationInput!], $cursor: ReportActionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyReportAction(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ReportAction
  }
}
    ${exports.ReportAction}`;
exports.findManyReportActionCount = (0, graphql_tag_1.default) `
    query findManyReportActionCount($where: ReportActionWhereInput, $orderBy: [ReportActionOrderByWithRelationInput!], $cursor: ReportActionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyReportActionCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneReportAction = (0, graphql_tag_1.default) `
    mutation createOneReportAction($data: ReportActionCreateInput!) {
  createOneReportAction(data: $data) {
    ...ReportAction
  }
}
    ${exports.ReportAction}`;
exports.updateOneReportAction = (0, graphql_tag_1.default) `
    mutation updateOneReportAction($where: ReportActionWhereUniqueInput!, $data: ReportActionUpdateInput!) {
  updateOneReportAction(where: $where, data: $data) {
    ...ReportAction
  }
}
    ${exports.ReportAction}`;
exports.deleteOneReportAction = (0, graphql_tag_1.default) `
    mutation deleteOneReportAction($where: ReportActionWhereUniqueInput!) {
  deleteOneReportAction(where: $where) {
    ...ReportAction
  }
}
    ${exports.ReportAction}`;
exports.deleteManyReportAction = (0, graphql_tag_1.default) `
    mutation deleteManyReportAction($where: ReportActionWhereInput) {
  deleteManyReportAction(where: $where) {
    count
  }
}
    `;
exports.updateManyReportAction = (0, graphql_tag_1.default) `
    mutation updateManyReportAction($where: ReportActionWhereInput, $data: ReportActionUpdateManyMutationInput!) {
  updateManyReportAction(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSearchWord = (0, graphql_tag_1.default) `
    query findUniqueSearchWord($where: SearchWordWhereUniqueInput!) {
  findUniqueSearchWord(where: $where) {
    ...SearchWord
  }
}
    ${exports.SearchWord}`;
exports.findManySearchWord = (0, graphql_tag_1.default) `
    query findManySearchWord($where: SearchWordWhereInput, $orderBy: [SearchWordOrderByWithRelationInput!], $cursor: SearchWordWhereUniqueInput, $skip: Int, $take: Int) {
  findManySearchWord(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SearchWord
  }
}
    ${exports.SearchWord}`;
exports.findManySearchWordCount = (0, graphql_tag_1.default) `
    query findManySearchWordCount($where: SearchWordWhereInput, $orderBy: [SearchWordOrderByWithRelationInput!], $cursor: SearchWordWhereUniqueInput, $skip: Int, $take: Int) {
  findManySearchWordCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSearchWord = (0, graphql_tag_1.default) `
    mutation createOneSearchWord($data: SearchWordCreateInput!) {
  createOneSearchWord(data: $data) {
    ...SearchWord
  }
}
    ${exports.SearchWord}`;
exports.updateOneSearchWord = (0, graphql_tag_1.default) `
    mutation updateOneSearchWord($where: SearchWordWhereUniqueInput!, $data: SearchWordUpdateInput!) {
  updateOneSearchWord(where: $where, data: $data) {
    ...SearchWord
  }
}
    ${exports.SearchWord}`;
exports.deleteOneSearchWord = (0, graphql_tag_1.default) `
    mutation deleteOneSearchWord($where: SearchWordWhereUniqueInput!) {
  deleteOneSearchWord(where: $where) {
    ...SearchWord
  }
}
    ${exports.SearchWord}`;
exports.deleteManySearchWord = (0, graphql_tag_1.default) `
    mutation deleteManySearchWord($where: SearchWordWhereInput) {
  deleteManySearchWord(where: $where) {
    count
  }
}
    `;
exports.updateManySearchWord = (0, graphql_tag_1.default) `
    mutation updateManySearchWord($where: SearchWordWhereInput, $data: SearchWordUpdateManyMutationInput!) {
  updateManySearchWord(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSecret = (0, graphql_tag_1.default) `
    query findUniqueSecret($where: SecretWhereUniqueInput!) {
  findUniqueSecret(where: $where) {
    ...Secret
  }
}
    ${exports.Secret}`;
exports.findManySecret = (0, graphql_tag_1.default) `
    query findManySecret($where: SecretWhereInput, $orderBy: [SecretOrderByWithRelationInput!], $cursor: SecretWhereUniqueInput, $skip: Int, $take: Int) {
  findManySecret(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Secret
  }
}
    ${exports.Secret}`;
exports.findManySecretCount = (0, graphql_tag_1.default) `
    query findManySecretCount($where: SecretWhereInput, $orderBy: [SecretOrderByWithRelationInput!], $cursor: SecretWhereUniqueInput, $skip: Int, $take: Int) {
  findManySecretCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSecret = (0, graphql_tag_1.default) `
    mutation createOneSecret($data: SecretCreateInput!) {
  createOneSecret(data: $data) {
    ...Secret
  }
}
    ${exports.Secret}`;
exports.updateOneSecret = (0, graphql_tag_1.default) `
    mutation updateOneSecret($where: SecretWhereUniqueInput!, $data: SecretUpdateInput!) {
  updateOneSecret(where: $where, data: $data) {
    ...Secret
  }
}
    ${exports.Secret}`;
exports.deleteOneSecret = (0, graphql_tag_1.default) `
    mutation deleteOneSecret($where: SecretWhereUniqueInput!) {
  deleteOneSecret(where: $where) {
    ...Secret
  }
}
    ${exports.Secret}`;
exports.deleteManySecret = (0, graphql_tag_1.default) `
    mutation deleteManySecret($where: SecretWhereInput) {
  deleteManySecret(where: $where) {
    count
  }
}
    `;
exports.updateManySecret = (0, graphql_tag_1.default) `
    mutation updateManySecret($where: SecretWhereInput, $data: SecretUpdateManyMutationInput!) {
  updateManySecret(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueServerError = (0, graphql_tag_1.default) `
    query findUniqueServerError($where: ServerErrorWhereUniqueInput!) {
  findUniqueServerError(where: $where) {
    ...ServerError
  }
}
    ${exports.ServerError}`;
exports.findManyServerError = (0, graphql_tag_1.default) `
    query findManyServerError($where: ServerErrorWhereInput, $orderBy: [ServerErrorOrderByWithRelationInput!], $cursor: ServerErrorWhereUniqueInput, $skip: Int, $take: Int) {
  findManyServerError(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...ServerError
  }
}
    ${exports.ServerError}`;
exports.findManyServerErrorCount = (0, graphql_tag_1.default) `
    query findManyServerErrorCount($where: ServerErrorWhereInput, $orderBy: [ServerErrorOrderByWithRelationInput!], $cursor: ServerErrorWhereUniqueInput, $skip: Int, $take: Int) {
  findManyServerErrorCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneServerError = (0, graphql_tag_1.default) `
    mutation createOneServerError($data: ServerErrorCreateInput!) {
  createOneServerError(data: $data) {
    ...ServerError
  }
}
    ${exports.ServerError}`;
exports.updateOneServerError = (0, graphql_tag_1.default) `
    mutation updateOneServerError($where: ServerErrorWhereUniqueInput!, $data: ServerErrorUpdateInput!) {
  updateOneServerError(where: $where, data: $data) {
    ...ServerError
  }
}
    ${exports.ServerError}`;
exports.deleteOneServerError = (0, graphql_tag_1.default) `
    mutation deleteOneServerError($where: ServerErrorWhereUniqueInput!) {
  deleteOneServerError(where: $where) {
    ...ServerError
  }
}
    ${exports.ServerError}`;
exports.deleteManyServerError = (0, graphql_tag_1.default) `
    mutation deleteManyServerError($where: ServerErrorWhereInput) {
  deleteManyServerError(where: $where) {
    count
  }
}
    `;
exports.updateManyServerError = (0, graphql_tag_1.default) `
    mutation updateManyServerError($where: ServerErrorWhereInput, $data: ServerErrorUpdateManyMutationInput!) {
  updateManyServerError(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSettlement = (0, graphql_tag_1.default) `
    query findUniqueSettlement($where: SettlementWhereUniqueInput!) {
  findUniqueSettlement(where: $where) {
    ...Settlement
  }
}
    ${exports.Settlement}`;
exports.findManySettlement = (0, graphql_tag_1.default) `
    query findManySettlement($where: SettlementWhereInput, $orderBy: [SettlementOrderByWithRelationInput!], $cursor: SettlementWhereUniqueInput, $skip: Int, $take: Int) {
  findManySettlement(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Settlement
  }
}
    ${exports.Settlement}`;
exports.findManySettlementCount = (0, graphql_tag_1.default) `
    query findManySettlementCount($where: SettlementWhereInput, $orderBy: [SettlementOrderByWithRelationInput!], $cursor: SettlementWhereUniqueInput, $skip: Int, $take: Int) {
  findManySettlementCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSettlement = (0, graphql_tag_1.default) `
    mutation createOneSettlement($data: SettlementCreateInput!) {
  createOneSettlement(data: $data) {
    ...Settlement
  }
}
    ${exports.Settlement}`;
exports.updateOneSettlement = (0, graphql_tag_1.default) `
    mutation updateOneSettlement($where: SettlementWhereUniqueInput!, $data: SettlementUpdateInput!) {
  updateOneSettlement(where: $where, data: $data) {
    ...Settlement
  }
}
    ${exports.Settlement}`;
exports.deleteOneSettlement = (0, graphql_tag_1.default) `
    mutation deleteOneSettlement($where: SettlementWhereUniqueInput!) {
  deleteOneSettlement(where: $where) {
    ...Settlement
  }
}
    ${exports.Settlement}`;
exports.deleteManySettlement = (0, graphql_tag_1.default) `
    mutation deleteManySettlement($where: SettlementWhereInput) {
  deleteManySettlement(where: $where) {
    count
  }
}
    `;
exports.updateManySettlement = (0, graphql_tag_1.default) `
    mutation updateManySettlement($where: SettlementWhereInput, $data: SettlementUpdateManyMutationInput!) {
  updateManySettlement(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSettlementItem = (0, graphql_tag_1.default) `
    query findUniqueSettlementItem($where: SettlementItemWhereUniqueInput!) {
  findUniqueSettlementItem(where: $where) {
    ...SettlementItem
  }
}
    ${exports.SettlementItem}`;
exports.findManySettlementItem = (0, graphql_tag_1.default) `
    query findManySettlementItem($where: SettlementItemWhereInput, $orderBy: [SettlementItemOrderByWithRelationInput!], $cursor: SettlementItemWhereUniqueInput, $skip: Int, $take: Int) {
  findManySettlementItem(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SettlementItem
  }
}
    ${exports.SettlementItem}`;
exports.findManySettlementItemCount = (0, graphql_tag_1.default) `
    query findManySettlementItemCount($where: SettlementItemWhereInput, $orderBy: [SettlementItemOrderByWithRelationInput!], $cursor: SettlementItemWhereUniqueInput, $skip: Int, $take: Int) {
  findManySettlementItemCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSettlementItem = (0, graphql_tag_1.default) `
    mutation createOneSettlementItem($data: SettlementItemCreateInput!) {
  createOneSettlementItem(data: $data) {
    ...SettlementItem
  }
}
    ${exports.SettlementItem}`;
exports.updateOneSettlementItem = (0, graphql_tag_1.default) `
    mutation updateOneSettlementItem($where: SettlementItemWhereUniqueInput!, $data: SettlementItemUpdateInput!) {
  updateOneSettlementItem(where: $where, data: $data) {
    ...SettlementItem
  }
}
    ${exports.SettlementItem}`;
exports.deleteOneSettlementItem = (0, graphql_tag_1.default) `
    mutation deleteOneSettlementItem($where: SettlementItemWhereUniqueInput!) {
  deleteOneSettlementItem(where: $where) {
    ...SettlementItem
  }
}
    ${exports.SettlementItem}`;
exports.deleteManySettlementItem = (0, graphql_tag_1.default) `
    mutation deleteManySettlementItem($where: SettlementItemWhereInput) {
  deleteManySettlementItem(where: $where) {
    count
  }
}
    `;
exports.updateManySettlementItem = (0, graphql_tag_1.default) `
    mutation updateManySettlementItem($where: SettlementItemWhereInput, $data: SettlementItemUpdateManyMutationInput!) {
  updateManySettlementItem(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSignIn = (0, graphql_tag_1.default) `
    query findUniqueSignIn($where: SignInWhereUniqueInput!) {
  findUniqueSignIn(where: $where) {
    ...SignIn
  }
}
    ${exports.SignIn}`;
exports.findManySignIn = (0, graphql_tag_1.default) `
    query findManySignIn($where: SignInWhereInput, $orderBy: [SignInOrderByWithRelationInput!], $cursor: SignInWhereUniqueInput, $skip: Int, $take: Int) {
  findManySignIn(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SignIn
  }
}
    ${exports.SignIn}`;
exports.findManySignInCount = (0, graphql_tag_1.default) `
    query findManySignInCount($where: SignInWhereInput, $orderBy: [SignInOrderByWithRelationInput!], $cursor: SignInWhereUniqueInput, $skip: Int, $take: Int) {
  findManySignInCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSignIn = (0, graphql_tag_1.default) `
    mutation createOneSignIn($data: SignInCreateInput!) {
  createOneSignIn(data: $data) {
    ...SignIn
  }
}
    ${exports.SignIn}`;
exports.updateOneSignIn = (0, graphql_tag_1.default) `
    mutation updateOneSignIn($where: SignInWhereUniqueInput!, $data: SignInUpdateInput!) {
  updateOneSignIn(where: $where, data: $data) {
    ...SignIn
  }
}
    ${exports.SignIn}`;
exports.deleteOneSignIn = (0, graphql_tag_1.default) `
    mutation deleteOneSignIn($where: SignInWhereUniqueInput!) {
  deleteOneSignIn(where: $where) {
    ...SignIn
  }
}
    ${exports.SignIn}`;
exports.deleteManySignIn = (0, graphql_tag_1.default) `
    mutation deleteManySignIn($where: SignInWhereInput) {
  deleteManySignIn(where: $where) {
    count
  }
}
    `;
exports.updateManySignIn = (0, graphql_tag_1.default) `
    mutation updateManySignIn($where: SignInWhereInput, $data: SignInUpdateManyMutationInput!) {
  updateManySignIn(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSignInTelVerification = (0, graphql_tag_1.default) `
    query findUniqueSignInTelVerification($where: SignInTelVerificationWhereUniqueInput!) {
  findUniqueSignInTelVerification(where: $where) {
    ...SignInTelVerification
  }
}
    ${exports.SignInTelVerification}`;
exports.findManySignInTelVerification = (0, graphql_tag_1.default) `
    query findManySignInTelVerification($where: SignInTelVerificationWhereInput, $orderBy: [SignInTelVerificationOrderByWithRelationInput!], $cursor: SignInTelVerificationWhereUniqueInput, $skip: Int, $take: Int) {
  findManySignInTelVerification(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SignInTelVerification
  }
}
    ${exports.SignInTelVerification}`;
exports.findManySignInTelVerificationCount = (0, graphql_tag_1.default) `
    query findManySignInTelVerificationCount($where: SignInTelVerificationWhereInput, $orderBy: [SignInTelVerificationOrderByWithRelationInput!], $cursor: SignInTelVerificationWhereUniqueInput, $skip: Int, $take: Int) {
  findManySignInTelVerificationCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSignInTelVerification = (0, graphql_tag_1.default) `
    mutation createOneSignInTelVerification($data: SignInTelVerificationCreateInput!) {
  createOneSignInTelVerification(data: $data) {
    ...SignInTelVerification
  }
}
    ${exports.SignInTelVerification}`;
exports.updateOneSignInTelVerification = (0, graphql_tag_1.default) `
    mutation updateOneSignInTelVerification($where: SignInTelVerificationWhereUniqueInput!, $data: SignInTelVerificationUpdateInput!) {
  updateOneSignInTelVerification(where: $where, data: $data) {
    ...SignInTelVerification
  }
}
    ${exports.SignInTelVerification}`;
exports.deleteOneSignInTelVerification = (0, graphql_tag_1.default) `
    mutation deleteOneSignInTelVerification($where: SignInTelVerificationWhereUniqueInput!) {
  deleteOneSignInTelVerification(where: $where) {
    ...SignInTelVerification
  }
}
    ${exports.SignInTelVerification}`;
exports.deleteManySignInTelVerification = (0, graphql_tag_1.default) `
    mutation deleteManySignInTelVerification($where: SignInTelVerificationWhereInput) {
  deleteManySignInTelVerification(where: $where) {
    count
  }
}
    `;
exports.updateManySignInTelVerification = (0, graphql_tag_1.default) `
    mutation updateManySignInTelVerification($where: SignInTelVerificationWhereInput, $data: SignInTelVerificationUpdateManyMutationInput!) {
  updateManySignInTelVerification(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSubscription = (0, graphql_tag_1.default) `
    query findUniqueSubscription($where: SubscriptionWhereUniqueInput!) {
  findUniqueSubscription(where: $where) {
    ...Subscription
  }
}
    ${exports.Subscription}`;
exports.findManySubscription = (0, graphql_tag_1.default) `
    query findManySubscription($where: SubscriptionWhereInput, $orderBy: [SubscriptionOrderByWithRelationInput!], $cursor: SubscriptionWhereUniqueInput, $skip: Int, $take: Int) {
  findManySubscription(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Subscription
  }
}
    ${exports.Subscription}`;
exports.findManySubscriptionCount = (0, graphql_tag_1.default) `
    query findManySubscriptionCount($where: SubscriptionWhereInput, $orderBy: [SubscriptionOrderByWithRelationInput!], $cursor: SubscriptionWhereUniqueInput, $skip: Int, $take: Int) {
  findManySubscriptionCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSubscription = (0, graphql_tag_1.default) `
    mutation createOneSubscription($data: SubscriptionCreateInput!) {
  createOneSubscription(data: $data) {
    ...Subscription
  }
}
    ${exports.Subscription}`;
exports.updateOneSubscription = (0, graphql_tag_1.default) `
    mutation updateOneSubscription($where: SubscriptionWhereUniqueInput!, $data: SubscriptionUpdateInput!) {
  updateOneSubscription(where: $where, data: $data) {
    ...Subscription
  }
}
    ${exports.Subscription}`;
exports.deleteOneSubscription = (0, graphql_tag_1.default) `
    mutation deleteOneSubscription($where: SubscriptionWhereUniqueInput!) {
  deleteOneSubscription(where: $where) {
    ...Subscription
  }
}
    ${exports.Subscription}`;
exports.deleteManySubscription = (0, graphql_tag_1.default) `
    mutation deleteManySubscription($where: SubscriptionWhereInput) {
  deleteManySubscription(where: $where) {
    count
  }
}
    `;
exports.updateManySubscription = (0, graphql_tag_1.default) `
    mutation updateManySubscription($where: SubscriptionWhereInput, $data: SubscriptionUpdateManyMutationInput!) {
  updateManySubscription(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSubscriptionHistory = (0, graphql_tag_1.default) `
    query findUniqueSubscriptionHistory($where: SubscriptionHistoryWhereUniqueInput!) {
  findUniqueSubscriptionHistory(where: $where) {
    ...SubscriptionHistory
  }
}
    ${exports.SubscriptionHistory}`;
exports.findManySubscriptionHistory = (0, graphql_tag_1.default) `
    query findManySubscriptionHistory($where: SubscriptionHistoryWhereInput, $orderBy: [SubscriptionHistoryOrderByWithRelationInput!], $cursor: SubscriptionHistoryWhereUniqueInput, $skip: Int, $take: Int) {
  findManySubscriptionHistory(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SubscriptionHistory
  }
}
    ${exports.SubscriptionHistory}`;
exports.findManySubscriptionHistoryCount = (0, graphql_tag_1.default) `
    query findManySubscriptionHistoryCount($where: SubscriptionHistoryWhereInput, $orderBy: [SubscriptionHistoryOrderByWithRelationInput!], $cursor: SubscriptionHistoryWhereUniqueInput, $skip: Int, $take: Int) {
  findManySubscriptionHistoryCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.findUniqueSysInfo = (0, graphql_tag_1.default) `
    query findUniqueSysInfo($where: SysInfoWhereUniqueInput!) {
  findUniqueSysInfo(where: $where) {
    ...SysInfo
  }
}
    ${exports.SysInfo}`;
exports.findManySysInfo = (0, graphql_tag_1.default) `
    query findManySysInfo($where: SysInfoWhereInput, $orderBy: [SysInfoOrderByWithRelationInput!], $cursor: SysInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManySysInfo(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SysInfo
  }
}
    ${exports.SysInfo}`;
exports.findManySysInfoCount = (0, graphql_tag_1.default) `
    query findManySysInfoCount($where: SysInfoWhereInput, $orderBy: [SysInfoOrderByWithRelationInput!], $cursor: SysInfoWhereUniqueInput, $skip: Int, $take: Int) {
  findManySysInfoCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSysInfo = (0, graphql_tag_1.default) `
    mutation createOneSysInfo($data: SysInfoCreateInput!) {
  createOneSysInfo(data: $data) {
    ...SysInfo
  }
}
    ${exports.SysInfo}`;
exports.updateOneSysInfo = (0, graphql_tag_1.default) `
    mutation updateOneSysInfo($where: SysInfoWhereUniqueInput!, $data: SysInfoUpdateInput!) {
  updateOneSysInfo(where: $where, data: $data) {
    ...SysInfo
  }
}
    ${exports.SysInfo}`;
exports.deleteOneSysInfo = (0, graphql_tag_1.default) `
    mutation deleteOneSysInfo($where: SysInfoWhereUniqueInput!) {
  deleteOneSysInfo(where: $where) {
    ...SysInfo
  }
}
    ${exports.SysInfo}`;
exports.deleteManySysInfo = (0, graphql_tag_1.default) `
    mutation deleteManySysInfo($where: SysInfoWhereInput) {
  deleteManySysInfo(where: $where) {
    count
  }
}
    `;
exports.updateManySysInfo = (0, graphql_tag_1.default) `
    mutation updateManySysInfo($where: SysInfoWhereInput, $data: SysInfoUpdateManyMutationInput!) {
  updateManySysInfo(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSysNotice = (0, graphql_tag_1.default) `
    query findUniqueSysNotice($where: SysNoticeWhereUniqueInput!) {
  findUniqueSysNotice(where: $where) {
    ...SysNotice
  }
}
    ${exports.SysNotice}`;
exports.findManySysNotice = (0, graphql_tag_1.default) `
    query findManySysNotice($where: SysNoticeWhereInput, $orderBy: [SysNoticeOrderByWithRelationInput!], $cursor: SysNoticeWhereUniqueInput, $skip: Int, $take: Int) {
  findManySysNotice(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SysNotice
  }
}
    ${exports.SysNotice}`;
exports.findManySysNoticeCount = (0, graphql_tag_1.default) `
    query findManySysNoticeCount($where: SysNoticeWhereInput, $orderBy: [SysNoticeOrderByWithRelationInput!], $cursor: SysNoticeWhereUniqueInput, $skip: Int, $take: Int) {
  findManySysNoticeCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSysNotice = (0, graphql_tag_1.default) `
    mutation createOneSysNotice($data: SysNoticeCreateInput!) {
  createOneSysNotice(data: $data) {
    ...SysNotice
  }
}
    ${exports.SysNotice}`;
exports.updateOneSysNotice = (0, graphql_tag_1.default) `
    mutation updateOneSysNotice($where: SysNoticeWhereUniqueInput!, $data: SysNoticeUpdateInput!) {
  updateOneSysNotice(where: $where, data: $data) {
    ...SysNotice
  }
}
    ${exports.SysNotice}`;
exports.deleteOneSysNotice = (0, graphql_tag_1.default) `
    mutation deleteOneSysNotice($where: SysNoticeWhereUniqueInput!) {
  deleteOneSysNotice(where: $where) {
    ...SysNotice
  }
}
    ${exports.SysNotice}`;
exports.deleteManySysNotice = (0, graphql_tag_1.default) `
    mutation deleteManySysNotice($where: SysNoticeWhereInput) {
  deleteManySysNotice(where: $where) {
    count
  }
}
    `;
exports.updateManySysNotice = (0, graphql_tag_1.default) `
    mutation updateManySysNotice($where: SysNoticeWhereInput, $data: SysNoticeUpdateManyMutationInput!) {
  updateManySysNotice(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSysNotification = (0, graphql_tag_1.default) `
    query findUniqueSysNotification($where: SysNotificationWhereUniqueInput!) {
  findUniqueSysNotification(where: $where) {
    ...SysNotification
  }
}
    ${exports.SysNotification}`;
exports.findManySysNotification = (0, graphql_tag_1.default) `
    query findManySysNotification($where: SysNotificationWhereInput, $orderBy: [SysNotificationOrderByWithRelationInput!], $cursor: SysNotificationWhereUniqueInput, $skip: Int, $take: Int) {
  findManySysNotification(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SysNotification
  }
}
    ${exports.SysNotification}`;
exports.findManySysNotificationCount = (0, graphql_tag_1.default) `
    query findManySysNotificationCount($where: SysNotificationWhereInput, $orderBy: [SysNotificationOrderByWithRelationInput!], $cursor: SysNotificationWhereUniqueInput, $skip: Int, $take: Int) {
  findManySysNotificationCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSysNotification = (0, graphql_tag_1.default) `
    mutation createOneSysNotification($data: SysNotificationCreateInput!) {
  createOneSysNotification(data: $data) {
    ...SysNotification
  }
}
    ${exports.SysNotification}`;
exports.updateOneSysNotification = (0, graphql_tag_1.default) `
    mutation updateOneSysNotification($where: SysNotificationWhereUniqueInput!, $data: SysNotificationUpdateInput!) {
  updateOneSysNotification(where: $where, data: $data) {
    ...SysNotification
  }
}
    ${exports.SysNotification}`;
exports.deleteOneSysNotification = (0, graphql_tag_1.default) `
    mutation deleteOneSysNotification($where: SysNotificationWhereUniqueInput!) {
  deleteOneSysNotification(where: $where) {
    ...SysNotification
  }
}
    ${exports.SysNotification}`;
exports.deleteManySysNotification = (0, graphql_tag_1.default) `
    mutation deleteManySysNotification($where: SysNotificationWhereInput) {
  deleteManySysNotification(where: $where) {
    count
  }
}
    `;
exports.updateManySysNotification = (0, graphql_tag_1.default) `
    mutation updateManySysNotification($where: SysNotificationWhereInput, $data: SysNotificationUpdateManyMutationInput!) {
  updateManySysNotification(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueSysPicture = (0, graphql_tag_1.default) `
    query findUniqueSysPicture($where: SysPictureWhereUniqueInput!) {
  findUniqueSysPicture(where: $where) {
    ...SysPicture
  }
}
    ${exports.SysPicture}`;
exports.findManySysPicture = (0, graphql_tag_1.default) `
    query findManySysPicture($where: SysPictureWhereInput, $orderBy: [SysPictureOrderByWithRelationInput!], $cursor: SysPictureWhereUniqueInput, $skip: Int, $take: Int) {
  findManySysPicture(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...SysPicture
  }
}
    ${exports.SysPicture}`;
exports.findManySysPictureCount = (0, graphql_tag_1.default) `
    query findManySysPictureCount($where: SysPictureWhereInput, $orderBy: [SysPictureOrderByWithRelationInput!], $cursor: SysPictureWhereUniqueInput, $skip: Int, $take: Int) {
  findManySysPictureCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneSysPicture = (0, graphql_tag_1.default) `
    mutation createOneSysPicture($data: SysPictureCreateInput!) {
  createOneSysPicture(data: $data) {
    ...SysPicture
  }
}
    ${exports.SysPicture}`;
exports.updateOneSysPicture = (0, graphql_tag_1.default) `
    mutation updateOneSysPicture($where: SysPictureWhereUniqueInput!, $data: SysPictureUpdateInput!) {
  updateOneSysPicture(where: $where, data: $data) {
    ...SysPicture
  }
}
    ${exports.SysPicture}`;
exports.deleteOneSysPicture = (0, graphql_tag_1.default) `
    mutation deleteOneSysPicture($where: SysPictureWhereUniqueInput!) {
  deleteOneSysPicture(where: $where) {
    ...SysPicture
  }
}
    ${exports.SysPicture}`;
exports.deleteManySysPicture = (0, graphql_tag_1.default) `
    mutation deleteManySysPicture($where: SysPictureWhereInput) {
  deleteManySysPicture(where: $where) {
    count
  }
}
    `;
exports.updateManySysPicture = (0, graphql_tag_1.default) `
    mutation updateManySysPicture($where: SysPictureWhereInput, $data: SysPictureUpdateManyMutationInput!) {
  updateManySysPicture(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueThumbnail = (0, graphql_tag_1.default) `
    query findUniqueThumbnail($where: ThumbnailWhereUniqueInput!) {
  findUniqueThumbnail(where: $where) {
    ...Thumbnail
  }
}
    ${exports.Thumbnail}`;
exports.findManyThumbnail = (0, graphql_tag_1.default) `
    query findManyThumbnail($where: ThumbnailWhereInput, $orderBy: [ThumbnailOrderByWithRelationInput!], $cursor: ThumbnailWhereUniqueInput, $skip: Int, $take: Int) {
  findManyThumbnail(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...Thumbnail
  }
}
    ${exports.Thumbnail}`;
exports.findManyThumbnailCount = (0, graphql_tag_1.default) `
    query findManyThumbnailCount($where: ThumbnailWhereInput, $orderBy: [ThumbnailOrderByWithRelationInput!], $cursor: ThumbnailWhereUniqueInput, $skip: Int, $take: Int) {
  findManyThumbnailCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneThumbnail = (0, graphql_tag_1.default) `
    mutation createOneThumbnail($data: ThumbnailCreateInput!) {
  createOneThumbnail(data: $data) {
    ...Thumbnail
  }
}
    ${exports.Thumbnail}`;
exports.updateOneThumbnail = (0, graphql_tag_1.default) `
    mutation updateOneThumbnail($where: ThumbnailWhereUniqueInput!, $data: ThumbnailUpdateInput!) {
  updateOneThumbnail(where: $where, data: $data) {
    ...Thumbnail
  }
}
    ${exports.Thumbnail}`;
exports.deleteOneThumbnail = (0, graphql_tag_1.default) `
    mutation deleteOneThumbnail($where: ThumbnailWhereUniqueInput!) {
  deleteOneThumbnail(where: $where) {
    ...Thumbnail
  }
}
    ${exports.Thumbnail}`;
exports.deleteManyThumbnail = (0, graphql_tag_1.default) `
    mutation deleteManyThumbnail($where: ThumbnailWhereInput) {
  deleteManyThumbnail(where: $where) {
    count
  }
}
    `;
exports.updateManyThumbnail = (0, graphql_tag_1.default) `
    mutation updateManyThumbnail($where: ThumbnailWhereInput, $data: ThumbnailUpdateManyMutationInput!) {
  updateManyThumbnail(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUrlMetadata = (0, graphql_tag_1.default) `
    query findUniqueUrlMetadata($where: UrlMetadataWhereUniqueInput!) {
  findUniqueUrlMetadata(where: $where) {
    ...UrlMetadata
  }
}
    ${exports.UrlMetadata}`;
exports.findManyUrlMetadata = (0, graphql_tag_1.default) `
    query findManyUrlMetadata($where: UrlMetadataWhereInput, $orderBy: [UrlMetadataOrderByWithRelationInput!], $cursor: UrlMetadataWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUrlMetadata(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UrlMetadata
  }
}
    ${exports.UrlMetadata}`;
exports.findManyUrlMetadataCount = (0, graphql_tag_1.default) `
    query findManyUrlMetadataCount($where: UrlMetadataWhereInput, $orderBy: [UrlMetadataOrderByWithRelationInput!], $cursor: UrlMetadataWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUrlMetadataCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUrlMetadata = (0, graphql_tag_1.default) `
    mutation createOneUrlMetadata($data: UrlMetadataCreateInput!) {
  createOneUrlMetadata(data: $data) {
    ...UrlMetadata
  }
}
    ${exports.UrlMetadata}`;
exports.updateOneUrlMetadata = (0, graphql_tag_1.default) `
    mutation updateOneUrlMetadata($where: UrlMetadataWhereUniqueInput!, $data: UrlMetadataUpdateInput!) {
  updateOneUrlMetadata(where: $where, data: $data) {
    ...UrlMetadata
  }
}
    ${exports.UrlMetadata}`;
exports.deleteOneUrlMetadata = (0, graphql_tag_1.default) `
    mutation deleteOneUrlMetadata($where: UrlMetadataWhereUniqueInput!) {
  deleteOneUrlMetadata(where: $where) {
    ...UrlMetadata
  }
}
    ${exports.UrlMetadata}`;
exports.deleteManyUrlMetadata = (0, graphql_tag_1.default) `
    mutation deleteManyUrlMetadata($where: UrlMetadataWhereInput) {
  deleteManyUrlMetadata(where: $where) {
    count
  }
}
    `;
exports.updateManyUrlMetadata = (0, graphql_tag_1.default) `
    mutation updateManyUrlMetadata($where: UrlMetadataWhereInput, $data: UrlMetadataUpdateManyMutationInput!) {
  updateManyUrlMetadata(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUser = (0, graphql_tag_1.default) `
    query findUniqueUser($where: UserWhereUniqueInput!) {
  findUniqueUser(where: $where) {
    ...User
  }
}
    ${exports.User}`;
exports.findManyUser = (0, graphql_tag_1.default) `
    query findManyUser($where: UserWhereInput, $orderBy: [UserOrderByWithRelationInput!], $cursor: UserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUser(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...User
  }
}
    ${exports.User}`;
exports.findManyUserCount = (0, graphql_tag_1.default) `
    query findManyUserCount($where: UserWhereInput, $orderBy: [UserOrderByWithRelationInput!], $cursor: UserWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUser = (0, graphql_tag_1.default) `
    mutation createOneUser($data: UserCreateInput!) {
  createOneUser(data: $data) {
    ...User
  }
}
    ${exports.User}`;
exports.updateOneUser = (0, graphql_tag_1.default) `
    mutation updateOneUser($where: UserWhereUniqueInput!, $data: UserUpdateInput!) {
  updateOneUser(where: $where, data: $data) {
    ...User
  }
}
    ${exports.User}`;
exports.deleteOneUser = (0, graphql_tag_1.default) `
    mutation deleteOneUser($where: UserWhereUniqueInput!) {
  deleteOneUser(where: $where) {
    ...User
  }
}
    ${exports.User}`;
exports.deleteManyUser = (0, graphql_tag_1.default) `
    mutation deleteManyUser($where: UserWhereInput) {
  deleteManyUser(where: $where) {
    count
  }
}
    `;
exports.updateManyUser = (0, graphql_tag_1.default) `
    mutation updateManyUser($where: UserWhereInput, $data: UserUpdateManyMutationInput!) {
  updateManyUser(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserAdAction = (0, graphql_tag_1.default) `
    query findUniqueUserAdAction($where: UserAdActionWhereUniqueInput!) {
  findUniqueUserAdAction(where: $where) {
    ...UserAdAction
  }
}
    ${exports.UserAdAction}`;
exports.findManyUserAdAction = (0, graphql_tag_1.default) `
    query findManyUserAdAction($where: UserAdActionWhereInput, $orderBy: [UserAdActionOrderByWithRelationInput!], $cursor: UserAdActionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserAdAction(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserAdAction
  }
}
    ${exports.UserAdAction}`;
exports.findManyUserAdActionCount = (0, graphql_tag_1.default) `
    query findManyUserAdActionCount($where: UserAdActionWhereInput, $orderBy: [UserAdActionOrderByWithRelationInput!], $cursor: UserAdActionWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserAdActionCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserAdAction = (0, graphql_tag_1.default) `
    mutation createOneUserAdAction($data: UserAdActionCreateInput!) {
  createOneUserAdAction(data: $data) {
    ...UserAdAction
  }
}
    ${exports.UserAdAction}`;
exports.updateOneUserAdAction = (0, graphql_tag_1.default) `
    mutation updateOneUserAdAction($where: UserAdActionWhereUniqueInput!, $data: UserAdActionUpdateInput!) {
  updateOneUserAdAction(where: $where, data: $data) {
    ...UserAdAction
  }
}
    ${exports.UserAdAction}`;
exports.deleteOneUserAdAction = (0, graphql_tag_1.default) `
    mutation deleteOneUserAdAction($where: UserAdActionWhereUniqueInput!) {
  deleteOneUserAdAction(where: $where) {
    ...UserAdAction
  }
}
    ${exports.UserAdAction}`;
exports.deleteManyUserAdAction = (0, graphql_tag_1.default) `
    mutation deleteManyUserAdAction($where: UserAdActionWhereInput) {
  deleteManyUserAdAction(where: $where) {
    count
  }
}
    `;
exports.updateManyUserAdAction = (0, graphql_tag_1.default) `
    mutation updateManyUserAdAction($where: UserAdActionWhereInput, $data: UserAdActionUpdateManyMutationInput!) {
  updateManyUserAdAction(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserBlocking = (0, graphql_tag_1.default) `
    query findUniqueUserBlocking($where: UserBlockingWhereUniqueInput!) {
  findUniqueUserBlocking(where: $where) {
    ...UserBlocking
  }
}
    ${exports.UserBlocking}`;
exports.findManyUserBlocking = (0, graphql_tag_1.default) `
    query findManyUserBlocking($where: UserBlockingWhereInput, $orderBy: [UserBlockingOrderByWithRelationInput!], $cursor: UserBlockingWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserBlocking(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserBlocking
  }
}
    ${exports.UserBlocking}`;
exports.findManyUserBlockingCount = (0, graphql_tag_1.default) `
    query findManyUserBlockingCount($where: UserBlockingWhereInput, $orderBy: [UserBlockingOrderByWithRelationInput!], $cursor: UserBlockingWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserBlockingCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserBlocking = (0, graphql_tag_1.default) `
    mutation createOneUserBlocking($data: UserBlockingCreateInput!) {
  createOneUserBlocking(data: $data) {
    ...UserBlocking
  }
}
    ${exports.UserBlocking}`;
exports.updateOneUserBlocking = (0, graphql_tag_1.default) `
    mutation updateOneUserBlocking($where: UserBlockingWhereUniqueInput!, $data: UserBlockingUpdateInput!) {
  updateOneUserBlocking(where: $where, data: $data) {
    ...UserBlocking
  }
}
    ${exports.UserBlocking}`;
exports.deleteOneUserBlocking = (0, graphql_tag_1.default) `
    mutation deleteOneUserBlocking($where: UserBlockingWhereUniqueInput!) {
  deleteOneUserBlocking(where: $where) {
    ...UserBlocking
  }
}
    ${exports.UserBlocking}`;
exports.deleteManyUserBlocking = (0, graphql_tag_1.default) `
    mutation deleteManyUserBlocking($where: UserBlockingWhereInput) {
  deleteManyUserBlocking(where: $where) {
    count
  }
}
    `;
exports.updateManyUserBlocking = (0, graphql_tag_1.default) `
    mutation updateManyUserBlocking($where: UserBlockingWhereInput, $data: UserBlockingUpdateManyMutationInput!) {
  updateManyUserBlocking(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserChannelAccount = (0, graphql_tag_1.default) `
    query findUniqueUserChannelAccount($where: UserChannelAccountWhereUniqueInput!) {
  findUniqueUserChannelAccount(where: $where) {
    ...UserChannelAccount
  }
}
    ${exports.UserChannelAccount}`;
exports.findManyUserChannelAccount = (0, graphql_tag_1.default) `
    query findManyUserChannelAccount($where: UserChannelAccountWhereInput, $orderBy: [UserChannelAccountOrderByWithRelationInput!], $cursor: UserChannelAccountWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserChannelAccount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserChannelAccount
  }
}
    ${exports.UserChannelAccount}`;
exports.findManyUserChannelAccountCount = (0, graphql_tag_1.default) `
    query findManyUserChannelAccountCount($where: UserChannelAccountWhereInput, $orderBy: [UserChannelAccountOrderByWithRelationInput!], $cursor: UserChannelAccountWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserChannelAccountCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserChannelAccount = (0, graphql_tag_1.default) `
    mutation createOneUserChannelAccount($data: UserChannelAccountCreateInput!) {
  createOneUserChannelAccount(data: $data) {
    ...UserChannelAccount
  }
}
    ${exports.UserChannelAccount}`;
exports.updateOneUserChannelAccount = (0, graphql_tag_1.default) `
    mutation updateOneUserChannelAccount($where: UserChannelAccountWhereUniqueInput!, $data: UserChannelAccountUpdateInput!) {
  updateOneUserChannelAccount(where: $where, data: $data) {
    ...UserChannelAccount
  }
}
    ${exports.UserChannelAccount}`;
exports.deleteOneUserChannelAccount = (0, graphql_tag_1.default) `
    mutation deleteOneUserChannelAccount($where: UserChannelAccountWhereUniqueInput!) {
  deleteOneUserChannelAccount(where: $where) {
    ...UserChannelAccount
  }
}
    ${exports.UserChannelAccount}`;
exports.deleteManyUserChannelAccount = (0, graphql_tag_1.default) `
    mutation deleteManyUserChannelAccount($where: UserChannelAccountWhereInput) {
  deleteManyUserChannelAccount(where: $where) {
    count
  }
}
    `;
exports.updateManyUserChannelAccount = (0, graphql_tag_1.default) `
    mutation updateManyUserChannelAccount($where: UserChannelAccountWhereInput, $data: UserChannelAccountUpdateManyMutationInput!) {
  updateManyUserChannelAccount(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserIdentity = (0, graphql_tag_1.default) `
    query findUniqueUserIdentity($where: UserIdentityWhereUniqueInput!) {
  findUniqueUserIdentity(where: $where) {
    ...UserIdentity
  }
}
    ${exports.UserIdentity}`;
exports.findManyUserIdentityCount = (0, graphql_tag_1.default) `
    query findManyUserIdentityCount($where: UserIdentityWhereInput, $orderBy: [UserIdentityOrderByWithRelationInput!], $cursor: UserIdentityWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserIdentityCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.findUniqueUserKeyword = (0, graphql_tag_1.default) `
    query findUniqueUserKeyword($where: UserKeywordWhereUniqueInput!) {
  findUniqueUserKeyword(where: $where) {
    ...UserKeyword
  }
}
    ${exports.UserKeyword}`;
exports.findManyUserKeyword = (0, graphql_tag_1.default) `
    query findManyUserKeyword($where: UserKeywordWhereInput, $orderBy: [UserKeywordOrderByWithRelationInput!], $cursor: UserKeywordWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserKeyword(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserKeyword
  }
}
    ${exports.UserKeyword}`;
exports.findManyUserKeywordCount = (0, graphql_tag_1.default) `
    query findManyUserKeywordCount($where: UserKeywordWhereInput, $orderBy: [UserKeywordOrderByWithRelationInput!], $cursor: UserKeywordWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserKeywordCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserKeyword = (0, graphql_tag_1.default) `
    mutation createOneUserKeyword($data: UserKeywordCreateInput!) {
  createOneUserKeyword(data: $data) {
    ...UserKeyword
  }
}
    ${exports.UserKeyword}`;
exports.updateOneUserKeyword = (0, graphql_tag_1.default) `
    mutation updateOneUserKeyword($where: UserKeywordWhereUniqueInput!, $data: UserKeywordUpdateInput!) {
  updateOneUserKeyword(where: $where, data: $data) {
    ...UserKeyword
  }
}
    ${exports.UserKeyword}`;
exports.deleteOneUserKeyword = (0, graphql_tag_1.default) `
    mutation deleteOneUserKeyword($where: UserKeywordWhereUniqueInput!) {
  deleteOneUserKeyword(where: $where) {
    ...UserKeyword
  }
}
    ${exports.UserKeyword}`;
exports.deleteManyUserKeyword = (0, graphql_tag_1.default) `
    mutation deleteManyUserKeyword($where: UserKeywordWhereInput) {
  deleteManyUserKeyword(where: $where) {
    count
  }
}
    `;
exports.updateManyUserKeyword = (0, graphql_tag_1.default) `
    mutation updateManyUserKeyword($where: UserKeywordWhereInput, $data: UserKeywordUpdateManyMutationInput!) {
  updateManyUserKeyword(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserLog = (0, graphql_tag_1.default) `
    query findUniqueUserLog($where: UserLogWhereUniqueInput!) {
  findUniqueUserLog(where: $where) {
    ...UserLog
  }
}
    ${exports.UserLog}`;
exports.findManyUserLog = (0, graphql_tag_1.default) `
    query findManyUserLog($where: UserLogWhereInput, $orderBy: [UserLogOrderByWithRelationInput!], $cursor: UserLogWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserLog(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserLog
  }
}
    ${exports.UserLog}`;
exports.findManyUserLogCount = (0, graphql_tag_1.default) `
    query findManyUserLogCount($where: UserLogWhereInput, $orderBy: [UserLogOrderByWithRelationInput!], $cursor: UserLogWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserLogCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserLog = (0, graphql_tag_1.default) `
    mutation createOneUserLog($data: UserLogCreateInput!) {
  createOneUserLog(data: $data) {
    ...UserLog
  }
}
    ${exports.UserLog}`;
exports.updateOneUserLog = (0, graphql_tag_1.default) `
    mutation updateOneUserLog($where: UserLogWhereUniqueInput!, $data: UserLogUpdateInput!) {
  updateOneUserLog(where: $where, data: $data) {
    ...UserLog
  }
}
    ${exports.UserLog}`;
exports.deleteOneUserLog = (0, graphql_tag_1.default) `
    mutation deleteOneUserLog($where: UserLogWhereUniqueInput!) {
  deleteOneUserLog(where: $where) {
    ...UserLog
  }
}
    ${exports.UserLog}`;
exports.deleteManyUserLog = (0, graphql_tag_1.default) `
    mutation deleteManyUserLog($where: UserLogWhereInput) {
  deleteManyUserLog(where: $where) {
    count
  }
}
    `;
exports.updateManyUserLog = (0, graphql_tag_1.default) `
    mutation updateManyUserLog($where: UserLogWhereInput, $data: UserLogUpdateManyMutationInput!) {
  updateManyUserLog(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserPenalty = (0, graphql_tag_1.default) `
    query findUniqueUserPenalty($where: UserPenaltyWhereUniqueInput!) {
  findUniqueUserPenalty(where: $where) {
    ...UserPenalty
  }
}
    ${exports.UserPenalty}`;
exports.findManyUserPenalty = (0, graphql_tag_1.default) `
    query findManyUserPenalty($where: UserPenaltyWhereInput, $orderBy: [UserPenaltyOrderByWithRelationInput!], $cursor: UserPenaltyWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserPenalty(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserPenalty
  }
}
    ${exports.UserPenalty}`;
exports.findManyUserPenaltyCount = (0, graphql_tag_1.default) `
    query findManyUserPenaltyCount($where: UserPenaltyWhereInput, $orderBy: [UserPenaltyOrderByWithRelationInput!], $cursor: UserPenaltyWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserPenaltyCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserPenalty = (0, graphql_tag_1.default) `
    mutation createOneUserPenalty($data: UserPenaltyCreateInput!) {
  createOneUserPenalty(data: $data) {
    ...UserPenalty
  }
}
    ${exports.UserPenalty}`;
exports.updateOneUserPenalty = (0, graphql_tag_1.default) `
    mutation updateOneUserPenalty($where: UserPenaltyWhereUniqueInput!, $data: UserPenaltyUpdateInput!) {
  updateOneUserPenalty(where: $where, data: $data) {
    ...UserPenalty
  }
}
    ${exports.UserPenalty}`;
exports.deleteOneUserPenalty = (0, graphql_tag_1.default) `
    mutation deleteOneUserPenalty($where: UserPenaltyWhereUniqueInput!) {
  deleteOneUserPenalty(where: $where) {
    ...UserPenalty
  }
}
    ${exports.UserPenalty}`;
exports.deleteManyUserPenalty = (0, graphql_tag_1.default) `
    mutation deleteManyUserPenalty($where: UserPenaltyWhereInput) {
  deleteManyUserPenalty(where: $where) {
    count
  }
}
    `;
exports.updateManyUserPenalty = (0, graphql_tag_1.default) `
    mutation updateManyUserPenalty($where: UserPenaltyWhereInput, $data: UserPenaltyUpdateManyMutationInput!) {
  updateManyUserPenalty(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserPointLog = (0, graphql_tag_1.default) `
    query findUniqueUserPointLog($where: UserPointLogWhereUniqueInput!) {
  findUniqueUserPointLog(where: $where) {
    ...UserPointLog
  }
}
    ${exports.UserPointLog}`;
exports.findManyUserPointLog = (0, graphql_tag_1.default) `
    query findManyUserPointLog($where: UserPointLogWhereInput, $orderBy: [UserPointLogOrderByWithRelationInput!], $cursor: UserPointLogWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserPointLog(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserPointLog
  }
}
    ${exports.UserPointLog}`;
exports.findManyUserPointLogCount = (0, graphql_tag_1.default) `
    query findManyUserPointLogCount($where: UserPointLogWhereInput, $orderBy: [UserPointLogOrderByWithRelationInput!], $cursor: UserPointLogWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserPointLogCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserPointLog = (0, graphql_tag_1.default) `
    mutation createOneUserPointLog($data: UserPointLogCreateInput!) {
  createOneUserPointLog(data: $data) {
    ...UserPointLog
  }
}
    ${exports.UserPointLog}`;
exports.updateOneUserPointLog = (0, graphql_tag_1.default) `
    mutation updateOneUserPointLog($where: UserPointLogWhereUniqueInput!, $data: UserPointLogUpdateInput!) {
  updateOneUserPointLog(where: $where, data: $data) {
    ...UserPointLog
  }
}
    ${exports.UserPointLog}`;
exports.deleteOneUserPointLog = (0, graphql_tag_1.default) `
    mutation deleteOneUserPointLog($where: UserPointLogWhereUniqueInput!) {
  deleteOneUserPointLog(where: $where) {
    ...UserPointLog
  }
}
    ${exports.UserPointLog}`;
exports.deleteManyUserPointLog = (0, graphql_tag_1.default) `
    mutation deleteManyUserPointLog($where: UserPointLogWhereInput) {
  deleteManyUserPointLog(where: $where) {
    count
  }
}
    `;
exports.updateManyUserPointLog = (0, graphql_tag_1.default) `
    mutation updateManyUserPointLog($where: UserPointLogWhereInput, $data: UserPointLogUpdateManyMutationInput!) {
  updateManyUserPointLog(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserPointWithdrawRequest = (0, graphql_tag_1.default) `
    query findUniqueUserPointWithdrawRequest($where: UserPointWithdrawRequestWhereUniqueInput!) {
  findUniqueUserPointWithdrawRequest(where: $where) {
    ...UserPointWithdrawRequest
  }
}
    ${exports.UserPointWithdrawRequest}`;
exports.findManyUserPointWithdrawRequest = (0, graphql_tag_1.default) `
    query findManyUserPointWithdrawRequest($where: UserPointWithdrawRequestWhereInput, $orderBy: [UserPointWithdrawRequestOrderByWithRelationInput!], $cursor: UserPointWithdrawRequestWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserPointWithdrawRequest(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserPointWithdrawRequest
  }
}
    ${exports.UserPointWithdrawRequest}`;
exports.findManyUserPointWithdrawRequestCount = (0, graphql_tag_1.default) `
    query findManyUserPointWithdrawRequestCount($where: UserPointWithdrawRequestWhereInput, $orderBy: [UserPointWithdrawRequestOrderByWithRelationInput!], $cursor: UserPointWithdrawRequestWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserPointWithdrawRequestCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserPointWithdrawRequest = (0, graphql_tag_1.default) `
    mutation createOneUserPointWithdrawRequest($data: UserPointWithdrawRequestCreateInput!) {
  createOneUserPointWithdrawRequest(data: $data) {
    ...UserPointWithdrawRequest
  }
}
    ${exports.UserPointWithdrawRequest}`;
exports.updateOneUserPointWithdrawRequest = (0, graphql_tag_1.default) `
    mutation updateOneUserPointWithdrawRequest($where: UserPointWithdrawRequestWhereUniqueInput!, $data: UserPointWithdrawRequestUpdateInput!) {
  updateOneUserPointWithdrawRequest(where: $where, data: $data) {
    ...UserPointWithdrawRequest
  }
}
    ${exports.UserPointWithdrawRequest}`;
exports.deleteOneUserPointWithdrawRequest = (0, graphql_tag_1.default) `
    mutation deleteOneUserPointWithdrawRequest($where: UserPointWithdrawRequestWhereUniqueInput!) {
  deleteOneUserPointWithdrawRequest(where: $where) {
    ...UserPointWithdrawRequest
  }
}
    ${exports.UserPointWithdrawRequest}`;
exports.deleteManyUserPointWithdrawRequest = (0, graphql_tag_1.default) `
    mutation deleteManyUserPointWithdrawRequest($where: UserPointWithdrawRequestWhereInput) {
  deleteManyUserPointWithdrawRequest(where: $where) {
    count
  }
}
    `;
exports.updateManyUserPointWithdrawRequest = (0, graphql_tag_1.default) `
    mutation updateManyUserPointWithdrawRequest($where: UserPointWithdrawRequestWhereInput, $data: UserPointWithdrawRequestUpdateManyMutationInput!) {
  updateManyUserPointWithdrawRequest(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUserUsage = (0, graphql_tag_1.default) `
    query findUniqueUserUsage($where: UserUsageWhereUniqueInput!) {
  findUniqueUserUsage(where: $where) {
    ...UserUsage
  }
}
    ${exports.UserUsage}`;
exports.findManyUserUsage = (0, graphql_tag_1.default) `
    query findManyUserUsage($where: UserUsageWhereInput, $orderBy: [UserUsageOrderByWithRelationInput!], $cursor: UserUsageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserUsage(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...UserUsage
  }
}
    ${exports.UserUsage}`;
exports.findManyUserUsageCount = (0, graphql_tag_1.default) `
    query findManyUserUsageCount($where: UserUsageWhereInput, $orderBy: [UserUsageOrderByWithRelationInput!], $cursor: UserUsageWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUserUsageCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUserUsage = (0, graphql_tag_1.default) `
    mutation createOneUserUsage($data: UserUsageCreateInput!) {
  createOneUserUsage(data: $data) {
    ...UserUsage
  }
}
    ${exports.UserUsage}`;
exports.updateOneUserUsage = (0, graphql_tag_1.default) `
    mutation updateOneUserUsage($where: UserUsageWhereUniqueInput!, $data: UserUsageUpdateInput!) {
  updateOneUserUsage(where: $where, data: $data) {
    ...UserUsage
  }
}
    ${exports.UserUsage}`;
exports.deleteOneUserUsage = (0, graphql_tag_1.default) `
    mutation deleteOneUserUsage($where: UserUsageWhereUniqueInput!) {
  deleteOneUserUsage(where: $where) {
    ...UserUsage
  }
}
    ${exports.UserUsage}`;
exports.deleteManyUserUsage = (0, graphql_tag_1.default) `
    mutation deleteManyUserUsage($where: UserUsageWhereInput) {
  deleteManyUserUsage(where: $where) {
    count
  }
}
    `;
exports.updateManyUserUsage = (0, graphql_tag_1.default) `
    mutation updateManyUserUsage($where: UserUsageWhereInput, $data: UserUsageUpdateManyMutationInput!) {
  updateManyUserUsage(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUser_ChatRoomView = (0, graphql_tag_1.default) `
    query findUniqueUser_ChatRoomView($where: User_ChatRoomViewWhereUniqueInput!) {
  findUniqueUser_ChatRoomView(where: $where) {
    ...User_ChatRoomView
  }
}
    ${exports.User_ChatRoomView}`;
exports.findManyUser_ChatRoomView = (0, graphql_tag_1.default) `
    query findManyUser_ChatRoomView($where: User_ChatRoomViewWhereInput, $orderBy: [User_ChatRoomViewOrderByWithRelationInput!], $cursor: User_ChatRoomViewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUser_ChatRoomView(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...User_ChatRoomView
  }
}
    ${exports.User_ChatRoomView}`;
exports.findManyUser_ChatRoomViewCount = (0, graphql_tag_1.default) `
    query findManyUser_ChatRoomViewCount($where: User_ChatRoomViewWhereInput, $orderBy: [User_ChatRoomViewOrderByWithRelationInput!], $cursor: User_ChatRoomViewWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUser_ChatRoomViewCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUser_ChatRoomView = (0, graphql_tag_1.default) `
    mutation createOneUser_ChatRoomView($data: User_ChatRoomViewCreateInput!) {
  createOneUser_ChatRoomView(data: $data) {
    ...User_ChatRoomView
  }
}
    ${exports.User_ChatRoomView}`;
exports.updateOneUser_ChatRoomView = (0, graphql_tag_1.default) `
    mutation updateOneUser_ChatRoomView($where: User_ChatRoomViewWhereUniqueInput!, $data: User_ChatRoomViewUpdateInput!) {
  updateOneUser_ChatRoomView(where: $where, data: $data) {
    ...User_ChatRoomView
  }
}
    ${exports.User_ChatRoomView}`;
exports.deleteOneUser_ChatRoomView = (0, graphql_tag_1.default) `
    mutation deleteOneUser_ChatRoomView($where: User_ChatRoomViewWhereUniqueInput!) {
  deleteOneUser_ChatRoomView(where: $where) {
    ...User_ChatRoomView
  }
}
    ${exports.User_ChatRoomView}`;
exports.deleteManyUser_ChatRoomView = (0, graphql_tag_1.default) `
    mutation deleteManyUser_ChatRoomView($where: User_ChatRoomViewWhereInput) {
  deleteManyUser_ChatRoomView(where: $where) {
    count
  }
}
    `;
exports.updateManyUser_ChatRoomView = (0, graphql_tag_1.default) `
    mutation updateManyUser_ChatRoomView($where: User_ChatRoomViewWhereInput, $data: User_ChatRoomViewUpdateManyMutationInput!) {
  updateManyUser_ChatRoomView(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueUser_Profile = (0, graphql_tag_1.default) `
    query findUniqueUser_Profile($where: User_ProfileWhereUniqueInput!) {
  findUniqueUser_Profile(where: $where) {
    ...User_Profile
  }
}
    ${exports.User_Profile}`;
exports.findManyUser_Profile = (0, graphql_tag_1.default) `
    query findManyUser_Profile($where: User_ProfileWhereInput, $orderBy: [User_ProfileOrderByWithRelationInput!], $cursor: User_ProfileWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUser_Profile(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...User_Profile
  }
}
    ${exports.User_Profile}`;
exports.findManyUser_ProfileCount = (0, graphql_tag_1.default) `
    query findManyUser_ProfileCount($where: User_ProfileWhereInput, $orderBy: [User_ProfileOrderByWithRelationInput!], $cursor: User_ProfileWhereUniqueInput, $skip: Int, $take: Int) {
  findManyUser_ProfileCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneUser_Profile = (0, graphql_tag_1.default) `
    mutation createOneUser_Profile($data: User_ProfileCreateInput!) {
  createOneUser_Profile(data: $data) {
    ...User_Profile
  }
}
    ${exports.User_Profile}`;
exports.updateOneUser_Profile = (0, graphql_tag_1.default) `
    mutation updateOneUser_Profile($where: User_ProfileWhereUniqueInput!, $data: User_ProfileUpdateInput!) {
  updateOneUser_Profile(where: $where, data: $data) {
    ...User_Profile
  }
}
    ${exports.User_Profile}`;
exports.deleteOneUser_Profile = (0, graphql_tag_1.default) `
    mutation deleteOneUser_Profile($where: User_ProfileWhereUniqueInput!) {
  deleteOneUser_Profile(where: $where) {
    ...User_Profile
  }
}
    ${exports.User_Profile}`;
exports.deleteManyUser_Profile = (0, graphql_tag_1.default) `
    mutation deleteManyUser_Profile($where: User_ProfileWhereInput) {
  deleteManyUser_Profile(where: $where) {
    count
  }
}
    `;
exports.updateManyUser_Profile = (0, graphql_tag_1.default) `
    mutation updateManyUser_Profile($where: User_ProfileWhereInput, $data: User_ProfileUpdateManyMutationInput!) {
  updateManyUser_Profile(where: $where, data: $data) {
    count
  }
}
    `;
exports.findUniqueVersionChange = (0, graphql_tag_1.default) `
    query findUniqueVersionChange($where: VersionChangeWhereUniqueInput!) {
  findUniqueVersionChange(where: $where) {
    ...VersionChange
  }
}
    ${exports.VersionChange}`;
exports.findManyVersionChange = (0, graphql_tag_1.default) `
    query findManyVersionChange($where: VersionChangeWhereInput, $orderBy: [VersionChangeOrderByWithRelationInput!], $cursor: VersionChangeWhereUniqueInput, $skip: Int, $take: Int) {
  findManyVersionChange(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  ) {
    ...VersionChange
  }
}
    ${exports.VersionChange}`;
exports.findManyVersionChangeCount = (0, graphql_tag_1.default) `
    query findManyVersionChangeCount($where: VersionChangeWhereInput, $orderBy: [VersionChangeOrderByWithRelationInput!], $cursor: VersionChangeWhereUniqueInput, $skip: Int, $take: Int) {
  findManyVersionChangeCount(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    skip: $skip
    take: $take
  )
}
    `;
exports.createOneVersionChange = (0, graphql_tag_1.default) `
    mutation createOneVersionChange($data: VersionChangeCreateInput!) {
  createOneVersionChange(data: $data) {
    ...VersionChange
  }
}
    ${exports.VersionChange}`;
exports.updateOneVersionChange = (0, graphql_tag_1.default) `
    mutation updateOneVersionChange($where: VersionChangeWhereUniqueInput!, $data: VersionChangeUpdateInput!) {
  updateOneVersionChange(where: $where, data: $data) {
    ...VersionChange
  }
}
    ${exports.VersionChange}`;
exports.deleteOneVersionChange = (0, graphql_tag_1.default) `
    mutation deleteOneVersionChange($where: VersionChangeWhereUniqueInput!) {
  deleteOneVersionChange(where: $where) {
    ...VersionChange
  }
}
    ${exports.VersionChange}`;
exports.deleteManyVersionChange = (0, graphql_tag_1.default) `
    mutation deleteManyVersionChange($where: VersionChangeWhereInput) {
  deleteManyVersionChange(where: $where) {
    count
  }
}
    `;
exports.updateManyVersionChange = (0, graphql_tag_1.default) `
    mutation updateManyVersionChange($where: VersionChangeWhereInput, $data: VersionChangeUpdateManyMutationInput!) {
  updateManyVersionChange(where: $where, data: $data) {
    count
  }
}
    `;
